(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[873],{

/***/ 4419:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/column-off.0bce7b86.svg","height":17,"width":17});

/***/ }),

/***/ 84923:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/column-on.df541de7.svg","height":17,"width":17});

/***/ }),

/***/ 59537:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/locator-big-chacrol.dc8ee673.svg","height":35,"width":26});

/***/ }),

/***/ 18146:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/locator-big-green.5d421b02.svg","height":35,"width":26});

/***/ }),

/***/ 38015:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/locator-big-red.d8da2f65.svg","height":35,"width":26});

/***/ }),

/***/ 53087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_BrowseAllStores; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var lodash_isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./src/store/features/locationSlice.js
var locationSlice = __webpack_require__(13644);
// EXTERNAL MODULE: ./src/utils/location.js
var utils_location = __webpack_require__(78800);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
;// CONCATENATED MODULE: ./i18n/useMystorei18n.js

const useMystorei18n = (param)=>{
    let { authorData  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        countryLabel: authorData.countryLabel ? authorData.countryLabel : t("kf.browseallstore.label.countryLabel"),
        toggleFilter: t("kf.browseallstore.label.toggleFilter"),
        filters: authorData.toggleFilter ? authorData.toggleFilter : t("kf.plp.label.filters"),
        applyFilters: t("kf.findstore.label.applyFilters"),
        setAsMyStore: t("kf.findStoreUtilNav.label.setAsMystore"),
        clearAll: t("kf.plp.label.clearAll"),
        home: authorData.home ? authorData.home : t("kf.browseallstore.label.home"),
        findStore: authorData.findStore ? authorData.findStore : t("kf.browseallstore.label.findStore"),
        browseAllStore: authorData.browseAllStore ? authorData.browseAllStore : t("kf.browseallstore.label.browseAllStore"),
        myStore: t("kf.findStoreUtilNav.label.myStore"),
        viewResults: t("kf.plp.label.viewResults"),
        view: t("kf.plp.label.view"),
        results: t("kf.plp.label.results"),
        ariaLabel: {
            currentPage: t("kf.pdp.label.aria.currentPage"),
            page: t("kf.pdp.label.aria.page")
        },
        noShowRoomFound: t("kf.browseallstore.label.noShowRoomFound")
    };
    return i18n;
};
/* harmony default export */ var i18n_useMystorei18n = (useMystorei18n);

// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./node_modules/react-sticky-el/lib/index.js
var lib = __webpack_require__(75198);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var dist_lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/core/Accordion/Accordion.jsx
var Accordion = __webpack_require__(1983);
// EXTERNAL MODULE: ./public/icons/filter.svg
var filter = __webpack_require__(24495);
// EXTERNAL MODULE: ./src/components/core/Checkbox/Checkbox.jsx
var Checkbox = __webpack_require__(55511);
// EXTERNAL MODULE: ./src/components/core/SelectDropdown/SelectDropdown.jsx
var SelectDropdown = __webpack_require__(14629);
;// CONCATENATED MODULE: ./components/BrowseAllStores/v1/browseStoreAnalytics.js
/**
 *
 * @param {Object} res
 * Data Layer Tech Spec 2022'
 * file: Requirement#20 Country Option Selector
 * Batch 2 - Find a Store
 */ const countryChangeDataAnalytics = (res)=>{
    const { status , message ="n/a" , value  } = res;
    const isStatus = status === 200;
    const eventInfo = {
        eventAction: "find a store:browse all stores​:country option selector",
        eventName: "find a store:browse all stores​:country option selector",
        eventType: "navigation",
        eventMsg: message === null || message === void 0 ? void 0 : message.toLowerCase(),
        eventStatus: isStatus ? "success" : "failure",
        internalLinkName: value.toLowerCase(),
        internalLinkPosition: "browse all stores​",
        internalLinkType: "find a store:country option selector",
        internalLinkZoneName: "find a store:browse all stores",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo: eventInfo,
        page: page
    });
};

// EXTERNAL MODULE: ./components/Findashowroom/Filter.jsx
var Filter = __webpack_require__(77679);
// EXTERNAL MODULE: ./src/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(18216);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var dist_es = __webpack_require__(67421);
;// CONCATENATED MODULE: ./components/BrowseAllStores/v1/BrowseAllStoresView/index.jsx



















const BrowseAllStoresView = (props)=>{
    const { countries =[] , staticTexts ={} , facets ={} , browseStoreDetails ={} , findStores , handleBrowseAllStoreCheck =()=>{} , browseAllStoreCheckedId , authorData  } = props;
    const [width] = (0,useWindowResize/* default */.Z)();
    const [showFilter, setShowFilter] = (0,react.useState)(dist_lib/* isMobile */.tq ? false : true);
    const [navSticky, setNavSticky] = (0,react.useState)(false);
    const [data, setData] = (0,react.useState)([]);
    const [countryChange, setCountryChange] = (0,react.useState)("");
    const [browseAllQuery, setBrowseAllQuery] = (0,react.useState)("");
    const [selectedFilterCount, setSelectedFilterCount] = (0,react.useState)(0);
    const [isEmpty, setIsEmpty] = (0,react.useState)(false);
    const [shortenedUrls, setShortenedUrls] = (0,react.useState)({});
    const { t  } = (0,dist_es/* useTranslation */.$G)();
    const [expanded, setExpanded] = (0,react.useState)({});
    const filterClass = classnames_default()({
        "view-all-stores__filter": true,
        "view-all-stores__filter--hide": dist_lib/* isMobile */.tq ? false : !showFilter,
        "view-all-stores__filter--modal": dist_lib/* isMobile */.tq ? showFilter : false
    });
    const storeListClass = classnames_default()({
        "view-all-stores__tile-col": true,
        "view-all-stores__tile-col--full-width": !showFilter
    });
    const locatioContainer = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        var ref, ref1;
        setCountryChange((ref = countries[0]) === null || ref === void 0 ? void 0 : ref.text);
        getAllStoreData((ref1 = countries[0]) === null || ref1 === void 0 ? void 0 : ref1.text);
    }, [
        countries
    ]);
    (0,react.useEffect)(()=>{
        getAllStoreData();
    }, [
        browseAllQuery,
        findStores
    ]);
    (0,react.useEffect)(()=>{
        Object.entries(data).sort().forEach((param)=>{
            let [district, stores] = param;
            stores.forEach((storeItem)=>{
                var _BPnumber;
                const url = (_BPnumber = browseStoreDetails[storeItem.BPnumber]) !== null && _BPnumber !== void 0 ? _BPnumber : constants.pageUrl;
                fetchShortenedUrl(url);
            });
        });
    }, [
        data,
        browseStoreDetails
    ]);
    const fetchShortenedUrl = async (url)=>{
        try {
            const shortenedUrl = await (0,helper/* getShortenedUrl */.Ppy)(url);
            setShortenedUrls((prevUrls)=>({
                    ...prevUrls,
                    [url]: shortenedUrl
                }));
        } catch (error) {
            console.error("Error occurred while fetching shortened URL:", error);
        }
    };
    const splitBrowseQuery = (queries)=>{
        setBrowseAllQuery((0,helper/* findStoreBuildQueryFromUrl */.$$z)(queries, constants.BOOLEAN_VALUE_RESPONSE));
    };
    const getAllStoreData = async (cnt)=>{
        var ref;
        const countryText = cnt || countryChange;
        const country = get_default()(countries.find((obj)=>obj.text === countryText), "value", "");
        const browseStoreItemsEle = authorData === null || authorData === void 0 ? void 0 : (ref = authorData.browseStoreItems) === null || ref === void 0 ? void 0 : ref[0];
        let finalQuery_authored;
        if (browseStoreItemsEle) {
            const { browsestorekey ="" , browsestorevalue =""  } = browseStoreItemsEle;
            let filterValue = "".concat(country == "All" ? "" : "CountryRegion Eq '" + country + "' and ", " ").concat(browsestorekey, " eq '").concat(browsestorevalue, "'");
            finalQuery_authored = browsestorekey && (!isEmpty_default()(browseAllQuery) ? "".concat(browseAllQuery) + filterValue : filterValue);
        }
        let finalQuery_default = !isEmpty_default()(browseAllQuery) ? "CountryRegion Eq '".concat(country, "' and LocationType eq 'Kohler Store' And ").concat(browseAllQuery) : "CountryRegion Eq '".concat(country, "' and LocationType eq 'Kohler Store'");
        let finalQuery = browseStoreItemsEle ? finalQuery_authored : finalQuery_default;
        const payload = {
            params: {
                $format: "json",
                brand: "annsacks",
                $filter: finalQuery
            }
        };
        try {
            if (country) {
                const { status , data ={}  } = await api/* apim.get */.TH.get(findStores, payload);
                if (status === 200) {
                    const res = data.d.results;
                    const groupedList = groupBy(res, "StateLong");
                    setSelectedFilterCount(res === null || res === void 0 ? void 0 : res.length);
                    setData(groupedList);
                    setIsEmpty(Object.entries(groupedList).length === 0);
                }
                return {
                    status
                };
            }
        } catch (error) {
            return {
                status: 400,
                message: error.message
            };
        }
    };
    const groupBy = (array, key)=>{
        return array.reduce((result, currentValue)=>{
            ;
            (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
            return result;
        }, {});
    };
    const formatPhoneNumber = (phoneNumberString)=>{
        const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return "(" + match[1] + ") " + match[2] + "-" + match[3];
        }
        return null;
    };
    const dynamicSort = (property)=>{
        const sortOrder = 1;
        return function(a, b) {
            const result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
            return result * sortOrder;
        };
    };
    const handleChange = async (value)=>{
        setCountryChange(value);
        const res = await getAllStoreData(value);
        countryChangeDataAnalytics({
            ...res,
            value
        });
    };
    const phNumberDatalayer = function(storeItem, district, isForStoreName) {
        let phoneNumber = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
        var ref, ref1, ref2;
        const page = (window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : (ref1 = ref.getState) === null || ref1 === void 0 ? void 0 : ref1.call(ref, "page")) || {};
        const eventInfo = JSON.parse(getEventInfo(storeItem, district, isForStoreName));
        window === null || window === void 0 ? void 0 : (ref2 = window.adobeDataLayer) === null || ref2 === void 0 ? void 0 : ref2.push({
            event: "cmp:click",
            eventInfo,
            page
        });
    };
    const getEventInfo = (storeItem, district, isForStoreName)=>{
        var ref, ref1;
        const stateName = district.toLowerCase();
        const cityName = (ref = storeItem.Locality) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        const storeName = (ref1 = storeItem.LocationName) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
        const type = !isForStoreName ? props.browseAllStoreCheckedId === storeItem.EntityID ? "set as preferred store" : "unset as preferred store" : storeName;
        var _BPnumber;
        const link = (_BPnumber = props.browseStoreDetails[storeItem.BPnumber]) !== null && _BPnumber !== void 0 ? _BPnumber : "/";
        const internalLinkURL = isForStoreName ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a";
        return JSON.stringify({
            clickInternalLinks: "true",
            eventAction: "find a store:browse all stores:".concat(isForStoreName ? "store name" : type),
            eventName: "find a store:browse all stores:".concat(isForStoreName ? "store name" : type),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: type,
            internalLinkPosition: "locations",
            internalLinkType: "find a store:".concat(!isForStoreName ? storeName + ":" : "").concat(cityName, ":").concat(stateName),
            internalLinkURL,
            internalLinkZoneName: "find a store:browse all stores"
        });
    };
    const handleCollapse = (state, key)=>{
        setExpanded({
            ...expanded,
            [key]: state
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "view-all-stores",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "kf-react-container view-all-stores__container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row no-gutters",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 ".concat(width >= 1024 && width <= 1280 ? "col-lg-12" : "col-lg-3", " view-all-stores__sticky-container"),
                        children: !dist_lib/* isMobile */.tq ? /*#__PURE__*/ (0,jsx_runtime.jsxs)((lib_default()), {
                            onFixedToggle: ()=>setNavSticky(!navSticky),
                            className: "view-all-stores__sticky-nav-wrap",
                            boundaryElement: ".view-all-stores__sticky-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "view-all-stores__countries-list",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                        label: staticTexts.countryLabel,
                                        data: countries.map((item)=>item.text),
                                        value: countryChange,
                                        onChange: handleChange,
                                        id: "browse-all-country-list-desktop"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "view-all-stores__controls",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: filter/* default */.Z === null || filter/* default */.Z === void 0 ? void 0 : filter/* default.src */.Z.src,
                                            className: "view-all-stores__filter-toggle-icon",
                                            alt: staticTexts.toggleFilter
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: staticTexts.filters
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: filterClass,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-list__filter--sticky",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter/* default */.Z, {
                                            texts: staticTexts,
                                            facets: facets,
                                            onFilter: (curfilters)=>splitBrowseQuery(curfilters),
                                            close: setShowFilter,
                                            displayShare: false,
                                            showFilter: showFilter,
                                            selectedFilterCount: selectedFilterCount,
                                            allStore: true
                                        })
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "view-all-stores__countries-list",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                        label: staticTexts.countryLabel,
                                        data: countries.map((item)=>item.text),
                                        value: countryChange,
                                        onChange: handleChange,
                                        id: "browse-all-country-list-mobile"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                                    onFixedToggle: ()=>setNavSticky(!navSticky),
                                    className: "view-all-stores__sticky-nav-wrap",
                                    boundaryElement: ".view-all-stores__container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "view-all-stores__controls",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: "view-all-stores__filter-toggle",
                                            onClick: ()=>setShowFilter(!showFilter),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: filter/* default */.Z === null || filter/* default */.Z === void 0 ? void 0 : filter/* default.src */.Z.src,
                                                    className: "view-all-stores__filter-toggle-icon",
                                                    alt: "Toggle Filter"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: staticTexts.filters
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: filterClass,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-list__filter--sticky",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter/* default */.Z, {
                                            texts: staticTexts,
                                            facets: facets,
                                            onFilter: (curfilters)=>splitBrowseQuery(curfilters),
                                            close: setShowFilter,
                                            displayShare: false,
                                            showFilter: showFilter,
                                            selectedFilterCount: selectedFilterCount,
                                            allStore: true
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 ".concat(width >= 1024 && width <= 1280 ? "col-lg-12" : "col-lg-9", " view-all-stores__data-container"),
                        children: isEmpty && Object.entries(data).length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: locatioContainer,
                            className: storeListClass,
                            children: staticTexts.noShowRoomFound
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: locatioContainer,
                            className: storeListClass,
                            children: Object.entries(data).sort().map((param, index)=>{
                                let [district, stores] = param;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    className: "view-all-stores__state-list",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                                        contentOverflow: "visible",
                                        title: district,
                                        isOpen: expanded[district],
                                        handleOpen: ()=>handleCollapse(true, district),
                                        handleClose: ()=>handleCollapse(false, district),
                                        triggerStyle: !dist_lib/* isMobile */.tq ? {
                                            display: "none"
                                        } : null,
                                        containerElementProps: {
                                            id: "viewAllStore"
                                        },
                                        children: [
                                            !dist_lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "view-all-stores__state-name",
                                                children: district
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "row",
                                                children: stores.sort(dynamicSort("Locality")).map((storeItem, idx)=>{
                                                    var _BPnumber;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "col-12 col-md-6 col-lg-4",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                className: "view-all-stores__store-name",
                                                                children: storeItem.Locality
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: shortenedUrls[(_BPnumber = props.browseStoreDetails[storeItem.BPnumber]) !== null && _BPnumber !== void 0 ? _BPnumber : constants.pageUrl],
                                                                className: "view-all-stores__store-description gbh-data-layer",
                                                                "data-gbh-data-layer": getEventInfo(storeItem, district, true),
                                                                children: storeItem.LocationName
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "view-all-stores__store-address-primary",
                                                                children: storeItem.AddressLine
                                                            }),
                                                            storeItem.AddressLine2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "view-all-stores__store-address-secondary",
                                                                children: storeItem.AddressLine2
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "view-all-stores__store-address-zone",
                                                                children: [
                                                                    storeItem.Locality,
                                                                    ",",
                                                                    " ",
                                                                    storeItem.AdminDistrict,
                                                                    " ",
                                                                    storeItem.PostalCode
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "view-all-stores__store-mobile",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "tel:".concat(storeItem === null || storeItem === void 0 ? void 0 : storeItem.Phone),
                                                                    onClick: ()=>{
                                                                        phNumberDatalayer(storeItem, district, true, formatPhoneNumber(storeItem.Phone));
                                                                    },
                                                                    children: formatPhoneNumber(storeItem.Phone)
                                                                })
                                                            }),
                                                            storeItem.ContactEmail && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "mailto:".concat(storeItem.ContactEmail),
                                                                className: "view-all-stores__store-email",
                                                                children: storeItem.ContactEmail
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "view-all-stores__set-as-my-store",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                                    analyticsData: getEventInfo(storeItem, district),
                                                                    checked: browseAllStoreCheckedId === storeItem.EntityID,
                                                                    value: browseAllStoreCheckedId === storeItem.EntityID ? staticTexts.myStore : staticTexts.setAsMyStore,
                                                                    id: "view-all-stores__set-store".concat(storeItem.BPnumber),
                                                                    onChange: (e)=>handleBrowseAllStoreCheck(e.target.checked ? storeItem.EntityID : 0)
                                                                })
                                                            })
                                                        ]
                                                    }, idx);
                                                })
                                            })
                                        ]
                                    })
                                }, index);
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_BrowseAllStoresView = (BrowseAllStoresView);

// EXTERNAL MODULE: ./i18n/useFindashowroomi18n.js
var useFindashowroomi18n = __webpack_require__(75185);
;// CONCATENATED MODULE: ./components/BrowseAllStores/v1/BrowseAllStores.jsx















const BrowseAllStores = (props)=>{
    const { data: authorData  } = props;
    const { storeCountryListPath  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { myStoreId , browseLocationsStoreFilterData  } = (0,es/* useSelector */.v9)(locationSlice/* locationState */._n);
    const dispatch = (0,es/* useDispatch */.I0)();
    const [browseStoreDetails, setBrowseStoreDetails] = (0,react.useState)({});
    const [browseStoreFilterData] = (0,react.useState)(get_default()(browseLocationsStoreFilterData, "storefilter", {}));
    const [countries, setCountries] = (0,react.useState)([]);
    var ref;
    const [browseAllStoreCheckedId, setBrowseAllStoreCheckedId] = (0,react.useState)((ref = localStorage.getItem("myStoreId")) !== null && ref !== void 0 ? ref : 0);
    const [facets, setFacets] = (0,react.useState)({});
    const [info, setInfo] = (0,react.useState)({});
    const storeTexts = i18n_useMystorei18n({
        authorData
    });
    const landingTexts = (0,useFindashowroomi18n/* default */.Z)(authorData);
    const staticTexts = {
        ...storeTexts,
        ...landingTexts
    };
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then(async (config)=>{
            const locale = get_default()(config, "internationalization.locale", "");
            const currencySign = get_default()(config, "internationalization.currencySign", "");
            const currencyCode = get_default()(config, "internationalization.currencyCode", "");
            const browseStoreDetailsUrl = get_default()(config, "general.storeDetailsServletPath", "");
            const findStores = get_default()(config, "apiEndPointData.findStores", "");
            const siteName = get_default()(config, "general.siteName", "");
            (0,api/* aemAxiosInstance */.Gb)({
                url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: browseStoreDetailsUrl
                }
            }).then((response)=>{
                if (response && response.data) {
                    setBrowseStoreDetails(response.data);
                }
            }).catch((err)=>{
                console.log("Failed to get compare attributes JSON file", err);
            });
            const info = {
                locale: locale,
                currencySign: currencySign,
                currencyCode: currencyCode,
                findStores: findStores,
                siteName: siteName
            };
            setInfo(info);
        });
    }, []);
    (0,react.useEffect)(()=>{
        dispatch((0,genericSlice/* getGenericListPath */.Ln)());
    }, []);
    (0,react.useEffect)(()=>{
        if (storeCountryListPath) {
            dispatch((0,genericSlice/* getStoreCountriesList */.a5)()).unwrap().then((res)=>{
                setCountries(res);
            });
        }
    }, [
        storeCountryListPath
    ]);
    (0,react.useEffect)(()=>{
        if (myStoreId !== browseAllStoreCheckedId) {
            localStorage.setItem("myStoreId", myStoreId);
            setBrowseAllStoreCheckedId(myStoreId);
        }
    }, [
        myStoreId
    ]);
    (0,react.useEffect)(()=>{
        if (browseStoreFilterData) {
            const updatedFacets = (0,helper/* storeFilterData */.TeW)(browseStoreFilterData);
            setFacets(updatedFacets);
        }
    }, [
        browseStoreFilterData
    ]);
    (0,react.useEffect)(()=>{
        if (myStoreId !== 0 && !isEmpty_default()(info)) {
            getUtilityDataById();
        }
    }, [
        myStoreId,
        info
    ]);
    const { findStores =""  } = info;
    const getUtilityDataById = async ()=>{
        const utilityData = await (0,utils_location/* getStoreDataById */.e)({
            myStoreId: myStoreId,
            findStores: findStores,
            siteName: info.siteName
        });
        dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData));
    };
    const handleBrowseAllStoreCheck = (entity)=>{
        localStorage.setItem("myStoreId", entity);
        dispatch((0,locationSlice/* setMyStore */.h9)(entity));
        setBrowseAllStoreCheckedId(entity);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_BrowseAllStoresView, {
        staticTexts: staticTexts,
        facets: facets,
        countries: countries,
        browseStoreDetails: browseStoreDetails,
        findStores: findStores,
        handleBrowseAllStoreCheck: (entity)=>handleBrowseAllStoreCheck(entity),
        browseAllStoreCheckedId: browseAllStoreCheckedId,
        authorData: authorData
    });
};
/* harmony default export */ var v1_BrowseAllStores = (BrowseAllStores);


/***/ }),

/***/ 77679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_core_Collapsible__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73394);
/* harmony import */ var _public_icons_close_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(653);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85518);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27514);
/* harmony import */ var _components_core_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55511);








const Filter = (props)=>{
    const [collapse, setCollapse] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [appliedFilters, setAppliedFilters] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [facetLabelsInfo, setFacetLabels] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const urlFiltersDetails = [];
        const urlFilters = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__/* .getFacetsFromUrl */ .bZU)();
        let facetsLabels = (facetLabelsInfo === null || facetLabelsInfo === void 0 ? void 0 : facetLabelsInfo.length) <= 0 && (props === null || props === void 0 ? void 0 : props.facets) ? updateFacetsFields(Object.keys(props === null || props === void 0 ? void 0 : props.facets)) : facetLabelsInfo;
        urlFilters ? urlFilters.forEach((urlFiltersKey, i)=>{
            if (facetsLabels[urlFiltersKey === null || urlFiltersKey === void 0 ? void 0 : urlFiltersKey.facet]) {
                urlFiltersDetails.push({
                    facet: facetsLabels[urlFiltersKey.facet],
                    value: updatePlusSymbol(urlFiltersKey.value),
                    display: updatePlusSymbol(urlFiltersKey.display),
                    query: updatePlusSymbol(urlFiltersKey.display)
                });
            }
        }) : "";
        urlFilters ? setAppliedFilters(urlFiltersDetails) : "";
    }, []);
    const formatFacetName = (name, filter)=>{
        var ref;
        let val = (ref = name.replace(/\./g, "/").replace(/_/g, " ").replace(/^\*{2}/, "")) === null || ref === void 0 ? void 0 : ref.replaceAll(" ", "");
        if (filter) {
            val += " - ".concat(filter);
            val.replace(/\s/g, "");
        }
        return val;
    };
    const isSelected = (obj)=>{
        let facet = appliedFilters.find((filter)=>{
            var ref;
            return filter.facet === ((ref = obj.facet) === null || ref === void 0 ? void 0 : ref.replaceAll(" ", ""));
        });
        if (!facet) return false;
        return facet.display.includes(obj.query) ? true : false;
    };
    const updateFacetsFields = (allFacetLabels)=>{
        let facetLabels = [];
        if ((allFacetLabels === null || allFacetLabels === void 0 ? void 0 : allFacetLabels.length) > 0) {
            allFacetLabels.forEach((labelVal)=>{
                facetLabels[labelVal === null || labelVal === void 0 ? void 0 : labelVal.replaceAll(" ", "")] = labelVal.replace(/\s/g, "");
            });
        }
        setFacetLabels(facetLabels);
        return facetLabels;
    };
    const updatePlusSymbol = (facetVal)=>{
        let facetLabels = [];
        if ((facetVal === null || facetVal === void 0 ? void 0 : facetVal.length) > 0) {
            facetVal.forEach((labelVal)=>{
                facetLabels.push(labelVal === null || labelVal === void 0 ? void 0 : labelVal.replaceAll("+", " "));
            });
        }
        return facetLabels;
    };
    const getUrlFullInfo = ()=>{
        var ref, ref1;
        let getUrlInfo = (ref1 = (ref = window.location.href) === null || ref === void 0 ? void 0 : ref.split("?")[1]) === null || ref1 === void 0 ? void 0 : ref1.split("&");
        let restSearchParam = getUrlInfo && getUrlInfo != undefined ? getUrlInfo.find((UrlText)=>UrlText.indexOf("q=") >= 0) : "";
        return restSearchParam;
    };
    const setUrlParams = (filters)=>{
        let restSearchParam = getUrlFullInfo();
        let query = restSearchParam && restSearchParam != undefined ? restSearchParam + "&" : "";
        if (filters.length > 0) {
            let facetsLabels = (facetLabelsInfo === null || facetLabelsInfo === void 0 ? void 0 : facetLabelsInfo.length) <= 0 && (props === null || props === void 0 ? void 0 : props.facets) ? updateFacetsFields(Object.keys(props === null || props === void 0 ? void 0 : props.facets)) : facetLabelsInfo;
            filters.forEach((filterInfo, i)=>{
                var ref;
                const values = [
                    ...filterInfo === null || filterInfo === void 0 ? void 0 : filterInfo.query
                ];
                let customFacet = filterInfo === null || filterInfo === void 0 ? void 0 : (ref = filterInfo.facet) === null || ref === void 0 ? void 0 : ref.replaceAll(" ", "_");
                if (values.length !== 0 && facetsLabels[customFacet]) {
                    var ref1;
                    var ref2;
                    query += "".concat((ref2 = (ref1 = customFacet === null || customFacet === void 0 ? void 0 : customFacet.replace(/^\*{2}/, "")) === null || ref1 === void 0 ? void 0 : ref1.replaceAll(" ", "_")) !== null && ref2 !== void 0 ? ref2 : customFacet, "=").concat(encodeURIComponent(values)).concat(i !== filters.length - 1 ? "&" : "");
                }
            });
            window.history.replaceState(window.location.pathname, document.title, query.toString().length === 0 ? window.location.pathname : "?".concat(query.toString()));
            if (props.resetTitle) props.resetTitle();
        } else {
            clearAllFilters();
        }
    };
    const handleFilter = (checked, obj, isFilterCancel)=>{
        let curFilters = appliedFilters;
        let facet = curFilters.find((filter)=>filter.facet === obj.facet);
        if (checked) {
            if (facet) {
                facet.value.push(obj.value.replace(/"/g, '\\"'));
                facet.display.push(obj.query);
                facet.query.push(obj.query);
            } else curFilters.push({
                facet: obj.facet,
                value: [
                    obj.value.replace(/"/g, '\\"')
                ],
                display: [
                    obj.query
                ],
                query: [
                    obj.query
                ]
            });
        } else {
            let index = facet.display.indexOf(obj.query);
            facet.value.splice(index, 1);
            facet.display.splice(index, 1);
            facet.query.splice(index, 1);
            if (!facet.value.length) {
                curFilters = curFilters.filter((f)=>f.facet !== obj.facet);
            }
        }
        setAppliedFilters([
            ...curFilters
        ]) //spreading is required to break reference
        ;
        addAnalyticsData(curFilters, checked, obj, isFilterCancel);
        props.addToUrl && setUrlParams(curFilters);
        props.onFilter(curFilters, true);
    };
    // Reason of handling this in a seperate function is to add the appliedFilters in filterArray prop of dataLayer
    const addAnalyticsData = (curFilters, isChecked, obj, isFilterCancel)=>{
        const { facet , value: label  } = obj;
        const filterLabel = label || obj.display;
        const appliedOrRemoved = isFilterCancel ? "cancel" : isChecked ? "applied" : "removed";
        const eventInfo = {
            eventAction: "find a store:".concat((props === null || props === void 0 ? void 0 : props.allStore) ? "browse all stores" : "landing", ":filters:").concat(appliedOrRemoved),
            eventName: "find a store:".concat((props === null || props === void 0 ? void 0 : props.allStore) ? "browse all stores" : "landing", ":filters:").concat(appliedOrRemoved),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(filterLabel === null || filterLabel === void 0 ? void 0 : filterLabel.toLowerCase(), ":").concat(appliedOrRemoved),
            internalLinkPosition: "find a store",
            internalLinkType: "find a store:".concat(facet === null || facet === void 0 ? void 0 : facet.toLowerCase()),
            filterArray: "".concat((facet === null || facet === void 0 ? void 0 : facet.toLowerCase()) + ":" + (filterLabel === null || filterLabel === void 0 ? void 0 : filterLabel.toLowerCase())),
            internalLinkZoneName: "find a store:".concat((props === null || props === void 0 ? void 0 : props.allStore) ? "browse all stores" : "landing", ":filters"),
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        let filterArray = "";
        if (curFilters.length > 0) {
            curFilters.forEach((facetObj)=>{
                facetObj.value.forEach((facetValue)=>{
                    filterArray += facetObj.facet.toLowerCase() + ":" + facetValue.toLowerCase() + "|";
                });
            });
        }
        eventInfo.filterArray = filterArray === null || filterArray === void 0 ? void 0 : filterArray.slice(0, -1);
        if (window.adobeDataLayer) {
            const { adobeDataLayer: { getState  } = {}  } = window;
            const page = getState && getState("page") || {};
            window.adobeDataLayer.push({
                event: "cmp:click",
                eventInfo,
                page
            });
        }
    };
    const handleCollapse = (facet, state)=>{
        setCollapse((prevCollapse)=>({
                ...prevCollapse,
                [facet]: state
            }));
    };
    const clearAllFilters = ()=>{
        setAppliedFilters([]);
        props.onFilter([], true);
        let restSearchParam = getUrlFullInfo();
        let urlParam = restSearchParam && restSearchParam != undefined ? restSearchParam : "";
        window.history.replaceState(window.location.pathname, document.title, urlParam.toString().length === 0 ? window.location.pathname : "?".concat(urlParam.toString()));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (props.showFilter) {
            window.addEventListener("keydown", handleKeyPress);
        }
        if (react_device_detect__WEBPACK_IMPORTED_MODULE_5__/* .isMobile */ .tq && window.innerWidth < 1024) {
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__/* .preventBodyScroll */ .MVu)(props.showFilter);
        }
        return ()=>{
            window.removeEventListener("keydown", handleKeyPress);
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__/* .preventBodyScroll */ .MVu)(false);
        };
    }, [
        props.showFilter
    ]);
    function handleKeyPress(e) {
        var ref;
        const focusElements = '[tabindex]:not([tabindex="-1"])';
        const focusContent = (ref = document.getElementById("kf-store-filter")) === null || ref === void 0 ? void 0 : ref.querySelectorAll(focusElements);
        const lastElem = focusContent[focusContent.length - 1];
        if (e.key === "Tab" && !e.shiftKey && document.activeElement === lastElem) {
            var ref1;
            (ref1 = document.getElementById("kf-store-use-location")) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
    }
    const addFilterExpandCollapseAnalytics = (facet, formatFacetName)=>{
        const collapseOrExpand = !collapse[facet[0]] ? "collapse" : "expand";
        return JSON.stringify({
            clickInternalLinks: "true",
            eventAction: "find a store:".concat((props === null || props === void 0 ? void 0 : props.allStore) ? "browse all stores" : "landing", ":filters:").concat(collapseOrExpand),
            eventName: "find a store:".concat((props === null || props === void 0 ? void 0 : props.allStore) ? "browse all stores" : "landing", ":filters:").concat(collapseOrExpand),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(collapseOrExpand),
            internalLinkPosition: "find a store",
            internalLinkType: "find a store:".concat(formatFacetName),
            internalLinkURL: "n/a",
            internalLinkZoneName: "find a store:".concat((props === null || props === void 0 ? void 0 : props.allStore) ? "browse all stores" : "landing", ":filters")
        });
    };
    const getEventInfo = ()=>{
        return JSON.stringify({
            eventAction: "find a store:".concat((props === null || props === void 0 ? void 0 : props.allStore) ? "browse all stores" : "landing", ":filters:clear all"),
            eventName: "find a store:".concat((props === null || props === void 0 ? void 0 : props.allStore) ? "browse all stores" : "landing", ":filters:clear all"),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "clear all",
            internalLinkPosition: "find a store",
            internalLinkType: "find a store:filters",
            internalLinkZoneName: "find a store:".concat((props === null || props === void 0 ? void 0 : props.allStore) ? "browse all stores" : "landing", ":filters"),
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("filter", "filter--show-less"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "filter__inner-container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "product-list__controls filter__mobile-header",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: "product-list__filter-toggle",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: window.innerWidth < 1200 ? props.texts.filterSort : props.texts.filters
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                role: "button",
                                tabIndex: "0",
                                src: _public_icons_close_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z === null || _public_icons_close_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_close_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src,
                                className: "product-list__close-icon",
                                alt: "Close Filter",
                                onClick: ()=>props.close(false)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "filter__chips",
                        children: [
                            appliedFilters.map((facet)=>{
                                return facet.value.map((filter)=>{
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "filter__chips-tag",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: filter
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                role: "button",
                                                tabIndex: "0",
                                                src: _public_icons_close_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z === null || _public_icons_close_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_close_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src,
                                                alt: "Close",
                                                className: "filter__chips-close-icon",
                                                onClick: ()=>handleFilter(false, {
                                                        facet: facet.facet,
                                                        display: filter,
                                                        query: filter
                                                    }, true)
                                            })
                                        ]
                                    }, filter);
                                });
                            }),
                            appliedFilters.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "filter__chips-clear-all gbh-data-layer",
                                "data-gbh-data-layer": getEventInfo(),
                                onClick: clearAllFilters,
                                role: "button",
                                tabIndex: "0",
                                "aria-label": props.texts.clearAll,
                                children: props.texts.clearAll
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        id: "kf-store-filter",
                        children: Object.entries(props.facets).map((facet)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Collapsible__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                open: collapse[facet[0]],
                                onTriggerOpening: ()=>handleCollapse(facet[0], true),
                                onTriggerClosing: ()=>handleCollapse(facet[0], false),
                                openedClassName: "is-open",
                                trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    role: "list",
                                    tabIndex: "0",
                                    className: "gbh-data-layer",
                                    "data-gbh-data-layer": addFilterExpandCollapseAnalytics(facet, formatFacetName(facet[0])),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            "aria-hidden": "true",
                                            children: facet[0]
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                                            className: "plus",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "line-1 line"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "line line-2"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                transitionTime: 400,
                                easing: "ease-in-out",
                                children: collapse[facet[0]] && facet[1].map((filter)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        id: facet[0] + filter.label,
                                        value: filter.label,
                                        onChange: (e)=>handleFilter(e.target.checked, {
                                                facet: formatFacetName(facet[0]),
                                                value: filter.label,
                                                query: filter.query
                                            }),
                                        checked: isSelected({
                                            facet: formatFacetName(facet[0]),
                                            display: filter.label,
                                            query: filter.query
                                        }),
                                        tabIndex: collapse[facet[0]] ? 0 : -1,
                                        checkBoxAria: filter.label
                                    }, filter.label))
                            }, facet[0]);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "filter__footer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("filter__apply", appliedFilters.length > 0 && "filter__apply--active"),
                    disabled: appliedFilters.length < 1,
                    onClick: ()=>props.close(false),
                    children: props.selectedFilterCount > 0 && appliedFilters.length > 0 ? "".concat(props.texts.view, " ").concat(props.texts.results, " (").concat(props.selectedFilterCount, ")") : props.texts.viewResults
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Filter);


/***/ }),

/***/ 43769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LeadGeneration; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./src/components/Shared/NewsletterFooter/newsLetterBody.js
var newsLetterBody = __webpack_require__(81506);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
// EXTERNAL MODULE: ./src/components/core/Input/Input.jsx
var Input = __webpack_require__(27222);
// EXTERNAL MODULE: ./src/components/core/SelectDropdown/SelectDropdown.jsx
var SelectDropdown = __webpack_require__(14629);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
;// CONCATENATED MODULE: ./components/LeadGeneration/Form.jsx









const Form = (props)=>{
    const { data , setData , i18n , error , onSubmit , teaserComponent , loading  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const [occupation, setOccupation] = (0,react.useState)([]);
    const [countries, setCountries] = (0,react.useState)([]);
    const [stateList, setStateList] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        setData({
            ...data,
            state: {}
        });
    }, [
        data.country
    ]);
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        const userEmail = (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : (ref1 = ref.href) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.includes) === null || ref2 === void 0 ? void 0 : ref2.call(ref1, "?email=")) ? window === null || window === void 0 ? void 0 : (ref3 = window.location) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.href) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.split) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.call(ref4, "=")) === null || ref6 === void 0 ? void 0 : ref6[1] : "";
        if (userEmail) setData({
            ...data,
            email: userEmail
        });
    }, [
        teaserComponent
    ]);
    const { countryListPath , stateListPath , occupationListPath  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    (0,react.useEffect)(()=>{
        try {
            if (!isEmpty_default()(countryListPath) && !isEmpty_default()(stateListPath) && !isEmpty_default()(occupationListPath)) getLocations();
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    }, [
        countryListPath,
        stateListPath,
        occupationListPath
    ]);
    const getLocations = async ()=>{
        if (countryListPath && stateListPath && occupationListPath) {
            var ref;
            const countryData = await dispatch((0,genericSlice/* getCountryList */.Jp)());
            const stateData = await dispatch((0,genericSlice/* getstateList */.lK)());
            const occupationList = await dispatch((0,genericSlice/* getOccupationList */.m3)());
            const mapList = !isEmpty_default()(countryData === null || countryData === void 0 ? void 0 : countryData.payload) && !isEmpty_default()(stateData === null || stateData === void 0 ? void 0 : stateData.payload) && (0,helper/* mapStateToCountryHandler */.oFy)(countryData === null || countryData === void 0 ? void 0 : countryData.payload, stateData === null || stateData === void 0 ? void 0 : stateData.payload) || [];
            setCountries(mapList);
            var ref1;
            setStateList((ref1 = (ref = mapList.find((country)=>country.code === "US")) === null || ref === void 0 ? void 0 : ref.states) !== null && ref1 !== void 0 ? ref1 : []);
            setOccupation(occupationList === null || occupationList === void 0 ? void 0 : occupationList.payload);
            var ref2;
            setData({
                ...data,
                country: (ref2 = mapList.find((country)=>country.code === "US")) !== null && ref2 !== void 0 ? ref2 : {}
            });
        }
    };
    const onNameChange = async (e)=>{
        const { id , value  } = e.target;
        const field = id.split("-");
        if (value === "" || await (0,helper/* validateField */.OP$)("name", value)) {
            setData({
                ...data,
                [field[2]]: value
            });
        }
    };
    const selectOccupation = (occupation)=>{
        setData({
            ...data,
            occupation
        });
        props.setError({
            ...error,
            occupation: false
        });
    };
    const onInputChange = async function(e) {
        let zipChange = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        const { id , value  } = e.target;
        const field = id.split("-");
        if (zipChange) {
            if (value === "" || await (0,helper/* validateField */.OP$)("zipCodeNumeric", value)) {
                setData({
                    ...data,
                    [field[2]]: value
                });
            }
        } else {
            setData({
                ...data,
                [field[2]]: value
            });
        }
    };
    const changeCountry = (country)=>{
        var ref;
        var ref1;
        setStateList((ref1 = (ref = countries === null || countries === void 0 ? void 0 : countries.find((c)=>{
            return (c === null || c === void 0 ? void 0 : c.name) === country;
        })) === null || ref === void 0 ? void 0 : ref.states) !== null && ref1 !== void 0 ? ref1 : []);
        setData({
            ...data,
            country: countries === null || countries === void 0 ? void 0 : countries.find((c)=>{
                return (c === null || c === void 0 ? void 0 : c.name) === country;
            })
        });
    };
    const changeState = (state)=>{
        var ref;
        setData({
            ...data,
            state: (ref = {
                code: state
            }) !== null && ref !== void 0 ? ref : {}
        });
        props.setError({
            ...error,
            state: false
        });
    };
    const checkDisabled = (userdata)=>{
        var ref, ref1, ref2, ref3;
        if ((userdata === null || userdata === void 0 ? void 0 : (ref = userdata.fname) === null || ref === void 0 ? void 0 : ref.trim()) && (userdata === null || userdata === void 0 ? void 0 : (ref1 = userdata.lname) === null || ref1 === void 0 ? void 0 : ref1.trim()) && (userdata === null || userdata === void 0 ? void 0 : (ref2 = userdata.email) === null || ref2 === void 0 ? void 0 : ref2.trim()) && (userdata === null || userdata === void 0 ? void 0 : userdata.zipcode) && (userdata === null || userdata === void 0 ? void 0 : userdata.state) && (userdata === null || userdata === void 0 ? void 0 : (ref3 = userdata.occupation) === null || ref3 === void 0 ? void 0 : ref3.trim())) return false;
        return true;
    };
    var ref, _code, _name, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "contact-title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "contact-title__fields",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "required-fields",
                                children: i18n.requiredInfoText
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container contact-info-form mb-40",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row mx-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "user-email col-12 px-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        id: "contact-user-email",
                                        type: "text",
                                        value: data.email,
                                        maxLength: 60,
                                        placeholder: "".concat(i18n.email, "*"),
                                        label: "".concat(i18n.email, "*"),
                                        onChange: onInputChange,
                                        showError: error === null || error === void 0 ? void 0 : error.email,
                                        errorMessage: error === null || error === void 0 ? void 0 : error.email,
                                        onBlur: ()=>props.onBlur("email"),
                                        autoComplete: "email"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row mx-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "user-fname col-12 px-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        id: "contact-user-fname",
                                        type: "text",
                                        value: data.fname,
                                        maxLength: 40,
                                        placeholder: "".concat(i18n.fname, "*"),
                                        label: "".concat(i18n.fname, "*"),
                                        onChange: onNameChange,
                                        showError: error.fname,
                                        errorMessage: error.fname,
                                        onBlur: ()=>props.onBlur("fname"),
                                        autoComplete: "given-name"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row mx-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "user-lname col-12 px-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        id: "contact-user-lname",
                                        type: "text",
                                        value: data.lname,
                                        maxLength: 40,
                                        placeholder: "".concat(i18n.lname, "*"),
                                        label: "".concat(i18n.lname, "*"),
                                        onChange: onNameChange,
                                        showError: error.lname,
                                        errorMessage: error.lname,
                                        onBlur: ()=>props.onBlur("lname"),
                                        autoComplete: "family-name"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row mx-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "user-state col-12 px-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                        id: "contact-user-state",
                                        customClass: "input-field",
                                        data: (ref = stateList !== null && stateList !== void 0 ? stateList : []) !== null && ref !== void 0 ? ref : [],
                                        value: (_code = data.state.code) !== null && _code !== void 0 ? _code : "",
                                        label: "".concat(i18n.state, "*"),
                                        onChange: changeState,
                                        showError: error.state,
                                        errorMessage: error.state,
                                        onBlur: ()=>props.onBlur("state"),
                                        ariaStateText: true,
                                        showStateName: true
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row mx-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "user-zipcode col-12 px-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        id: "contact-user-zipcode",
                                        type: "text",
                                        value: data.zipcode,
                                        maxLength: 7,
                                        autoComplete: "postal-code",
                                        placeholder: "".concat(i18n.zipcode, "*"),
                                        label: "".concat(i18n.zipcode, "*"),
                                        onChange: (e)=>onInputChange(e, true),
                                        showError: error.zipcode,
                                        errorMessage: error.zipcode,
                                        onBlur: ()=>props.onBlur("zipcode")
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row mx-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "user-country col-12 px-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                        id: "contact-user-country",
                                        customClass: "input-field",
                                        data: countries.map((country)=>{
                                            return country === null || country === void 0 ? void 0 : country.name;
                                        }),
                                        name: "country",
                                        value: (_name = data.country.name) !== null && _name !== void 0 ? _name : "",
                                        label: "".concat(i18n.country),
                                        onChange: changeCountry,
                                        showError: error.country,
                                        errorMessage: error.country
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row mx-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-12 px-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                        id: "contact-user-occupation-type",
                                        data: occupation === null || occupation === void 0 ? void 0 : occupation.map((el)=>el.text),
                                        value: (ref1 = data === null || data === void 0 ? void 0 : data.occupation) !== null && ref1 !== void 0 ? ref1 : "",
                                        label: "".concat(i18n.occupation, "*"),
                                        onChange: selectOccupation,
                                        showError: error.occupation,
                                        errorMessage: error.occupation,
                                        onBlur: ()=>props.onBlur("occupation")
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: "lead-gen-footer__submit-button",
                role: "button",
                id: "submit-membership-form-button",
                disabled: checkDisabled(data),
                onClick: onSubmit,
                type: "black",
                label: i18n.subscribe,
                loading: loading,
                flexible: true
            })
        ]
    });
};
/* harmony default export */ var LeadGeneration_Form = (Form);

// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./components/LeadGeneration/FormSuccessMessage.jsx





const FormSuccessMessage = (props)=>{
    const [continueUrl, setContinueUrl] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }, []);
    const getContinueUrl = async ()=>{
        try {
            setContinueUrl(await (0,helper/* getShortenedUrl */.Ppy)(props === null || props === void 0 ? void 0 : props.continueShoppingUrl, true));
        } catch (error) {
            console.error(error);
        }
    };
    (0,react.useEffect)(()=>{
        getContinueUrl();
    }, [
        props === null || props === void 0 ? void 0 : props.continueShoppingUrl
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "lead-gen-confirmation-message-wrapper",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "lead-gen-confirmation-message__container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: "lead-gen-success-message",
                    className: "message-content",
                    tabIndex: "0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "success-message-title",
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(props.i18n.successTitle)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "success-message-description",
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(props.i18n.successDescription)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lead-gen-response-message__cta",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "black",
                        target: (props === null || props === void 0 ? void 0 : props.isNewTab) ? "_blank" : "_self",
                        label: props.i18n.startShopping,
                        to: continueUrl,
                        className: "start-shopping-btn"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var LeadGeneration_FormSuccessMessage = ((0,lib/* withOrientationChange */.Qe)(FormSuccessMessage));

;// CONCATENATED MODULE: ./components/LeadGeneration/LeadGenView.jsx









const LeadGenView = (props)=>{
    const { i18n , submitSuccess , brandName , isNewTab , showToaster , teaserComponent  } = props;
    const [userData, setUserData] = (0,react.useState)({
        fname: "",
        lname: "",
        email: "",
        state: {},
        zipcode: "",
        country: {},
        occupation: ""
    });
    const [error, setError] = (0,react.useState)({});
    const [loading, setLoading] = (0,react.useState)(false);
    const validateExist = async (field)=>{
        switch(field){
            case "fname":
            case "lname":
                if (!userData[field].trim() || !await (0,helper/* validateField */.OP$)("name", userData[field])) {
                    return field === "fname" ? i18n.fnameError : i18n.lnameError;
                }
                break;
            case "email":
                if (!userData[field]) return i18n.noEmailError;
                else if (!await (0,helper/* validateField */.OP$)("email", userData[field])) return i18n.validEmail;
                break;
            case "zipcode":
                if (!userData.zipcode.trim()) return i18n.zipcodeError;
                else if (userData.zipcode.length < 5) return i18n.validZipcode;
                break;
            case "state":
                if (!userData.state || isEmpty_default()(userData.state)) return i18n.stateError;
                break;
            case "occupation":
                if (userData.occupation.trim() === "") return i18n.occupationError;
                break;
            default:
                return;
        }
    };
    const onBlurError = async (field)=>{
        setError({
            ...error,
            [field]: await validateExist(field)
        });
    };
    const getErrorList = async ()=>{
        let errorList = {
            fname: await validateExist("fname"),
            lname: await validateExist("lname"),
            email: await validateExist("email"),
            zipcode: await validateExist("zipcode"),
            state: await validateExist("state"),
            occupation: await validateExist("occupation")
        };
        return errorList;
    };
    const onSubmit = async ()=>{
        setLoading(true);
        let errorDataList = [];
        const errorList = await getErrorList();
        setError(errorList);
        if (errorList.fname) {
            errorDataList.push("contact-user-fname");
        } else if (errorList.lname) {
            errorDataList.push("contact-user-lname");
        } else if (errorList.email) {
            errorDataList.push("contact-user-email");
        } else if (errorList.zipcode) {
            errorDataList.push("contact-user-zipcode");
        } else if (errorList.state) {
            errorDataList.push("contact-user-state");
        } else if (errorList.occupation) {
            errorDataList.push("contact-user-occupation-type");
        }
        errorDataList.forEach((item, i)=>{
            if (i === 0) document.getElementById("".concat(item)).focus();
        });
        const isInvalid = Object.values(errorList).find((el)=>el);
        const { fname , lname , email , state , zipcode , country , occupation  } = userData;
        if (!isInvalid) {
            const additionalValues = {
                "First Name": fname,
                "Last Name": lname,
                State: state.code,
                "Zip or Postal Code": zipcode,
                Country: country === null || country === void 0 ? void 0 : country.name,
                Occupation: occupation
            };
            let body = (0,newsLetterBody/* default */.Z)(brandName, email, null, additionalValues);
            (0,helper/* sanitizeObject */.O0b)(body);
            setLoading(false);
            api/* apim.post */.TH.post(constants.emailSubscribeEndPoint, body, {
                params: {
                    brand: brandName
                }
            }).then((response)=>{
                if (response === null || response === void 0 ? void 0 : response.data) {
                    var ref;
                    var ref1;
                    const isSuccess = (ref1 = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.resultMessages) !== null && ref1 !== void 0 ? ref1 : [];
                    if (isSuccess) {
                        var ref2, ref3;
                        teaserComponent === null || teaserComponent === void 0 ? void 0 : (ref2 = teaserComponent.classList) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.add) === null || ref3 === void 0 ? void 0 : ref3.call(ref2, "d-none");
                        props.handleSubmitMsg(true);
                    }
                } else {
                    showToaster("News letter subscription API: Error occured while fetching data from Get URL Property");
                }
            }).catch((err)=>{
                var ref, ref1;
                if (((ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.error) === "Email address already subscribed") {
                    showToaster(i18n === null || i18n === void 0 ? void 0 : i18n.alreadySubscribed);
                } else {
                    showToaster(i18n === null || i18n === void 0 ? void 0 : i18n.genError);
                }
            });
        } else {
            setLoading(false);
        }
    };
    return !submitSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "kf-react-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "lead-gen-main",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadGeneration_Form, {
                i18n: i18n,
                data: userData,
                setData: setUserData,
                error: error,
                setError: setError,
                onBlur: onBlurError,
                onSubmit: onSubmit,
                loading: loading,
                teaserComponent: teaserComponent
            })
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadGeneration_FormSuccessMessage, {
        i18n: i18n,
        setSubmitSuccess: props.handleSubmitMsg,
        continueShoppingUrl: props.continueShoppingUrl,
        isNewTab: isNewTab
    });
};
/* harmony default export */ var LeadGeneration_LeadGenView = (LeadGenView);

;// CONCATENATED MODULE: ./components/LeadGeneration/index.jsx








const LeadGen = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const dispatch = (0,es/* useDispatch */.I0)();
    const [submitSuccess, setSubmitSuccess] = (0,react.useState)(false);
    const [brandName, setBrandName] = (0,react.useState)("");
    const [teaserComponent, setTeaserComponent] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        var ref;
        (0,config/* getConfig */.i)().then(async (config)=>{
            setBrandName(get_default()(config, "general.siteName", ""));
        });
        dispatch((0,genericSlice/* getGenericListPath */.Ln)());
        if (document === null || document === void 0 ? void 0 : (ref = document.getElementById) === null || ref === void 0 ? void 0 : ref.call(document, "aem-lead-gen-container")) {
            var ref1;
            setTeaserComponent(document === null || document === void 0 ? void 0 : (ref1 = document.getElementById) === null || ref1 === void 0 ? void 0 : ref1.call(document, "aem-lead-gen-container"));
        }
    }, []);
    var ref6, ref7, ref8, ref9;
    const i18n = {
        requiredInfoText: t("kf.auth.label.requiredFields"),
        fname: t("kf.contactus.label.firstName"),
        lname: t("kf.contactus.label.lastName"),
        email: t("kf.contactus.label.emailAddress"),
        state: t("kf.contactus.label.state"),
        zipcode: t("kf.contactus.label.zipCode"),
        country: t("kf.contactus.label.country"),
        successTitle: (ref6 = props === null || props === void 0 ? void 0 : (ref = props.data) === null || ref === void 0 ? void 0 : ref.successtitle) !== null && ref6 !== void 0 ? ref6 : t("kf.newsletter.label.getReady"),
        successDescription: (ref7 = props === null || props === void 0 ? void 0 : (ref1 = props.data) === null || ref1 === void 0 ? void 0 : ref1.successdescription) !== null && ref7 !== void 0 ? ref7 : t("kf.contactus.label.messageSent"),
        startShopping: (ref8 = props === null || props === void 0 ? void 0 : (ref2 = props.data) === null || ref2 === void 0 ? void 0 : ref2.ctaLabel) !== null && ref8 !== void 0 ? ref8 : t("kf.trademembership.label.startShopping"),
        fnameError: t("kf.contactus.error.fnameError"),
        lnameError: t("kf.contactus.error.lnameError"),
        noEmailError: t("kf.contactus.error.noEmailError"),
        validEmail: t("kf.contactus.error.validEmail"),
        stateError: t("kf.contactus.error.stateError"),
        zipcodeError: t("kf.contactus.error.zipcodeError"),
        validZipcode: t("kf.contactus.error.validZipcode"),
        serverError: (ref9 = props === null || props === void 0 ? void 0 : (ref3 = props.data) === null || ref3 === void 0 ? void 0 : ref3.errorMessage) !== null && ref9 !== void 0 ? ref9 : t("kf.contactus.error.serverError"),
        occupation: t("kf.trademembership.label.occupation"),
        occupationError: t("kf.trademembership.error.occupation"),
        subscribe: t("kf.account.label.subscribe"),
        genError: t("kf.error.message.genericError"),
        alreadySubscribed: t("kf.newsletter.label.alreadySubscribed")
    };
    const handleSubmit = (status)=>{
        setSubmitSuccess(status);
    };
    const showToaster = (msg)=>{
        dispatch((0,genericSlice/* showToast */.CF)({
            message: msg,
            isVisible: true
        }));
    };
    var ref10, ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadGeneration_LeadGenView, {
        i18n: i18n,
        submitSuccess: submitSuccess,
        handleSubmitMsg: handleSubmit,
        continueShoppingUrl: (ref10 = props === null || props === void 0 ? void 0 : (ref4 = props.data) === null || ref4 === void 0 ? void 0 : ref4.ctalink) !== null && ref10 !== void 0 ? ref10 : "",
        showToaster: (msg)=>showToaster(msg),
        brandName: brandName,
        isNewTab: (ref11 = props === null || props === void 0 ? void 0 : (ref5 = props.data) === null || ref5 === void 0 ? void 0 : ref5.isnewtab) !== null && ref11 !== void 0 ? ref11 : false,
        teaserComponent: teaserComponent
    }, submitSuccess);
};
/* harmony default export */ var LeadGeneration = ((0,esm/* withTranslation */.Zh)()(LeadGen));


/***/ }),

/***/ 21137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_AssociateMembership; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/hooks/useIsSsr.js
var useIsSsr = __webpack_require__(7154);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./src/components/core/Modal/Modal.jsx + 2 modules
var Modal = __webpack_require__(2583);
// EXTERNAL MODULE: ./src/components/core/ReCaptcha/ReCaptcha.jsx + 1 modules
var ReCaptcha = __webpack_require__(15740);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./src/components/core/Checkbox/Checkbox.jsx
var Checkbox = __webpack_require__(55511);
// EXTERNAL MODULE: ./src/components/core/Input/Input.jsx
var Input = __webpack_require__(27222);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
;// CONCATENATED MODULE: ./src/components/AssociateMembership/v1/AssociateMemberShipAnalytics.js
const getEventInfo = function(isRetired, type, link) {
    let needsJSON = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    let extractedLink = "";
    if (link) {
        if (link.indexOf("http") === -1 && link.indexOf("mailto:") === -1) {
            extractedLink = window.location.origin + link;
        } else {
            extractedLink = link;
        }
    } else {
        extractedLink = "n/a";
    }
    const eventActionType = type === "don't have a kohler email?";
    const eventFor = isRetired ? "Ko" : "email";
    const eventAction = eventActionType ? "insider-program-associate-discount:group code:".concat(type) : "insider-program-associate-discount:".concat(eventFor, ":").concat(type);
    const eventInfo = {
        eventAction,
        eventName: eventAction,
        eventType: "click",
        eventMsg: "n/a",
        eventStatus: "n/a",
        formName: "kohler insider program form",
        internalLinkName: type,
        internalLinkPosition: "insider-program-associate-discount:" + (eventActionType ? "group code form" : "form"),
        internalLinkType: "insider-program-associate-discount:" + type,
        internalLinkZoneName: "insider-program-associate-discount:overlay",
        internalLinkURL: extractedLink,
        clickInternalLinks: "true"
    };
    if (needsJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};


// EXTERNAL MODULE: ./constants/regex.js
var regex = __webpack_require__(49139);
// EXTERNAL MODULE: ./src/components/AssociateMembership/v1/index.module.scss
var index_module = __webpack_require__(93720);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/components/AssociateMembership/v1/AssociateMembershipView.jsx










const AssociateMembershipView = (param)=>{
    let { i18n ={} , verifyEmail =()=>{} , isRetired =false , changeState =()=>{} , showModal =false , loading =false , legalPages ={} , verifyClockId =()=>{}  } = param;
    const [code, setCode] = (0,react.useState)("");
    const [codeError, setCodeError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [policy1Error, setPolicy1Error] = (0,react.useState)(false);
    const [policy1, setPolicy1] = (0,react.useState)(false);
    const clearError = ()=>{
        setCodeError({
            show: false,
            message: ""
        });
    };
    const { policy1Error: i18nPolicy1Error , koError , mailError , validMailError , codeErrorKO , codeError: i18nCodeError , resendCodeKOError , resendCodeEmailError , name: i18nName , description , requiredFields , codeVerification , code: i18nCode , noKohlerEmail , termsAndConditions , privacyPolicy , subjectAccessRequest , termsOfService , submit  } = i18n;
    const { privacyPolicy: legalPagesPrivacyPolicy , subjectAccessRequest: legalPagesSubjectAccessRequest , termsOfService: legalPagesTermsOfService  } = legalPages;
    const inputCodeText = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if (!showModal) {
            setCode("");
            setPolicy1(false);
            setPolicy1Error(false);
            setCodeError(false);
        }
    }, [
        showModal
    ]);
    const handleTermsPolicy = (e)=>{
        setPolicy1(e.target.checked);
        if (e.target.checked) {
            setPolicy1Error(false);
        }
    };
    const handleSubmit = async ()=>{
        clearError();
        let valid = true;
        const errorList = [];
        const setPolicy1ErrorAndPush = (message)=>{
            setPolicy1Error({
                show: true,
                message
            });
            valid = false;
            errorList.push(message);
        };
        const setCodeErrorAndPush = (message)=>{
            setCodeError({
                show: true,
                message
            });
            inputCodeText.current.focus();
            valid = false;
            errorList.push(message);
        };
        if (!policy1) {
            setPolicy1ErrorAndPush(i18nPolicy1Error);
        } else if (!code) {
            setCodeErrorAndPush(isRetired ? koError : mailError);
        } else if (!isRetired && !regex/* MEMBERSHIP_VALID_MAIL_ERROR_REGEX.test */.dd.test(code)) {
            setCodeErrorAndPush(validMailError);
        } else if (!isRetired && !regex/* MEMBERSHIP_CODE_ERROR_REGEX.test */.Vb.test(code)) {
            setCodeErrorAndPush(isRetired ? codeErrorKO : i18nCodeError);
        } else if (isRetired && code) {
            valid = "KO";
        }
        if (valid == "KO") {
            verifyClockId(code, ()=>setCodeErrorAndPush(resendCodeKOError), addSubmitAnalytics);
        } else if (valid) {
            verifyEmail(code, ()=>setCodeErrorAndPush(resendCodeEmailError), addSubmitAnalytics);
        } else {
            addSubmitAnalytics("failure", errorList.join("|"), isRetired);
        }
    };
    const handleInputChange = ()=>{
        clearError();
        changeState();
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
        const eventInfo = getEventInfo(isRetired, "don't have a kohler email?", null, true);
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page
        });
    };
    const addSubmitAnalytics = (status, message, isKO)=>{
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
        const eventInfo = {
            ...getEventInfo(isRetired, "submit", null, true),
            eventStatus: status,
            eventMsg: message ? message.toLowerCase() : "n/a",
            termsAndConditions: policy1
        };
        if (isKO) {
            // user entered KO id
            eventInfo.groupCode = code;
        }
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page
        });
    };
    const getRecaptchaAnalytics = {
        pageTitle: "insider-program-associate-discount:".concat(isRetired ? "ko" : "email"),
        internalLinkPosition: "insider-program-associate-discount:form",
        internalLinkType: "insider-program-associate-discount",
        internalLinkTypeWithType: "insider-program-associate-discount"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "associate-membership ".concat((index_module_default()).membershipStyleWrapper),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "associate-membership__header",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "associate-membership__title",
                    id: "associate-membership__title",
                    children: i18nName
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "associate-membership__description",
                id: "associate-membership__description",
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "associate-membership__description1",
                children: requiredFields
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                ref: inputCodeText,
                id: "asm-code",
                type: "text",
                value: code,
                maxLength: 40,
                placeholder: isRetired ? "".concat(codeVerification, "*") : "".concat(i18nCode, "*"),
                label: isRetired ? "".concat(codeVerification, "*") : "".concat(i18nCode, "*"),
                onChange: (e)=>setCode(e.target.value),
                showError: codeError.show,
                errorMessage: codeError.message,
                autoFocus: true,
                ariaRequried: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "associate-membership__retired",
                children: !isRetired && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "#",
                    onClick: handleInputChange,
                    children: noKohlerEmail
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "associate-membership__terms",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        checked: policy1,
                        onChange: (e)=>handleTermsPolicy(e)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: (0,helper/* sanitizeInnerHtml */.KD0)(termsAndConditions)
                    })
                ]
            }),
            policy1Error ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "associate-membership__policy-term-error",
                children: i18nPolicy1Error
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "associate-membership__button",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    role: "button",
                    type: "black",
                    flexible: true,
                    loading: loading,
                    label: submit,
                    onClick: handleSubmit
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptcha/* default */.Z, {
                getAnalyticsData: getRecaptchaAnalytics
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "associate-membership__policies",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        tabIndex: "0",
                        className: "gbh-data-layer",
                        "data-gbh-data-layer": getEventInfo(isRetired, "privacy policy", legalPagesPrivacyPolicy),
                        href: legalPagesPrivacyPolicy,
                        children: privacyPolicy
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        tabIndex: "0",
                        className: "gbh-data-layer",
                        "data-gbh-data-layer": getEventInfo(isRetired, "subject access request", legalPagesSubjectAccessRequest),
                        href: legalPagesSubjectAccessRequest,
                        children: subjectAccessRequest
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        tabIndex: "0",
                        className: "gbh-data-layer",
                        "data-gbh-data-layer": getEventInfo(isRetired, "terms of service", legalPagesTermsOfService),
                        href: legalPagesTermsOfService,
                        children: termsOfService
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var v1_AssociateMembershipView = (AssociateMembershipView);

;// CONCATENATED MODULE: ./src/components/AssociateMembership/v1/Confirm.jsx




const Confirm = (param)=>{
    let { i18n ={} , verifyCode =()=>{} , loading =false , resendCode =()=>{} , email ="" , legalPages ={}  } = param;
    const [code, setCode] = (0,react.useState)("");
    const { errorCode ="" , codeInvalidError ="" , nameConfirm ="" , descriptionConfirm ="" , description1 ="" , codeConfirm ="" , resendCodeError ="" , resendCode: i18nResendCode = "" , protectedByGoogle ="" , privacyPolicy ="" , termsOfService ="" , subjectAccessRequest =""  } = i18n;
    const { privacyPolicy: legalPagesPrivacyPolicy , subjectAccessRequest: legalPagesSubjectAccessRequest , termsOfService: legalPagesTermsOfService  } = legalPages;
    const [codeError, setCodeError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const clearError = ()=>{
        setCodeError({
            show: false,
            message: ""
        });
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        clearError();
        let valid = true;
        if (!code) {
            setCodeError({
                show: true,
                message: errorCode
            });
            valid = false;
        }
        if (valid) {
            verifyCode(code, ()=>setCodeError({
                    show: true,
                    message: codeInvalidError
                }));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "associate-membership",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "associate-membership__header",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "associate-membership__title",
                    children: nameConfirm
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "associate-membership__description",
                children: descriptionConfirm
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "associate-membership__description1",
                children: description1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                id: "code",
                type: "text",
                value: code,
                maxLength: 40,
                placeholder: "".concat(codeConfirm, "*"),
                label: "".concat(codeConfirm, "*"),
                onChange: (e)=>setCode(e.target.value),
                showError: codeError.show,
                errorMessage: codeError.message
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "associate-membership__terms",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: ()=>resendCode(email, ()=>setCodeError({
                                    show: true,
                                    message: resendCodeError
                                })),
                        children: i18nResendCode
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "associate-membership__button",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    type: "black",
                    label: "Confirm",
                    flexible: true,
                    loading: loading,
                    onClick: handleSubmit
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "my-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "protectedByGoogle",
                        children: "".concat(protectedByGoogle, " ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "policies",
                        href: legalPagesPrivacyPolicy,
                        children: privacyPolicy
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "protectedByGoogle",
                        children: " and "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "policies",
                        href: legalPagesTermsOfService,
                        children: termsOfService
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "protectedByGoogle",
                        children: " apply"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "associate-membership__policies",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: legalPagesPrivacyPolicy,
                        children: privacyPolicy
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: legalPagesSubjectAccessRequest,
                        children: subjectAccessRequest
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: legalPagesTermsOfService,
                        children: termsOfService
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var v1_Confirm = (Confirm);

// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./src/store/features/authSlice.js
var authSlice = __webpack_require__(2693);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
;// CONCATENATED MODULE: ./src/i18n/useAssociateMembershipi18n.js


const useAssociateMembershipi18n = (param)=>{
    let { authorData: { formSubhead , formRequired , insiderTermsAndConditions , formHeadline , confirmRequired , formKohlerCo , confirmSubhead , resendCodeCta , confirmHeadline , formSuccessMessage , confirmSuccessMessage , emailError , koError , formCta , confirmCta , formMemberLink , successMessage , genericError  } = {}  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const getDescription = ()=>{
        return formSubhead ? (0,helper/* sanitizeText */.oOy)(formSubhead) : t("kf.associatemembership.label.description");
    };
    const getRequiredFields = ()=>{
        return formRequired ? (0,helper/* sanitizeText */.oOy)(formRequired) : t("kf.associatemembership.label.requiredFields");
    };
    const getTermsAndConditions = ()=>{
        return insiderTermsAndConditions || t("kf.associatemembership.label.termsAndConditions");
    };
    const getTermsAndConditions1 = ()=>{
        return t("kf.associatemembership.label.termsAndConditions1");
    };
    const getPrivacyPolicy = ()=>{
        return t("kf.associatemembership.label.privacyPolicy");
    };
    const getSubjectAccessRequest = ()=>{
        return t("kf.associatemembership.label.subjectAccessRequest");
    };
    const getTermsOfService = ()=>{
        return t("kf.associatemembership.label.termsOfService");
    };
    const getCodeInvalidError = ()=>{
        return t("kf.associatemembership.label.codeInvalidError");
    };
    const getCode = ()=>{
        return t("kf.associatemembership.label.code");
    };
    const getCodeError = ()=>{
        return t("kf.associatemembership.label.codeError");
    };
    const getName = ()=>{
        return formHeadline || t("kf.associatemembership.label.name");
    };
    const getCodeVerification = ()=>{
        return formKohlerCo || t("kf.associatemembership.label.codeVerification");
    };
    const getCodeErrorKO = ()=>{
        return t("kf.associatemembership.label.codeErrorKO");
    };
    const getDescriptionConfirm = ()=>{
        return confirmSubhead ? (0,helper/* sanitizeText */.oOy)(confirmSubhead) : t("kf.associatemembership.label.descriptionConfirm");
    };
    const getCodeConfirm = ()=>{
        return t("kf.associatemembership.label.codeConfirm");
    };
    const getResendCode = ()=>{
        return resendCodeCta || t("kf.associatemembership.label.resendCode");
    };
    const getConfirmCodeError = ()=>{
        return t("kf.associatemembership.label.confirmCodeError");
    };
    const getNameConfirm = ()=>{
        return confirmHeadline || t("kf.associatemembership.label.nameConfirm");
    };
    const getSuccessMessage = ()=>{
        return formSuccessMessage ? (0,helper/* sanitizeText */.oOy)(formSuccessMessage) : t("kf.associatemembership.label.successMessage");
    };
    const getConfirmationSuccessMessage = ()=>{
        return confirmSuccessMessage ? (0,helper/* sanitizeText */.oOy)(confirmSuccessMessage) : t("kf.associatemembership.label.confirmSuccessMessage");
    };
    const getMailError = ()=>{
        return t("kf.associatemembership.label.mailError");
    };
    const getKoError = ()=>{
        return t("kf.associatemembership.label.koError");
    };
    const getErrorCode = ()=>{
        return t("kf.associatemembership.label.errorCode");
    };
    const getPolicy1Error = ()=>{
        return t("kf.keyspecifier.label.policy1Error");
    };
    const getKohlerMailError = ()=>{
        return t("kf.associatemembership.label.kohlerMailError");
    };
    const getValidMailError = ()=>{
        return t("kf.associatemembership.label.validMailError");
    };
    const getResendCodeEmailError = ()=>{
        return emailError || t("kf.associatemembership.label.resendEmailCodeError");
    };
    const getResendCodeKOError = ()=>{
        return koError || t("kf.associatemembership.label.resendKOCodeError");
    };
    const getProtectedByGoogle = ()=>{
        return t("kf.contactus.message.protectedByGoogle");
    };
    const getSubmit = ()=>{
        return formCta || t("kf.associatemembership.label.submit");
    };
    const getConfirmBtn = ()=>{
        return confirmCta || t("kf.associatemembership.label.confirmBtn");
    };
    const getTermsAndConditionLink = ()=>{
        return formMemberLink || "/";
    };
    const getConfirmFieldsRequired = ()=>{
        return confirmRequired ? (0,helper/* sanitizeText */.oOy)(confirmRequired) : t("kf.associatemembership.label.confirmFieldsRequired");
    };
    const getNoKohlerEmail = ()=>{
        return t("kf.associatemembership.label.noKohlerEmail");
    };
    const getSuccessMessage2 = ()=>{
        return successMessage !== null && successMessage !== void 0 ? successMessage : t("kf.associatemembership.label.successMessage");
    };
    const getGenericError = ()=>{
        return genericError !== null && genericError !== void 0 ? genericError : t("kf.error.message.genericError");
    };
    const getKoError2 = ()=>{
        return koError || t("kf.associatemembership.label.resendKOCodeError");
    };
    const getEmailError = ()=>{
        return emailError || t("kf.associatemembership.label.resendEmailCodeError");
    };
    const i18n = {
        description: getDescription(),
        requiredFields: getRequiredFields(),
        termsAndConditions: getTermsAndConditions(),
        termsAndConditions1: getTermsAndConditions1(),
        privacyPolicy: getPrivacyPolicy(),
        subjectAccessRequest: getSubjectAccessRequest(),
        termsOfService: getTermsOfService(),
        codeInvalidError: getCodeInvalidError(),
        code: getCode(),
        codeError: getCodeError(),
        name: getName(),
        codeVerification: getCodeVerification(),
        codeErrorKO: getCodeErrorKO(),
        descriptionConfirm: getDescriptionConfirm(),
        codeConfirm: getCodeConfirm(),
        resendCode: getResendCode(),
        confirmCodeError: getConfirmCodeError(),
        nameConfirm: getNameConfirm(),
        successMessage: getSuccessMessage(),
        confirmationSuccessMessage: getConfirmationSuccessMessage(),
        mailError: getMailError(),
        koError: getKoError(),
        errorCode: getErrorCode(),
        policy1Error: getPolicy1Error(),
        kohlerMailError: getKohlerMailError(),
        validMailError: getValidMailError(),
        resendCodeEmailError: getResendCodeEmailError(),
        resendCodeKOError: getResendCodeKOError(),
        protectedByGoogle: getProtectedByGoogle(),
        submit: getSubmit(),
        confirmBtn: getConfirmBtn(),
        termsAndConditionLink: getTermsAndConditionLink(),
        confirmFieldsRequired: getConfirmFieldsRequired(),
        noKohlerEmail: getNoKohlerEmail(),
        successMessage2: getSuccessMessage2(),
        genericError: getGenericError(),
        koError2: getKoError2(),
        emailError: getEmailError()
    };
    return i18n;
};
/* harmony default export */ var i18n_useAssociateMembershipi18n = (useAssociateMembershipi18n);

// EXTERNAL MODULE: ./src/components/FriendsAndFamily/v1/friendsAndFamilyHelper.js
var friendsAndFamilyHelper = __webpack_require__(91960);
;// CONCATENATED MODULE: ./src/components/AssociateMembership/v1/AssociateMembership.jsx


















const AssociateMembership = (props)=>{
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { isAuth , user , access_token: accessToken  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { pageIsInteractive  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { data: authorData  } = props;
    const i18n = i18n_useAssociateMembershipi18n({
        authorData
    });
    const { successMessage2 , koError2 , genericError , emailError  } = i18n;
    const [confirmModal, setConfirmModal] = (0,react.useState)(false);
    const [isRetired, setIsRetired] = (0,react.useState)(false);
    const [loading, setLoading] = (0,react.useState)(false);
    const [email, setEmail] = (0,react.useState)("");
    const [persona, setUserPersona] = (0,react.useState)("");
    const [legalPageLinks, setLegalPageLinks] = (0,react.useState)("");
    const [apiUrl, setAPIUrl] = (0,react.useState)("");
    const [showModal, setShowModal] = (0,react.useState)(false);
    const [nodeList, setNodeList] = (0,react.useState)([]);
    const [btnLoaded, setBtnLoaded] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        (0,friendsAndFamilyHelper/* redirectionToContentPage */.f)();
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(accessToken)) {
            (0,config/* getConfig */.i)().then((config)=>{
                const legalPageLinks = get_default()(config, "legalPageData", {});
                setLegalPageLinks(legalPageLinks);
            });
            (0,authSlice/* setPersona */.nf)((0,helper/* getUserPersona */.shu)());
            setAPIUrl(constants.MEMBERSHIP_API_URL_ENDPOINT);
        }
    }, [
        accessToken
    ]);
    (0,react.useEffect)(()=>{
        if (user) {
            setUserPersona((0,helper/* getUserPersona */.shu)());
        }
    }, [
        user
    ]);
    (0,react.useEffect)(()=>{
        if (!showModal) {
            setBtnLoaded(false);
        } else {
            setBtnLoaded(true);
        }
    }, [
        showModal
    ]);
    (0,react.useEffect)(()=>{
        if (!isSsr && pageIsInteractive) {
            if (!btnLoaded) {
                setTimeout(function() {
                    getNodeList();
                }, 1000);
            }
        }
    }, [
        isSsr,
        pageIsInteractive,
        btnLoaded,
        nodeList
    ]);
    const getNodeList = ()=>{
        if (document.querySelectorAll(constants.MEMBERSHIP_QUERRY_SELECTOR_URL)) {
            setNodeList(document.querySelectorAll(constants.MEMBERSHIP_QUERRY_SELECTOR_URL));
            showMembershipPopupHandler();
        }
    };
    const showAuthModal = ()=>{
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
    };
    const showMembershipPopupHandler = ()=>{
        nodeList.forEach((el)=>{
            el.addEventListener("click", (e)=>{
                e.preventDefault();
                if (isAuth) {
                    setShowModal(true);
                } else {
                    showAuthModal();
                }
            });
        });
    };
    const showToaster = (msg)=>{
        dispatch((0,genericSlice/* showToast */.CF)({
            message: msg,
            isVisible: true
        }));
    };
    const changeState = ()=>{
        setIsRetired(true);
    };
    const verifyCode = (code, cb)=>{
        const body = {
            action: "validate",
            email: email,
            code: code
        };
        setLoading(true);
        api/* apim.post */.TH.post("".concat(apiUrl), body).then(()=>{
            setLoading(false);
            setConfirmModal(false);
            setShowModal(false);
            if (persona != constants["default"].KEMP_PERSONA) {
                setUserPersona(constants["default"].KEMP_PERSONA);
                dispatch((0,authSlice/* setPersona */.nf)(constants["default"].KEMP_PERSONA));
            }
            showToaster(successMessage2);
        }).catch(()=>{
            setLoading(false);
            cb === null || cb === void 0 ? void 0 : cb();
        });
    };
    const verifyClockId = (id, cb, analyticsCB)=>{
        const body = {
            action: "validate",
            email: user.sub,
            clockId: id
        };
        setLoading(true);
        (0,ReCaptcha/* validateRecaptcha */.L)().then((res)=>{
            if (res === null || res === void 0 ? void 0 : res.success) {
                api/* apim.post */.TH.post("".concat(apiUrl), body).then(()=>{
                    setConfirmModal(true);
                    setLoading(false);
                    analyticsCB === null || analyticsCB === void 0 ? void 0 : analyticsCB("success", null, true);
                }).catch(()=>{
                    setLoading(false);
                    analyticsCB === null || analyticsCB === void 0 ? void 0 : analyticsCB("failure", koError2, true);
                    cb === null || cb === void 0 ? void 0 : cb();
                });
            } else {
                setLoading(false);
                analyticsCB === null || analyticsCB === void 0 ? void 0 : analyticsCB("failure", genericError, true);
                showToaster(genericError);
            }
        }).catch(()=>{
            analyticsCB === null || analyticsCB === void 0 ? void 0 : analyticsCB("failure", genericError, true);
        });
    };
    const verifyEmail = (email, cb, analyticsCB)=>{
        const body = {
            action: "generate",
            email: email
        };
        setLoading(true);
        (0,ReCaptcha/* validateRecaptcha */.L)().then((res)=>{
            if (res === null || res === void 0 ? void 0 : res.success) {
                api/* apim.post */.TH.post("".concat(apiUrl), body).then(()=>{
                    setEmail(email);
                    setLoading(false);
                    setConfirmModal(true);
                    analyticsCB === null || analyticsCB === void 0 ? void 0 : analyticsCB("success");
                }).catch(()=>{
                    setLoading(false);
                    analyticsCB === null || analyticsCB === void 0 ? void 0 : analyticsCB("failure", emailError);
                    cb === null || cb === void 0 ? void 0 : cb();
                });
            } else {
                setLoading(false);
                showToaster(genericError);
                analyticsCB === null || analyticsCB === void 0 ? void 0 : analyticsCB("failure", genericError);
            }
        }).catch(()=>{
            analyticsCB === null || analyticsCB === void 0 ? void 0 : analyticsCB("failure", genericError);
        });
    };
    const resendCode = (email, cb)=>{
        const body = {
            action: "generate",
            email: email
        };
        api/* apim.post */.TH.post("".concat(apiUrl), body).then(()=>{
            setConfirmModal(true);
        }).catch(()=>{
            cb();
        });
    };
    const closeModal = ()=>{
        setShowModal(false);
        setConfirmModal(false);
        setIsRetired(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
        labelledBy: "associate-membership__title",
        describedBy: "associate-membership__description",
        showModal: showModal,
        onModalClose: ()=>closeModal(),
        children: !confirmModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_AssociateMembershipView, {
            i18n: i18n,
            verifyEmail: verifyEmail,
            isRetired: isRetired,
            changeState: changeState,
            showModal: showModal,
            loading: loading,
            legalPages: legalPageLinks,
            verifyClockId: verifyClockId
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Confirm, {
            i18n: i18n,
            verifyCode: verifyCode,
            loading: loading,
            resendCode: resendCode,
            email: email,
            legalPages: legalPageLinks
        })
    });
};
/* harmony default export */ var v1_AssociateMembership = (AssociateMembership);


/***/ }),

/***/ 50481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_FindStore; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./src/store/features/locationSlice.js
var locationSlice = __webpack_require__(13644);
// EXTERNAL MODULE: ./src/utils/location.js
var utils_location = __webpack_require__(78800);
// EXTERNAL MODULE: ./src/components/FindStore/v1/analytics.js
var analytics = __webpack_require__(82423);
// EXTERNAL MODULE: ./src/i18n/useFindStorei18n.js
var useFindStorei18n = __webpack_require__(95511);
// EXTERNAL MODULE: ./src/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(18216);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/react-bingmaps/lib/index.js
var react_bingmaps_lib = __webpack_require__(20604);
// EXTERNAL MODULE: ./src/components/core/Collapsible/index.js
var Collapsible = __webpack_require__(73394);
// EXTERNAL MODULE: ./src/components/core/Checkbox/Checkbox.jsx
var Checkbox = __webpack_require__(55511);
// EXTERNAL MODULE: ./public/icons/filter.svg
var filter = __webpack_require__(24495);
// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(653);
;// CONCATENATED MODULE: ./src/components/FindStore/v1/Filter.jsx










const Filter = (props)=>{
    const { texts ={} , onFilter =()=>{} , showFilter =false , close =()=>{} , selectedFilterCount ="" , facets ={} , locationRef =""  } = props;
    const filterRef = (0,react.useRef)(null);
    const [collapse, setCollapse] = (0,react.useState)({});
    const [appliedFilters, setAppliedFilters] = (0,react.useState)([]);
    const formatFacetName = (name, filter)=>{
        let val = name.replace(/\./g, "/").replace(/_/g, " ").replace(/^\*{2}/, "");
        if (filter) val += " - ".concat(filter);
        return val;
    };
    const facetFilter = (arr, obj)=>{
        return arr.find((filter)=>filter.facet === obj.facet);
    };
    const isSelected = (obj)=>{
        const facet = facetFilter(appliedFilters, obj);
        if (!facet) return false;
        return facet.display.includes(obj.display);
    };
    const handleFilter = (checked, obj, isFilterCancel)=>{
        let curFilters = [
            ...appliedFilters
        ];
        const facet = facetFilter(curFilters, obj);
        if (checked) {
            if (facet) {
                facet.value.push(obj.value.replace(/"/g, '\\"'));
                facet.display.push(obj.value);
                facet.query.push(obj.query);
            } else curFilters.push({
                facet: obj.facet,
                value: [
                    obj.value.replace(/"/g, '\\"')
                ],
                display: [
                    obj.value
                ],
                query: [
                    obj.query
                ]
            });
        } else {
            const index = facet.display.indexOf(obj.value);
            facet.value.splice(index, 1);
            facet.display.splice(index, 1);
            facet.query.splice(index, 1);
            if (!facet.value.length) {
                curFilters = curFilters.filter((f)=>f.facet !== obj.facet);
            }
        }
        setAppliedFilters(curFilters);
        (0,analytics/* addAnalyticsData */.OQ)(curFilters, checked, obj, isFilterCancel);
        onFilter(curFilters, true);
    };
    const handleCollapse = (facet, state)=>{
        setCollapse((prevCollapse)=>({
                ...prevCollapse,
                [facet]: state
            }));
        (0,analytics/* addFilterExpandCollapseAnalytics */.wo)(facet, formatFacetName(facet), {
            [facet]: state
        });
    };
    const clearAllFilters = ()=>{
        setAppliedFilters([]);
        onFilter([], true);
    };
    (0,react.useEffect)(()=>{
        if (showFilter) {
            window.addEventListener("keydown", handleKeyPress);
        }
        if (lib/* isMobile */.tq && window.innerWidth < 1024) {
            (0,helper/* preventBodyScroll */.MVu)(showFilter);
        }
        return ()=>{
            window.removeEventListener("keydown", handleKeyPress);
            (0,helper/* preventBodyScroll */.MVu)(false);
        };
    }, [
        showFilter
    ]);
    /**
   *
   * @param {Event} e
   */ const handleKeyPress = (e)=>{
        var ref;
        const focusElements = '[tabindex]:not([tabindex="-1"])';
        const focusContent = (ref = filterRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll(focusElements);
        const lastElem = focusContent[focusContent.length - 1];
        if (e.key === "Tab" && !e.shiftKey && document.activeElement === lastElem) {
            var ref1;
            e.preventDefault();
            (ref1 = locationRef.current) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("filter", "filter--show-less"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "filter__inner-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-list__controls filter__mobile-header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "product-list__filter-toggle",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        "aria-hidden": true,
                                        role: "presentation",
                                        src: filter/* default */.Z === null || filter/* default */.Z === void 0 ? void 0 : filter/* default.src */.Z.src,
                                        className: "product-list__filter-toggle-icon",
                                        alt: "Toggle Filter"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: texts.filters
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                role: "button",
                                tabIndex: "0",
                                src: icons_close/* default */.Z === null || icons_close/* default */.Z === void 0 ? void 0 : icons_close/* default.src */.Z.src,
                                className: "product-list__close-icon",
                                alt: "Close Filter",
                                onClick: ()=>close(false)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "filter__chips",
                        children: [
                            appliedFilters.map((facet)=>{
                                return facet.display.map((filter)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                        className: "filter__chips-tag",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: filter
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                role: "button",
                                                tabIndex: "0",
                                                src: icons_close/* default */.Z === null || icons_close/* default */.Z === void 0 ? void 0 : icons_close/* default.src */.Z.src,
                                                alt: "Close",
                                                className: "filter__chips-close-icon",
                                                onClick: ()=>handleFilter(false, {
                                                        facet: facet.facet,
                                                        value: filter,
                                                        query: filter
                                                    }, true)
                                            })
                                        ]
                                    }, filter);
                                });
                            }),
                            appliedFilters.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "filter__chips-clear-all gbh-data-layer",
                                "data-gbh-data-layer": (0,analytics/* getEventClearFilterInfo */.dm)(),
                                onClick: clearAllFilters,
                                role: "button",
                                tabIndex: "0",
                                "aria-label": texts.clearAll,
                                children: texts.clearAll
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "kf-store-filter",
                        ref: filterRef,
                        children: Object.entries(facets).map((facet)=>{
                            const facetName = facet[0];
                            const facetCount = facet[1].length;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapsible/* default */.Z, {
                                open: collapse[facet[0]],
                                onTriggerOpening: ()=>handleCollapse(facet[0], true),
                                onTriggerClosing: ()=>handleCollapse(facet[0], false),
                                openedClassName: "is-open",
                                trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    role: "list",
                                    tabIndex: "0",
                                    "aria-label": "".concat(collapse[facet[0]] ? texts.expanded : texts.collapsed, " ").concat(texts.filterTitle(facetName, facetCount), ")}"),
                                    className: "gbh-data-layer",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            "aria-hidden": "true",
                                            children: formatFacetName(facet[0])
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                            className: "plus",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "line-1 line"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "line line-2"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                transitionTime: 400,
                                easing: "ease-in-out",
                                children: facet[1].map((filter)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        id: facet[0] + filter.label,
                                        value: filter.label,
                                        onChange: (e)=>handleFilter(e.target.checked, {
                                                facet: formatFacetName(facet[0]),
                                                value: filter.label,
                                                query: filter.query
                                            }),
                                        checked: isSelected({
                                            facet: formatFacetName(facet[0]),
                                            display: filter.label,
                                            query: filter.query
                                        }),
                                        tabIndex: collapse[facet[0]] ? 0 : -1,
                                        checkBoxAria: filter.label
                                    }, filter.label))
                            }, facet[0]);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "filter__footer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: classnames_default()("filter__apply", appliedFilters.length > 0 && "filter__apply--active"),
                    disabled: appliedFilters.length < 1,
                    onClick: ()=>close(false),
                    children: selectedFilterCount > 0 && appliedFilters.length > 0 ? "".concat(texts.view, " ").concat(texts.results, " (").concat(selectedFilterCount, ")") : texts.viewResults
                })
            })
        ]
    });
};
/* harmony default export */ var v1_Filter = (Filter);

// EXTERNAL MODULE: ./components/core/AutoSuggestion/v1/AutoSuggestion.jsx
var AutoSuggestion = __webpack_require__(36130);
// EXTERNAL MODULE: ./src/components/FindStore/v1/FindStoreLanding.View/index.module.scss
var index_module = __webpack_require__(5693);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/components/FindStore/v1/StoreList.jsx








const StoreList = (param)=>{
    let { data ={} , active =false , staticTexts ={} , findStoreDetails ={} , findStoreCheckedId ="" , handleFindStoreCheck =()=>{} , index ="" , tabName  } = param;
    var ref;
    const { LocationName ="" , AddressLine ="" , AddressLine2 ="" , Locality ="" , AdminDistrict ="" , Latitude =0 , Longitude =0 , LocationType ="" , travelDistance =0 , BPnumber ="" , Phone ="" , EntityID ="" , OpenUntil ="" , PostalCode =""  } = data;
    const { kohlerStore  } = staticTexts;
    const [bpnumberURL, setBPnumberURL] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,helper/* getShortenedUrl */.Ppy)(findStoreDetails[BPnumber]).then((res)=>{
            setBPnumberURL(res);
        });
    }, [
        BPnumber
    ]);
    var _BPnumber;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "store-list ".concat(active && "store-list--active"),
        role: "listitem",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-8 col-md-4 store-list__name-col px-0",
                        children: LocationType.toLowerCase() !== ((ref = constants.LOCATIONSCONST.LocationType) === null || ref === void 0 ? void 0 : ref.toLowerCase()) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "store-list__name store-list__genuine-dealers gbh-data-layer",
                            children: LocationName
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: bpnumberURL !== null && bpnumberURL !== void 0 ? bpnumberURL : "/",
                            className: "store-list__name gbh-data-layer",
                            "data-gbh-data-layer": (0,analytics/* getEventStoreFilterInfo */.hE)(data, "store name", (_BPnumber = findStoreDetails[data.BPnumber]) !== null && _BPnumber !== void 0 ? _BPnumber : "/"),
                            children: LocationName
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 col-md-4 store-list__address-col px-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "store-list__address",
                                children: !lib/* isMobile */.tq ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: AddressLine
                                        }),
                                        isEmpty_default()(AddressLine2) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: AddressLine2
                                        }) : "",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "".concat(Locality, ",").concat(AdminDistrict, " ").concat(PostalCode)
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: lib/* isIOS */.gn === true ? "maps://maps.google.com/maps?daddr=".concat(Latitude, ",").concat(Longitude, "&amp;ll=") : "http://www.google.com/maps?q=".concat(Latitude, ",").concat(Longitude),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: AddressLine
                                        }),
                                        isEmpty_default()(AddressLine2) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: AddressLine2
                                        }) : "",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "".concat(Locality, ",").concat(AdminDistrict, " ").concat(PostalCode)
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "tel:+".concat(Phone),
                                className: "store-list__phone",
                                onClickCapture: ()=>(0,analytics/* getEventStorePhoneInfo */.rt)(Phone, tabName),
                                children: (0,helper/* formatPhoneNumber */.unW)(Phone)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-3 col-md-2 store-list__distance-col px-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "store-list__distance",
                                children: "".concat(travelDistance.toFixed(1), " mi")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "store-list__time",
                                children: OpenUntil
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-7 px-0",
                        children: LocationType === kohlerStore.toLowerCase() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "store-list__set-store",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                id: "store-list__set-store_".concat(index),
                                checked: findStoreCheckedId === EntityID,
                                value: findStoreCheckedId === EntityID ? staticTexts.myStore : staticTexts.setAsMyStore,
                                onChange: (e)=>{
                                    handleFindStoreCheck(e.target.checked ? EntityID : 0);
                                    (0,analytics/* setStoreAnalytics */.LX)(e.target.checked, LocationName);
                                }
                            })
                        }) : null
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-5 px-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "store-list__set-store-time",
                            children: OpenUntil
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var v1_StoreList = (StoreList);

// EXTERNAL MODULE: ./src/components/core/Modal/ZipCodeInfoModal.jsx
var ZipCodeInfoModal = __webpack_require__(4801);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
;// CONCATENATED MODULE: ./src/components/FindStore/v1/FindStoreLanding.View/FindStoreLanding.jsx



















const FindStoreLanding = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const { staticTexts ={} , brandData ={} , handleChange =()=>{} , facets =[] , searchTerm ="" , getGeoLocation =()=>{} , tabList =[] , // getStoreDetails = () => {},
    findStoreDetails ={} , findStoresBingKey ="" , selectedFilterCount ="" , totalResults ="" , citySuggestData ={} , handleFindStoreCheck =()=>{} , findStoreCheckedId ="" , infoModal =false , infoModalError ={} , authorData ={} , setInfoModalClose =()=>{} , latitude =0 , longitude =0 , locationRef ="" , tabChangeListener =()=>{} , loadMoreHandler =()=>{} , loadingState =false , applySelectedFilters =()=>{}  } = props;
    const prevShowFilter = (0,react.useRef)(false);
    const { isLandscape  } = props;
    const [width] = (0,useWindowResize/* default */.Z)();
    const [showFilter, setShowFilter] = (0,react.useState)(false);
    const [showMap, setShowMap] = (0,react.useState)(false);
    const [curStore] = (0,react.useState)(null);
    const [browseAllStoreUrl, setBrowseAllStoreUrl] = (0,react.useState)("");
    const [activeTab, setActiveTab] = (0,react.useState)(0);
    const [mapInfo, setMapInfo] = (0,react.useState)([]);
    const [center, setCenter] = (0,react.useState)([
        latitude,
        longitude
    ]);
    const [locationMessage, setlocationMessage] = (0,react.useState)("");
    const filterClass = classnames_default()({
        "find-store-landing__filter": true,
        "pl-0": lib/* isMobile */.tq ? false : !showFilter,
        "find-store-landing__filter--hide": !showFilter,
        "find-store-landing__filter--modal": lib/* isMobile */.tq ? showFilter : false
    });
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then(async (config)=>{
            const browseAllStoreUrl = await (0,helper/* getShortenedUrl */.Ppy)((staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.ctaLink) || get_default()(config, "general.allStoresPagePath", "") || "/");
            setBrowseAllStoreUrl(browseAllStoreUrl);
        });
    }, []);
    const { locationErrormessage ="" , kohlerStore ="" , showrooms ="" , partsDealer ="" , countryPlaceholder ="" , ariaLabel ={
        hideFilter: "",
        showFilter: "",
        enterZipcode: "",
        browseAll: "",
        mapGuidelines: "",
        mapMarker: ""
    } , userMyLocation ="" , viewList ="" , viewMap ="" , browseAllStore =""  } = staticTexts;
    (0,react.useEffect)(()=>{
        (0,helper/* getShortenedUrl */.Ppy)(locationErrormessage).then((res)=>{
            setlocationMessage(res);
        });
    }, []);
    const { loadMoreStore =""  } = authorData;
    const activePins = {
        0: {
            text: kohlerStore,
            icon: tabList[0].icon
        },
        1: {
            text: showrooms,
            icon: tabList[1].icon
        },
        2: {
            text: partsDealer,
            icon: tabList[2].icon
        }
    };
    // using let variables as we don't need to re-render dom on getting value for this variables.
    let zoomInButton;
    let zoomOutButton;
    let locateMeButton;
    (0,react.useEffect)(()=>{
        if (showFilter) {
            var ref, ref1, ref2;
            ((ref = document.getElementById("kf-store-filter")) === null || ref === void 0 ? void 0 : ref.childNodes) && ((ref2 = (ref1 = document.getElementById("kf-store-filter").childNodes[0]) === null || ref1 === void 0 ? void 0 : ref1.querySelector('[tabindex="0"]')) === null || ref2 === void 0 ? void 0 : ref2.focus());
        }
        if ((prevShowFilter === null || prevShowFilter === void 0 ? void 0 : prevShowFilter.current) !== showFilter) {
            (0,analytics/* getFilterEventInfo */.Us)(showFilter);
            prevShowFilter.current = showFilter;
        }
    }, [
        showFilter
    ]);
    (0,react.useEffect)(()=>{
        var ref, ref1;
        const pins = getPinsBasedOnTab(activeTab);
        var ref2;
        const activeData = (ref2 = (ref = brandData[tabList[activeTab].key]) === null || ref === void 0 ? void 0 : ref.data) !== null && ref2 !== void 0 ? ref2 : [];
        const changedLatitude = activeData.length ? activeData[0].Latitude : latitude;
        const changedLongitude = activeData.length ? activeData[0].Longitude : longitude;
        if (changedLatitude !== 0) setCenter([
            changedLatitude,
            changedLongitude
        ]);
        setMapInfo(pins);
        (ref1 = window.wow) === null || ref1 === void 0 ? void 0 : ref1.sync();
    }, [
        activeTab,
        latitude,
        longitude
    ]);
    const changeTab = (tab)=>{
        setActiveTab(tab);
        tabChangeListener(tab);
    };
    (0,react.useEffect)(()=>{
        const aemBreadCrumb = document.getElementById("find-store-breadcrumb");
        if (aemBreadCrumb) {
            aemBreadCrumb.parentNode.style.display = "none";
            document.getElementById("find-store-crumb").appendChild(aemBreadCrumb);
        }
    }, []);
    const handleKeyPress = (e)=>{
        const { keyCode  } = e;
        const { LEFTARROW , RIGHTARROW  } = constants.FINDLOCATIONKEYCODE;
        if (keyCode === LEFTARROW || keyCode === RIGHTARROW) {
            let tab;
            if (keyCode === LEFTARROW) {
                tab = activeTab - 1;
            } else if (keyCode === RIGHTARROW) {
                tab = activeTab + 1;
            }
            if (tab < 0) tab = tabList.length - 1;
            if (tab >= tabList.length) tab = 0;
            document.getElementById("find-store__".concat(tabList[tab].key.toLowerCase(), "--tab")).focus();
        }
    };
    (0,react.useEffect)(()=>{
        /**
     * These buttons are from a react-bigmaps library.
     * We don't get any events on click of zoom in and out buttons floating over right top side of map
     * so need javascript to add events
     */ if (!window.isZoomButtonLoaded && window.adobeDataLayer && !isEmpty_default()(findStoresBingKey)) {
            addClickEventOnMap();
        }
        return ()=>{
            zoomOutButton && zoomOutButton.removeEventListener("click", handleMapZoomOutClick);
            zoomInButton && zoomInButton.removeEventListener("click", handleMapZoomInClick);
            locateMeButton && locateMeButton.removeEventListener("click", handleMapLocateMeClick);
            delete window.isZoomButtonLoaded;
        };
    }, [
        findStoresBingKey
    ]);
    const getPinsBasedOnTab = (tab)=>{
        var ref;
        let pins = [];
        const currentTab = tab ? tab : activeTab;
        var ref1;
        const pinsBasedOnActiveTab = (ref1 = (ref = brandData[tabList[activeTab].key]) === null || ref === void 0 ? void 0 : ref.data) !== null && ref1 !== void 0 ? ref1 : [];
        if (pinsBasedOnActiveTab.length) {
            pins = pinsBasedOnActiveTab.map((store)=>{
                const icon = activePins[currentTab].icon || tabList[2].icon;
                return {
                    location: [
                        store === null || store === void 0 ? void 0 : store.Latitude,
                        store === null || store === void 0 ? void 0 : store.Longitude
                    ],
                    option: {
                        icon: icon
                    }
                };
            });
        }
        return pins;
    };
    const addClickEventOnMap = ()=>{
        setTimeout(()=>{
            if (!window.isZoomButtonLoaded) {
                zoomInButton = document.getElementById("ZoomInButton");
                if (zoomInButton) {
                    window.isZoomButtonLoaded = true;
                    zoomInButton.addEventListener("click", handleMapZoomInClick);
                    zoomOutButton = document.getElementById("ZoomOutButton");
                    locateMeButton = document.getElementById("LocateMeButton");
                    if (zoomOutButton) {
                        zoomOutButton.addEventListener("click", handleMapZoomOutClick);
                    }
                    if (locateMeButton) {
                        locateMeButton.addEventListener("click", handleMapLocateMeClick);
                    }
                } else {
                    // redundant call to self as we need to wait till map zoom buttons are getting loaded.
                    addClickEventOnMap();
                }
            }
        }, 3000) // we need this timeout as it always take time to load buttons on map
        ;
    };
    const handleMapZoomInClick = ()=>{
        (0,analytics/* addAnalyticsEvent */.X1)("in");
    };
    const handleMapZoomOutClick = ()=>{
        (0,analytics/* addAnalyticsEvent */.X1)("out");
    };
    const handleMapLocateMeClick = ()=>{
        (0,analytics/* addAnalyticsEvent */.X1)("locate me", true);
    };
    (0,react.useEffect)(()=>{
        if (brandData === null || brandData === void 0 ? void 0 : brandData.needTOReloadTabs) {
            setActiveTab(0);
        }
    }, [
        brandData === null || brandData === void 0 ? void 0 : brandData.needTOReloadTabs
    ]);
    const isBrandDataEmpty = ()=>{
        if (!isEmpty_default()(brandData)) {
            const isBrandDataContainsAnyData = Object.keys(brandData).filter((key)=>{
                var ref;
                return (ref = brandData[key].data) === null || ref === void 0 ? void 0 : ref.length;
            });
            return isBrandDataContainsAnyData === null || isBrandDataContainsAnyData === void 0 ? void 0 : isBrandDataContainsAnyData.length;
        }
        return false;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).findStoreLandingWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "find-store-landing",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ZipCodeInfoModal/* default */.Z, {
                    handleModalClose: ()=>{
                        setInfoModalClose();
                    },
                    show: infoModal,
                    data: infoModalError,
                    store: true,
                    staticTexts: staticTexts,
                    labelledBy: "Geo-Location-store-error-message",
                    className: "message-modal"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row ml-0 mr-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                id: "find-store-crumb",
                                className: "find-store-landing__breadcrumb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: filterClass,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "find-store-landing__filter-panel",
                                    children: showFilter ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Filter, {
                                        facets: facets,
                                        close: (isShow)=>setShowFilter(isShow),
                                        onFilter: (curFilters)=>applySelectedFilters(curFilters, activeTab),
                                        displayShare: false,
                                        texts: staticTexts,
                                        selectedFilterCount: selectedFilterCount,
                                        totalResults: totalResults,
                                        showFilter: showFilter,
                                        locationRef: locationRef
                                    }) : null
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "find-store-landing__result-container ".concat(lib/* isMobile */.tq ? width >= 992 ? showFilter ? " " : " find-store-landing__result-full" : " col-12" : showFilter ? " " : " find-store-landing__result-full"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-lg-5 find-store-landing__search-container ".concat(showMap ? lib/* isMobile */.tq && (lib/* isTablet */.Em || isLandscape) ? "col-5" : "col-12" : "col-12"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "find-store-landing__search",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoSuggestion/* default */.Z, {
                                                        placeholderLabel: countryPlaceholder,
                                                        selectedValue: searchTerm,
                                                        handleChange: (selectedVal)=>handleChange(selectedVal),
                                                        handleSelect: (selectedVal)=>handleChange(selectedVal),
                                                        optionList: citySuggestData,
                                                        borderValue: "bottom",
                                                        suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            role: "button",
                                                            tabIndex: "0",
                                                            "aria-label": showFilter ? ariaLabel.hideFilter : ariaLabel.showFilter,
                                                            src: filter/* default */.Z === null || filter/* default */.Z === void 0 ? void 0 : filter/* default.src */.Z.src,
                                                            alt: ariaLabel.showFilter,
                                                            onClick: ()=>setShowFilter(!showFilter),
                                                            ariaLabel: ariaLabel.enterZipcode,
                                                            id: "find-store-landing__search-auto-suggest"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    role: "button",
                                                    tabIndex: "0",
                                                    id: "kf-store-use-location",
                                                    className: "find-store-landing__use-location",
                                                    onClick: ()=>getGeoLocation(userMyLocation),
                                                    ref: locationRef,
                                                    children: userMyLocation
                                                }),
                                                width <= 992 ? !showMap ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    role: "button",
                                                    tabIndex: "0",
                                                    className: "find-store-landing__view-list",
                                                    onClick: ()=>setShowMap(!showMap),
                                                    children: viewMap
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    role: "button",
                                                    tabIndex: "0",
                                                    className: "find-store-landing__view-list",
                                                    onClick: ()=>setShowMap(!showMap),
                                                    children: viewList
                                                }) : null,
                                                !showMap ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                    children: [
                                                        isBrandDataEmpty() && !isEmpty_default()(searchTerm) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "find-store-landing__tabs wow animate__fadeInUp",
                                                            role: "tablist",
                                                            children: tabList.map((tab, i)=>{
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                    className: "find-store-landing__tab gbh-data-layer ".concat(activeTab === i ? "find-store-landing__tab--active" : ""),
                                                                    "data-gbh-data-layer": (0,analytics/* getStoreEventInfo */.B8)("inner tabs", tab.title),
                                                                    onClick: ()=>changeTab(i),
                                                                    onKeyDown: handleKeyPress,
                                                                    role: "tab",
                                                                    tabIndex: 0,
                                                                    "aria-selected": activeTab === i,
                                                                    id: "find-store__".concat(tab.key.toLowerCase(), "--tab"),
                                                                    children: tab.title
                                                                }, i);
                                                            })
                                                        }) : null,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            role: "list",
                                                            className: "find-store-landing__list ".concat(((ref = brandData[tabList[activeTab].key]) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.length) ? "find-store-landing__show-list" : "", " ").concat(tabList[activeTab].key !== kohlerStore ? "find-store-landing__list-mb" : ""),
                                                            children: !isEmpty_default()(brandData) && ((ref2 = brandData[tabList[activeTab].key]) === null || ref2 === void 0 ? void 0 : ref2.data.length) ? (ref3 = brandData[tabList[activeTab].key]) === null || ref3 === void 0 ? void 0 : ref3.data.map((store, i)=>{
                                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(v1_StoreList, {
                                                                    data: store,
                                                                    index: i,
                                                                    activeTab: activeTab,
                                                                    staticTexts: staticTexts,
                                                                    active: (curStore === null || curStore === void 0 ? void 0 : curStore.EntityID) === store.EntityID ? true : false,
                                                                    findStoreDetails: findStoreDetails,
                                                                    handleFindStoreCheck: handleFindStoreCheck,
                                                                    findStoreCheckedId: findStoreCheckedId,
                                                                    isChecked: Boolean(findStoreCheckedId),
                                                                    tabName: tabList[activeTab].title
                                                                }, i);
                                                            }) : !isEmpty_default()(brandData) && !loadingState ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "find-store-landing__message ".concat(((ref4 = brandData[tabList[activeTab].key]) === null || ref4 === void 0 ? void 0 : ref4.data.length) ? "find-store-landing__store-message" : ""),
                                                                children: (0,helper/* sanitizeInnerHtml */.KD0)(!searchTerm ? locationMessage : authorData.nostoresavailable, {
                                                                    replace: (domNode)=>{
                                                                        const { type ="" , name ="" , attribs ={} , attribs: { href =""  } = {} , children =[]  } = domNode;
                                                                        if (type === "tag" && name === "a") {
                                                                            attribs.onClick = ()=>{
                                                                                var ref, ref1;
                                                                                (0,analytics/* locationMessageNavigationAnalytics */.HS)({
                                                                                    link: href,
                                                                                    label: (ref = children[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(),
                                                                                    zone: "landing:location info"
                                                                                });
                                                                            };
                                                                        }
                                                                    }
                                                                })
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: "Loading..."
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "find-store-browseall-div",
                                                            children: [
                                                                !((ref5 = brandData[tabList[activeTab].key]) === null || ref5 === void 0 ? void 0 : ref5.isAllLoaded) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                        label: !loadingState ? loadMoreStore : "Loading...",
                                                                        size: "large",
                                                                        type: "ghost",
                                                                        role: "link",
                                                                        "aria-label": ariaLabel.browseAll,
                                                                        className: "gbh-data-layer",
                                                                        onClick: (e)=>{
                                                                            e.preventDefault();
                                                                            loadMoreHandler(activeTab);
                                                                        }
                                                                    })
                                                                }) : null,
                                                                tabList[activeTab].key === kohlerStore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                    label: browseAllStore,
                                                                    size: "large",
                                                                    type: "ghost",
                                                                    role: "link",
                                                                    "aria-label": ariaLabel.browseAll,
                                                                    className: "gbh-data-layer",
                                                                    to: browseAllStoreUrl,
                                                                    "data-gbh-data-layer": (0,analytics/* getStoreEventInfo */.B8)("browse all stores", null, browseAllStoreUrl)
                                                                }) : null
                                                            ]
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "find-store-landing__map ".concat(showMap ? width <= 992 ? lib/* isTablet */.Em || isLandscape ? "col-7 find-store-landing__show-map" : "col-12 find-store-landing__show-map" : "col-7" : "col-7", " wow animate__fadeInUp"),
                                            children: [
                                                !isEmpty_default()(findStoresBingKey) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_bingmaps_lib/* ReactBingmaps */.a, {
                                                    bingmapKey: findStoresBingKey,
                                                    center: center,
                                                    mapTypeId: "grayscale",
                                                    disableStreetside: true,
                                                    navigationBarMode: "square",
                                                    zoom: 12,
                                                    mapOptions: {
                                                        showMapTypeSelector: false,
                                                        NavigationBarMode: "square"
                                                    },
                                                    pushPins: mapInfo
                                                }, mapInfo) : null,
                                                findStoresBingKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "find-store-landing__location-note",
                                                    "aria-label": ariaLabel.mapGuidelines,
                                                    children: tabList ? tabList.map((tab, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    role: "presentation",
                                                                    "aria-label": ariaLabel.mapMarker,
                                                                    src: tab.icon,
                                                                    alt: "",
                                                                    className: "img-fluid"
                                                                }),
                                                                lib/* isMobile */.tq ? tab.locationNoteMobile : tab.locationNote
                                                            ]
                                                        }, i)) : null
                                                }) : null
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var FindStoreLanding_View_FindStoreLanding = (FindStoreLanding);

// EXTERNAL MODULE: ./public/icons/locator-big-chacrol.svg
var locator_big_chacrol = __webpack_require__(59537);
// EXTERNAL MODULE: ./public/icons/locator-big-red.svg
var locator_big_red = __webpack_require__(38015);
// EXTERNAL MODULE: ./public/icons/locator-big-green.svg
var locator_big_green = __webpack_require__(18146);
// EXTERNAL MODULE: ./src/components/FindStore/v1/api.js
var v1_api = __webpack_require__(75058);
;// CONCATENATED MODULE: ./src/components/FindStore/v1/FindStore.jsx




















const FindStore = (props)=>{
    const { data: authorData  } = props;
    const staticTexts = (0,useFindStorei18n/* default */.Z)({
        authorData
    });
    const { distanceMiles =0 , maxStorePerPage =10  } = authorData;
    const { myStoreId , browseLocationsStoreFilterData , findAStoreSearchEvent  } = (0,es/* useSelector */.v9)(locationSlice/* locationState */._n);
    const [searchTerm, setSearchTerm] = (0,react.useState)("");
    const [brandStoreShowroomOrDealersData, setBrandStoreShowroomOrDealersData] = (0,react.useState)({});
    const [latitude, setLatitude] = (0,react.useState)(0);
    const [longitude, setLongitude] = (0,react.useState)(0);
    const [findStoreDetails, setFindStoreDetails] = (0,react.useState)({});
    const [findStoreFilterData] = (0,react.useState)(get_default()(browseLocationsStoreFilterData, "storefilter", {}));
    const [citySuggestData, setCitySuggestData] = (0,react.useState)([]);
    var ref;
    const [findStoreCheckedId, setFindStoreCheckedId] = (0,react.useState)((ref = localStorage.getItem("myStoreId")) !== null && ref !== void 0 ? ref : 0);
    const [infoModal, setInfoModal] = (0,react.useState)(false);
    const [infoModalError, setinfoModalError] = (0,react.useState)({});
    const [info, setInfo] = (0,react.useState)({});
    const [loadingState, setLoadingState] = (0,react.useState)(true);
    const [geolocationEvent, setGeolocationEvent] = (0,react.useState)(false);
    const dispatch = (0,es/* useDispatch */.I0)();
    const locationRef = (0,react.useRef)(null);
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then(async (config)=>{
            const locale = get_default()(config, "internationalization.locale", "");
            const currencySign = get_default()(config, "internationalization.currencySign", "");
            const currencyCode = get_default()(config, "internationalization.currencyCode", "");
            const findStoreDetailsUrl = get_default()(config, "general.storeDetailsServletPath", "");
            const findStores = get_default()(config, "apiEndPointData.findStores", "");
            const reverseGeo = get_default()(config, "apiEndPointData.reverseGeo", "");
            const findStoresBingKey = get_default()(config, "apiEndPointData.findStoresBingKey", "");
            const siteName = get_default()(config, "general.siteName", "");
            const info = {
                locale: locale,
                currencySign: currencySign,
                currencyCode: currencyCode,
                findStores: findStores,
                reverseGeo: reverseGeo,
                findStoresBingKey: findStoresBingKey,
                siteName: siteName,
                findStoreDetailsUrl: findStoreDetailsUrl
            };
            setInfo(info);
            (0,api/* aemAxiosInstance */.Gb)({
                url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: findStoreDetailsUrl
                }
            }).then((response)=>{
                if (response && response.data) {
                    setFindStoreDetails(response.data);
                }
            }).catch((err)=>{
                console.log("Failed to get compare attributes JSON file", err);
            });
        });
    }, []);
    const { findStores =""  } = info;
    (0,react.useEffect)(()=>{
        const urlSearchTerm = router.query.q;
        if (urlSearchTerm !== undefined) {
            setSearchTerm(urlSearchTerm);
            localStorage.setItem("searchTerm", urlSearchTerm);
        } else {
            setSearchTerm((localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("currentZipCode")) || "");
            localStorage.removeItem("searchTerm");
        }
    }, [
        router.query.q
    ]);
    (0,react.useEffect)(()=>{
        if (myStoreId !== findStoreCheckedId) {
            localStorage.setItem("myStoreId", myStoreId);
            setFindStoreCheckedId(myStoreId);
        }
    }, [
        myStoreId
    ]);
    (0,react.useEffect)(()=>{
        if (myStoreId !== 0 && !isEmpty_default()(info)) {
            getUtilityDataById();
        } else {
            dispatch((0,locationSlice/* setStoreAddress */.wf)({}));
        }
    }, [
        myStoreId,
        info
    ]);
    const getUtilityDataById = async ()=>{
        const utilityData = await (0,utils_location/* getStoreDataById */.e)({
            myStoreId: myStoreId,
            findStores: findStores,
            siteName: info.siteName
        });
        dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData));
    };
    (0,react.useEffect)(()=>{
        if (searchTerm && findStores) {
            debouncedFetchData(searchTerm, info, findAStoreSearchEvent, geolocationEvent);
        }
    }, [
        searchTerm,
        info,
        findAStoreSearchEvent,
        geolocationEvent
    ]);
    const debouncedFetchData = (0,react.useCallback)(debounce_default()((keyword, infoval, findAStoreSearchEvt, geolocationEvent)=>{
        getStoreDetails({
            isAutoComplete: true,
            preventUnwantedDataLayer: !findAStoreSearchEvt,
            type: "",
            info: infoval,
            key: keyword,
            activeTab: 0,
            page: 1,
            needCallToSuggestionAPI: true,
            geolocationEvent
        });
        setUrlParam(keyword);
    }, 2000), []);
    const resetBrandData = function() {
        let needToReturn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        const brandData = {
            ...brandStoreShowroomOrDealersData
        };
        const tabKeys = tabList.map((item)=>item.key);
        tabKeys.forEach((item)=>{
            brandData[item] = {
                data: [],
                isAllLoaded: true,
                page: 0
            };
        });
        if (needToReturn) return brandData;
        setBrandStoreShowroomOrDealersData(brandData);
    };
    const getGeoLocation = (type)=>{
        var ref;
        setGeolocationEvent(true);
        (0,helper/* getMyLocation */.fPm)().then((getLocation)=>{
            var _zipcode;
            setSearchTerm((_zipcode = getLocation.zipcode) !== null && _zipcode !== void 0 ? _zipcode : "");
        }).catch((param)=>{
            let { cause  } = param;
            var ref;
            (0,analytics/* addFindAStoreAnalytics */.DO)({
                action: "cmp:click",
                status: "failure",
                total: 0,
                authorData,
                type,
                searchTerm,
                geolocationEvent: true,
                errorMessage: (ref = cause === null || cause === void 0 ? void 0 : cause.message) !== null && ref !== void 0 ? ref : ""
            });
            setinfoModalError(cause !== null && cause !== void 0 ? cause : {});
            setInfoModal(true);
            setGeolocationEvent(false);
        });
        (ref = locationRef.current) === null || ref === void 0 ? void 0 : ref.focus();
    };
    const getStoreDetails = async (param)=>{
        let { preventUnwantedDataLayer , type ="" , info ={} , key ="" , activeTab =0 , page =1 , needCallToSuggestionAPI =false , geolocationEvent  } = param;
        const { findStores ="" , siteName =""  } = info;
        const { key: locationType = ""  } = tabList[activeTab];
        if (key.length > 2 && findStores) {
            setLoadingState(true);
            let autoSuggestionAPIStatus = 0;
            let autoSuggestionAPIResults = [];
            if (needCallToSuggestionAPI) {
                if (!isEmpty_default()(brandStoreShowroomOrDealersData)) {
                    resetBrandData();
                }
                if (!(0,helper/* hasNumber */.Yo6)(key)) {
                    const suggestedData = await (0,v1_api/* getAutoSuggestionsInputBased */.T)(findStores, siteName, key);
                    const { status , data: { d: { results =[]  } = {}  } = {}  } = suggestedData;
                    autoSuggestionAPIStatus = status;
                    autoSuggestionAPIResults = results;
                    if (autoSuggestionAPIStatus === constants.LOCATIONSCONST.status) {
                        const suggestedResult = autoSuggestionAPIResults.map((city)=>city.Locality);
                        setCitySuggestData([
                            ...new Set(suggestedResult)
                        ]);
                    }
                }
            }
            let matchedStoresResult = {};
            try {
                matchedStoresResult = await (0,v1_api/* getFindAStoresResult */.R)(findStores, key, siteName, distanceMiles, maxStorePerPage, locationType, page);
            } catch (err) {
                setLoadingState(false);
                // eslint-disable-next-line no-console
                console.log("failed in fetching the find a store result", err);
            }
            const { data: { info: filteredData = [] , totalRecords =0 , totalPages =1  } = {}  } = matchedStoresResult;
            const brandData = isEmpty_default()(brandStoreShowroomOrDealersData) ? resetBrandData(true) : {
                ...brandStoreShowroomOrDealersData
            };
            brandData[locationType].data = [
                ...brandData[locationType].data,
                ...filteredData
            ];
            brandData[locationType].totalRecords = totalRecords;
            brandData[locationType].isAllLoaded = totalRecords === 0 || totalPages === page;
            brandData[locationType].page = page;
            brandData.needTOReloadTabs = needCallToSuggestionAPI;
            if (totalRecords === 0 && activeTab < 2) {
                return await getStoreDetails({
                    isAutoComplete: false,
                    preventUnwantedDataLayer,
                    type: "",
                    info,
                    key,
                    activeTab: activeTab + 1,
                    geolocationEvent
                });
            }
            if (!preventUnwantedDataLayer || geolocationEvent) {
                if (page > 1) {
                    (0,analytics/* findAStoreLoadMoreAnalytics */.pm)();
                } else {
                    let status1 = "success";
                    if (!totalRecords) {
                        status1 = "failure";
                    }
                    (0,analytics/* addFindAStoreAnalytics */.DO)({
                        action: "cmp:click",
                        status: status1,
                        total: totalRecords,
                        authorData,
                        type,
                        searchTerm: key,
                        geolocationEvent
                    });
                }
            }
            const newLatitude = filteredData.length ? filteredData[0].Latitude : 0;
            const newLongitude = filteredData.length ? filteredData[0].Longitude : 0;
            sessionStorage.setItem("brandData", JSON.stringify(brandData));
            setBrandStoreShowroomOrDealersData(brandData);
            setLatitude(newLatitude);
            setLongitude(newLongitude);
            setLoadingState(false);
            dispatch((0,locationSlice/* setFindAStoreSearchEvent */.tD)(false));
            setGeolocationEvent(false);
        } else {
            if (!preventUnwantedDataLayer) {
                (0,analytics/* addFindAStoreAnalytics */.DO)({
                    action: "cmp:click",
                    status: "failure",
                    total: 0,
                    authorData,
                    type,
                    searchTerm: key,
                    geolocationEvent
                });
            }
            setLatitude(0);
            setLongitude(0);
            setCitySuggestData([]);
            setLoadingState(false);
            dispatch((0,locationSlice/* setFindAStoreSearchEvent */.tD)(false));
            setGeolocationEvent(false);
        }
    };
    const handleChange = (inputVal)=>{
        setSearchTerm(inputVal);
        dispatch((0,locationSlice/* setFindAStoreSearchEvent */.tD)(true));
        localStorage.setItem("searchTerm", inputVal);
    };
    const handleFindStoreCheck = (entity)=>{
        localStorage.setItem("myStoreId", entity);
        dispatch((0,locationSlice/* setMyStore */.h9)(entity));
        setFindStoreCheckedId(entity);
    };
    const setUrlParam = (keyword)=>{
        if (keyword && keyword.length >= 5) {
            var ref, ref1, ref2;
            const url = new URL(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href);
            const searchParams = url === null || url === void 0 ? void 0 : url.searchParams;
            searchParams === null || searchParams === void 0 ? void 0 : searchParams.set("q", keyword);
            const urlSearch = "?" + (searchParams === null || searchParams === void 0 ? void 0 : searchParams.toString());
            (0,helper/* hasNumber */.Yo6)(keyword) && localStorage.setItem("currentZipCode", keyword);
            window === null || window === void 0 ? void 0 : (ref1 = window.history) === null || ref1 === void 0 ? void 0 : ref1.replaceState(window === null || window === void 0 ? void 0 : (ref2 = window.location) === null || ref2 === void 0 ? void 0 : ref2.pathname, document === null || document === void 0 ? void 0 : document.title, urlSearch);
        }
    };
    const resetFilterData = (parsedBrandData, activeTab)=>{
        var ref;
        brandStoreShowroomOrDealersData[tabList[activeTab].key].data = (ref = parsedBrandData[tabList[activeTab].key]) === null || ref === void 0 ? void 0 : ref.data;
        setBrandStoreShowroomOrDealersData({
            ...brandStoreShowroomOrDealersData
        });
    };
    const mapFilteredQueries = (dataItem, appliedFilters)=>{
        const mappedItems = appliedFilters.filter((item)=>dataItem[item] === true);
        return mappedItems.length === appliedFilters.length;
    };
    const applySelectedFilters = (curFilters, activeTab)=>{
        const brandDataFromSession = sessionStorage.getItem("brandData");
        const parsedBrandData = JSON.parse(brandDataFromSession);
        if (!curFilters.length) resetFilterData(parsedBrandData, activeTab);
        const appliedFilters = curFilters.map((item)=>item.query).flat(1);
        const brandStoreData = {
            ...parsedBrandData
        };
        const appliedBrandStoreFilters = brandStoreData[tabList[activeTab].key].data.filter((item)=>mapFilteredQueries(item, appliedFilters));
        brandStoreData[tabList[activeTab].key].data = appliedBrandStoreFilters;
        setBrandStoreShowroomOrDealersData(brandStoreData);
    };
    let facets = {};
    if (findStoreFilterData) {
        facets = (0,helper/* storeFilterData */.TeW)(findStoreFilterData);
    }
    const tabList = [
        {
            title: staticTexts.kohlerStore,
            key: staticTexts.kohlerStore,
            id: 0,
            icon: locator_big_chacrol/* default */.Z === null || locator_big_chacrol/* default */.Z === void 0 ? void 0 : locator_big_chacrol/* default.src */.Z.src,
            locationNote: staticTexts.kohlerStore,
            locationNoteMobile: staticTexts.kohler
        },
        {
            title: staticTexts.showrooms,
            key: staticTexts.showroom,
            id: 1,
            icon: locator_big_red/* default */.Z === null || locator_big_red/* default */.Z === void 0 ? void 0 : locator_big_red/* default.src */.Z.src,
            locationNote: staticTexts.showrooms,
            locationNoteMobile: staticTexts.showrooms
        },
        {
            title: staticTexts.genuinePartsDealers,
            key: staticTexts.partsDealer,
            id: 2,
            icon: locator_big_green/* default */.Z === null || locator_big_green/* default */.Z === void 0 ? void 0 : locator_big_green/* default.src */.Z.src,
            locationNote: staticTexts.genuinePartsDealers,
            locationNoteMobile: staticTexts.genuinePartsDealers
        }
    ];
    const tabChangeListener = (activeTab)=>{
        var ref;
        if (!((ref = brandStoreShowroomOrDealersData[tabList[activeTab].key]) === null || ref === void 0 ? void 0 : ref.data.length)) {
            getStoreDetails({
                isAutoComplete: false,
                preventUnwantedDataLayer: true,
                type: "",
                info,
                key: searchTerm,
                activeTab
            });
        }
    };
    const loadMoreHandler = (activeTab)=>{
        const { page =1  } = brandStoreShowroomOrDealersData[tabList[activeTab].key];
        getStoreDetails({
            isAutoComplete: false,
            preventUnwantedDataLayer: false,
            type: "",
            info,
            key: searchTerm,
            activeTab,
            page: page + 1
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FindStoreLanding_View_FindStoreLanding, {
        brandData: brandStoreShowroomOrDealersData,
        staticTexts: staticTexts,
        searchTerm: searchTerm,
        handleChange: (inputVal)=>handleChange(inputVal),
        facets: facets,
        getGeoLocation: getGeoLocation,
        tabList: tabList,
        latitude: latitude,
        longitude: longitude,
        getStoreDetails: (queries, preventUnwantedDataLayer)=>getStoreDetails({
                queries: queries,
                distanceVal: constants.LOCATIONSCONST.paramSpatialFilter,
                isAutoComplete: true,
                preventUnwantedDataLayer: preventUnwantedDataLayer,
                info: info,
                key: searchTerm
            }),
        findStoreDetails: findStoreDetails,
        findStoresBingKey: info.findStoresBingKey,
        citySuggestData: citySuggestData,
        handleFindStoreCheck: (checkedVal, entity)=>handleFindStoreCheck(checkedVal, entity),
        findStoreCheckedId: findStoreCheckedId,
        infoModal: infoModal,
        setInfoModalClose: ()=>setInfoModal(false),
        infoModalError: infoModalError,
        authorData: authorData,
        info: info,
        locationRef: locationRef,
        tabChangeListener: tabChangeListener,
        loadMoreHandler: loadMoreHandler,
        loadingState: loadingState,
        applySelectedFilters: applySelectedFilters
    });
};
/* harmony default export */ var v1_FindStore = (FindStore);


/***/ }),

/***/ 5619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_FriendsAndFamily; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./src/hooks/useIsSsr.js
var useIsSsr = __webpack_require__(7154);
// EXTERNAL MODULE: ./src/components/core/Modal/Modal.jsx + 2 modules
var Modal = __webpack_require__(2583);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./src/components/core/ReCaptcha/ReCaptcha.jsx + 1 modules
var ReCaptcha = __webpack_require__(15740);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./src/store/features/authSlice.js
var authSlice = __webpack_require__(2693);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./src/components/core/Checkbox/Checkbox.jsx
var Checkbox = __webpack_require__(55511);
// EXTERNAL MODULE: ./src/components/core/Input/Input.jsx
var Input = __webpack_require__(27222);
// EXTERNAL MODULE: ./src/components/FriendsAndFamily/v1/friendsAndFamilyHelper.js
var friendsAndFamilyHelper = __webpack_require__(91960);
;// CONCATENATED MODULE: ./src/components/FriendsAndFamily/v1/FriendsAndFamilyAnalytics.js
const getEventInfo = function(type, link) {
    let needsJSON = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const eventInfo = {
        eventAction: "friends-and-family-program:group code:" + type,
        eventName: "friends-and-family-program:group code:" + type,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        formName: "kohler friends and family program form",
        internalLinkName: type,
        internalLinkPosition: "friends-and-family-program:group code form",
        internalLinkType: "friends-and-family-program:" + type,
        internalLinkZoneName: "friends-and-family-program:overlay",
        internalLinkURL: link ? (link.indexOf("http") === -1 && link.indexOf("mailto:") === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true"
    };
    if (needsJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const addSubmitAnalytics = function() {
    let status = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", groupCode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", agreeTerms = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    const eventMsg = message ? message.toLowerCase().replace(/[^a-zA-Z ]/g, "") : "n/a";
    const eventInfo = {
        ...getEventInfo("submit", null, true),
        eventStatus: status,
        eventMsg,
        groupCode,
        termsAndConditions: agreeTerms === null || agreeTerms === void 0 ? void 0 : agreeTerms.terms,
        getInspringIdeas: agreeTerms === null || agreeTerms === void 0 ? void 0 : agreeTerms.kbSubscription
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const getRecaptchaAnalytics = {
    pageTitle: "friends-and-family-program:group code",
    internalLinkPosition: "friends-and-family-program:group code form",
    internalLinkType: "friends-and-family-program",
    internalLinkTypeWithType: "friends-and-family-program"
};


// EXTERNAL MODULE: ./src/components/FriendsAndFamily/v1/FriendsAndFamilyView/index.module.scss
var index_module = __webpack_require__(77781);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/components/FriendsAndFamily/v1/FriendsAndFamilyView/index.jsx










const FriendsAndFamilyView = (props)=>{
    const { showModal =false , i18n ={} , onSubmit =()=>{} , loading =false , legalPages ={}  } = props;
    const [firstName, setFirstName] = (0,react.useState)("");
    const [lastName, setLastName] = (0,react.useState)("");
    const [email, setEmail] = (0,react.useState)("");
    const [zipcode, setZipcode] = (0,react.useState)("");
    const [groupCode, setGroupCode] = (0,react.useState)("");
    const [agreeTerms, setAgreeTerms] = (0,react.useState)({
        terms: false,
        kbSubscription: false
    });
    const [firstNameError, setFirstNameError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [lastNameError, setLastNameError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [emailError, setEmailError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [zipcodeError, setZipcodeError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [groupCodeError, setGroupCodeError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [error, setError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [isAnchorEventLoaded, setAnchorEventLoaded] = (0,react.useState)(false);
    const { codeInvalidError ="" , firstNameError: i18nFirstNameError = "" , lastNameError: i18nLastNameError = "" , emailError: i18nEmailError = "" , zipcodeError: i18nZipCodeError = "" , validZipcode ="" , groupCodeError: i18nGroupCodeError = "" , termsError ="" , name: i18nName = "" , description ="" , description1 ="" , firstName: i18nFirstName = "" , lastName: i18nLastName = "" , email: i18nEmail = "" , code ="" , zipcode: i18nZipCode = "" , helpContact ="" , termsAndConditions ="" , getIdeas ="" , submit ="" , privacyPolicy: i18nPrivacyPolicy = "" , subjectAccessRequest: i18nSubjectAccessRequest = "" , termsOfService: i18nTermsOfService = ""  } = i18n;
    const { privacyPolicy ="" , termsOfService ="" , subjectAccessRequest =""  } = legalPages;
    (0,react.useEffect)(()=>{
        if (!showModal) {
            setFirstName("");
            setLastName("");
            setEmail("");
            setZipcode("");
            setGroupCode("");
            setAgreeTerms(false);
            clearError();
        } else if (!isAnchorEventLoaded) {
            // we need click event on dangerouslySetInnerHTML={{__html: i18n.need}} children. i.e. anchor tag
            setTimeout(()=>{
                findElementAndAddEvent("ff-membership__help-contact1", "friends and family support");
                findElementAndAddEvent("ff-membership__terms1", "terms and conditions");
            }, 0);
        }
    }, [
        showModal
    ]);
    const findElementAndAddEvent = (classes, type)=>{
        const descriptionElm = document.getElementsByClassName(classes);
        if (descriptionElm === null || descriptionElm === void 0 ? void 0 : descriptionElm.length) {
            const aElm = descriptionElm[0].getElementsByTagName("a");
            for (const element of aElm){
                const actualElm = element;
                if (!actualElm.hasAttribute("data-gbh-data-layer")) {
                    actualElm.classList.add("gbh-data-layer");
                    actualElm.setAttribute("data-gbh-data-layer", getEventInfo(type, actualElm.getAttribute("href")));
                    if (!isAnchorEventLoaded) {
                        setAnchorEventLoaded(true);
                    }
                }
            }
        }
    };
    const clearError = ()=>{
        setFirstNameError({
            show: false,
            message: ""
        });
        setLastNameError({
            show: false,
            message: ""
        });
        setEmailError({
            show: false,
            message: ""
        });
        setZipcodeError({
            show: false,
            message: ""
        });
        setGroupCodeError({
            show: false,
            message: ""
        });
    };
    const handleSuccess = ()=>{
        setGroupCode("");
        setAgreeTerms({
            terms: false,
            kbSubscription: false
        });
        addSubmitAnalytics("success", "", groupCode, agreeTerms);
    };
    const handleTermsPolicy = (e)=>{
        setAgreeTerms({
            ...agreeTerms,
            terms: e.target.checked
        });
        if (e.target.checked) {
            setError(false);
        }
    };
    const handleError = ()=>{
        setGroupCodeError({
            show: true,
            message: codeInvalidError
        });
        addSubmitAnalytics("failure", codeInvalidError, groupCode, agreeTerms);
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        clearError();
        // timeout is required for ADA readout properly
        setTimeout(()=>{
            const errorMessage = [];
            const getElementIdList = [];
            let valid = true;
            if (!firstName || !(0,helper/* validateField */.OP$)("name", firstName)) {
                getElementIdList.push("firstName");
                setFirstNameError({
                    show: true,
                    message: i18nFirstNameError
                });
                valid = false;
                errorMessage.push(i18nFirstNameError);
            }
            if (!lastName || !(0,helper/* validateField */.OP$)("name", lastName)) {
                getElementIdList.push("lastName");
                setLastNameError({
                    show: true,
                    message: i18nLastNameError
                });
                valid = false;
                errorMessage.push(i18nLastNameError);
            }
            if (!email || !(0,helper/* validateField */.OP$)("email", email)) {
                getElementIdList.push("email");
                setEmailError({
                    show: true,
                    message: i18nEmailError
                });
                valid = false;
                errorMessage.push(i18nEmailError);
            }
            if (!zipcode) {
                getElementIdList.push("zipCode");
                setZipcodeError({
                    show: true,
                    message: i18nZipCodeError
                });
                valid = false;
                errorMessage.push(i18nZipCodeError);
            } else if (!(0,helper/* validateField */.OP$)("zipcode", zipcode)) {
                getElementIdList.push("zipCode");
                setZipcodeError({
                    show: true,
                    message: validZipcode
                });
                valid = false;
                errorMessage.push(validZipcode);
            }
            if (!groupCode) {
                getElementIdList.push("groupCode");
                setGroupCodeError({
                    show: true,
                    message: i18nGroupCodeError
                });
                valid = false;
                errorMessage.push(i18nGroupCodeError);
            }
            if (!agreeTerms.terms) {
                setError({
                    show: true,
                    message: termsError
                });
                valid = false;
                errorMessage.push(termsError);
            }
            if (!valid) {
                var ref, ref1;
                // Focus on the first error field
                addSubmitAnalytics("failure", errorMessage.join("|").toLowerCase(), groupCode, agreeTerms);
                (ref = document.getElementById(getElementIdList[0])) === null || ref === void 0 ? void 0 : ref.focus();
                (ref1 = document.getElementById("".concat(getElementIdList[0], "-error"))) === null || ref1 === void 0 ? void 0 : ref1.focus();
            } else {
                onSubmit({
                    firstName,
                    lastName,
                    email,
                    zipcode,
                    groupCode,
                    kbSubscription: agreeTerms.kbSubscription
                }, handleSuccess, handleError, addSubmitAnalytics);
            }
        }, 100);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((index_module_default()) === null || (index_module_default()) === void 0 ? void 0 : (index_module_default()).friendsAndFamilyStyleWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "ff-membership",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "ff-membership__header",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "ff-modal-title",
                        className: "ff-membership__title",
                        children: (0,friendsAndFamilyHelper/* entityToCharacter */.F)(i18nName)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "ff-modal-description",
                    className: "ff-membership__description",
                    children: description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "ff-membership__description1",
                    children: description1
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                    id: "firstName",
                    type: "text",
                    value: firstName,
                    maxLength: 40,
                    placeholder: "".concat(i18nFirstName, "*"),
                    label: "".concat(i18nFirstName, "*"),
                    onChange: (e)=>{
                        clearError();
                        setFirstName(e.target.value);
                    },
                    showError: firstNameError.show,
                    errorMessage: firstNameError.message
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                    id: "lastName",
                    type: "text",
                    value: lastName,
                    maxLength: 40,
                    placeholder: "".concat(i18nLastName, "*"),
                    label: "".concat(i18nLastName, "*"),
                    onChange: (e)=>{
                        clearError();
                        setLastName(e.target.value);
                    },
                    showError: lastNameError.show,
                    errorMessage: lastNameError.message
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                    id: "email",
                    type: "text",
                    value: email,
                    maxLength: 40,
                    placeholder: "".concat(i18nEmail, "*"),
                    label: "".concat(i18nEmail, "*"),
                    onChange: (e)=>{
                        clearError();
                        setEmail(e.target.value);
                    },
                    showError: emailError.show,
                    errorMessage: emailError.message
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                    id: "zipcode",
                    type: "text",
                    value: zipcode,
                    maxLength: 7,
                    placeholder: "".concat(i18nZipCode, "*"),
                    label: "".concat(i18nZipCode, "*"),
                    onChange: (e)=>{
                        clearError();
                        setZipcode(e.target.value);
                    },
                    showError: zipcodeError.show,
                    errorMessage: zipcodeError.message
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                    id: "groupCode",
                    type: "text",
                    value: groupCode,
                    maxLength: 40,
                    placeholder: "".concat(code, "*"),
                    label: "".concat(code, "*"),
                    onChange: (e)=>{
                        clearError();
                        setGroupCode(e.target.value.toUpperCase());
                    },
                    showError: groupCodeError.show,
                    errorMessage: groupCodeError.message
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "ff-membership__help-contact ff-membership__help-contact1",
                    children: (0,helper/* sanitizeInnerHtml */.KD0)(helpContact)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "ff-membership__terms ff-membership__terms1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            checked: agreeTerms.terms,
                            onChange: (e)=>handleTermsPolicy(e)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(termsAndConditions)
                        })
                    ]
                }),
                error.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "key-specifier__tnc",
                    children: error.message
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "ff-membership__terms",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            checked: agreeTerms.kbSubscription,
                            onChange: (e)=>setAgreeTerms({
                                    ...agreeTerms,
                                    kbSubscription: e.target.checked
                                })
                        }),
                        getIdeas
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "ff-membership__help-contact ff-membership__help-contact1",
                    children: (0,helper/* sanitizeInnerHtml */.KD0)(helpContact)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "ff-membership__button",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "black",
                        role: "button",
                        label: submit,
                        loading: loading,
                        flexible: true,
                        onClick: handleSubmit
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptcha/* default */.Z, {
                    getAnalyticsData: getRecaptchaAnalytics
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "ff-membership__policies",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: privacyPolicy,
                            className: "gbh-data-layer",
                            "data-gbh-data-layer": getEventInfo("privacy policy", privacyPolicy),
                            children: i18nPrivacyPolicy
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: subjectAccessRequest,
                            className: "gbh-data-layer",
                            "data-gbh-data-layer": getEventInfo("subject access request", subjectAccessRequest),
                            children: i18nSubjectAccessRequest
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            id: "ff-last-element",
                            href: termsOfService,
                            className: "gbh-data-layer",
                            "data-gbh-data-layer": getEventInfo("terms of service", termsOfService),
                            children: i18nTermsOfService
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var v1_FriendsAndFamilyView = (FriendsAndFamilyView);

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
;// CONCATENATED MODULE: ./src/i18n/useFriendsAndFamilyi18n.js


const useFriendsAndFamilyi18n = (param)=>{
    let { authorData: { description , description1 , successTitle , successDescription , successCtaLabel , termsAndConditions , helpContact , getIdeas , codeInvalidError , code , codeError , name  } = {}  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        description: description ? (0,helper/* sanitizeText */.oOy)(description) : t("kf.friendsandfamily.label.description"),
        description1: description1 ? (0,helper/* sanitizeText */.oOy)(description1) : t("kf.friendsandfamily.label.description1"),
        successTitle: successTitle ? (0,helper/* sanitizeText */.oOy)(successTitle) : t("kf.friendsandfamily.label.successTitle"),
        successMessage: successDescription ? (0,helper/* sanitizeText */.oOy)(successDescription) : t("kf.friendsandfamily.label.successMessage"),
        continueShopping: successCtaLabel ? (0,helper/* sanitizeText */.oOy)(successCtaLabel) : t("kf.friendsandfamily.label.continueShopping"),
        termsAndConditions: termsAndConditions || t("kf.friendsandfamily.label.termsAndConditions"),
        helpContact: helpContact || t("kf.friendsandfamily.label.helpContact"),
        getIdeas: getIdeas ? (0,helper/* sanitizeText */.oOy)(getIdeas) : t("kf.friendsandfamily.label.getIdeas"),
        privacyPolicy: t("kf.friendsandfamily.label.privacyPolicy"),
        subjectAccessRequest: t("kf.friendsandfamily.label.subjectAccessRequest"),
        termsOfService: t("kf.friendsandfamily.label.termsOfService"),
        codeInvalidError: codeInvalidError ? (0,helper/* sanitizeText */.oOy)(codeInvalidError) : t("kf.friendsandfamily.label.codeInvalidError"),
        firstName: t("kf.friendsandfamily.label.firstName"),
        lastName: t("kf.friendsandfamily.label.lastName"),
        email: t("kf.friendsandfamily.label.email"),
        zipcode: t("kf.friendsandfamily.label.zipcode"),
        firstNameError: t("kf.friendsandfamily.label.firstNameError"),
        lastNameError: t("kf.friendsandfamily.label.lastNameError"),
        emailError: t("kf.friendsandfamily.label.emailError"),
        zipcodeError: t("kf.friendsandfamily.label.zipcodeError"),
        validZipcode: t("kf.friendsandfamily.label.validZipcode"),
        code: code ? (0,helper/* sanitizeText */.oOy)(code) : t("kf.friendsandfamily.label.code"),
        groupCodeError: codeError ? (0,helper/* sanitizeText */.oOy)(codeError) : t("kf.friendsandfamily.label.groupCodeError"),
        termsError: t("kf.friendsandfamily.label.termsError"),
        name: name ? (0,helper/* sanitizeText */.oOy)(name) : t("kf.friendsandfamily.label.name"),
        submit: t("kf.friendsandfamily.label.submit"),
        genericError: t("kf.error.message.genericError")
    };
    return i18n;
};
/* harmony default export */ var i18n_useFriendsAndFamilyi18n = (useFriendsAndFamilyi18n);

// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
;// CONCATENATED MODULE: ./src/components/FriendsAndFamily/v1/FriendsAndFamily.jsx

















const FriendsAndFamily = (props)=>{
    const { data: authorData  } = props;
    const { emailBrand =""  } = authorData;
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { pageIsInteractive  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const isSsr = (0,useIsSsr/* default */.Z)();
    const i18n = i18n_useFriendsAndFamilyi18n({
        authorData
    });
    const { successTitle ="" , successMessage ="" , continueShopping ="" , genericError =""  } = i18n;
    const [showSuccess, setShowSuccess] = (0,react.useState)(false);
    const [applyForm, setApplyForm] = (0,react.useState)(false);
    const [showAlertModal, setShowAlertModal] = (0,react.useState)(false);
    const [loading, setLoading] = (0,react.useState)(false);
    const [legalPageLinks, setLegalPageLinks] = (0,react.useState)("");
    const [persona, setUserPersona] = (0,react.useState)("");
    const [nodeList, setNodeList] = (0,react.useState)([]);
    const [btnLoaded, setBtnLoaded] = (0,react.useState)(false);
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        (0,friendsAndFamilyHelper/* redirectionToContentPage */.f)();
    }, []);
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then((config)=>{
            const legalPageLinks = get_default()(config, "legalPageData", {});
            setLegalPageLinks(legalPageLinks);
            setUserPersona((0,helper/* getUserPersona */.shu)());
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (!showAlertModal || !showSuccess) {
            setBtnLoaded(false);
        } else {
            setBtnLoaded(true);
        }
    }, [
        showAlertModal || showSuccess
    ]);
    (0,react.useEffect)(()=>{
        if (!isSsr && pageIsInteractive) {
            if (!btnLoaded) {
                setTimeout(function() {
                    getNodeList();
                }, 500);
            }
        }
    }, [
        isSsr,
        pageIsInteractive,
        btnLoaded,
        nodeList
    ]);
    const getNodeList = ()=>{
        const elements = document.querySelectorAll(constants.FRIENDS_AND_FAMILY_QUERRY_SELECTOR_URL);
        if (elements) {
            setNodeList(elements);
            showMembershipPopupHandler();
        }
    };
    const showMembershipPopupHandler = ()=>{
        nodeList.forEach((el)=>{
            el.addEventListener("click", (e)=>{
                e.preventDefault();
                setShowAlertModal(true);
                setShowSuccess(false);
                setApplyForm(true);
            });
        });
    };
    const showToaster = (msg)=>{
        dispatch((0,genericSlice/* showToast */.CF)({
            message: msg,
            isVisible: true
        }));
    };
    const handleSubmit = (payload, success, error, analyticsCB)=>{
        const { firstName , lastName , email , zipcode , groupCode , kbSubscription  } = payload;
        setLoading(true);
        (0,ReCaptcha/* validateRecaptcha */.L)().then((res)=>{
            if (res.success) {
                api/* apim.post */.TH.post(constants.FRIENDS_AND_FAMILY_API_URL_ENDPOINT, {
                    firstName: firstName,
                    lastName: lastName,
                    email: email,
                    zipcode: zipcode,
                    groupCode: groupCode,
                    emailBrand: emailBrand !== null && emailBrand !== void 0 ? emailBrand : "",
                    subscribeKohlerKBConsumer: kbSubscription
                }).then(()=>{
                    setLoading(false);
                    setShowAlertModal(false);
                    setShowSuccess(true);
                    setApplyForm(false);
                    if (isAuth) {
                        if (persona != constants["default"].FF_PERSONA) {
                            setUserPersona(constants["default"].FF_PERSONA);
                            dispatch((0,authSlice/* setPersona */.nf)(constants["default"].FF_PERSONA));
                        }
                    }
                    success();
                }).catch(()=>{
                    setLoading(false);
                    error();
                });
            } else {
                setLoading(false);
                analyticsCB === null || analyticsCB === void 0 ? void 0 : analyticsCB("failure", genericError);
                showToaster(genericError);
            }
        }).catch(()=>{
            analyticsCB === null || analyticsCB === void 0 ? void 0 : analyticsCB("failure", genericError);
        });
    };
    const handleClose = ()=>{
        setShowAlertModal(false);
        setShowSuccess(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal["default"], {
        showModal: showAlertModal || showSuccess,
        onModalClose: handleClose,
        labelledBy: "ff-modal-title",
        describedBy: "ff-modal-description",
        lastElem: "ff-last-element",
        children: [
            applyForm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FriendsAndFamilyView, {
                i18n: i18n,
                onSubmit: handleSubmit,
                closeModal: ()=>setShowAlertModal(false),
                showModal: showAlertModal,
                loading: loading,
                legalPages: legalPageLinks
            }) : null,
            showSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "success-modelId",
                tabIndex: "0",
                className: "success-message-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "success-modal-header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: successTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "success-message-model",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: (0,helper/* sanitizeInnerHtml */.KD0)(successMessage)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        role: "button",
                        type: "black",
                        label: continueShopping,
                        onClick: handleClose,
                        className: "friends-family-button"
                    })
                ]
            }) : null
        ]
    });
};
/* harmony default export */ var v1_FriendsAndFamily = (FriendsAndFamily);


/***/ }),

/***/ 5642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_InstallDesignServices; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./src/components/core/Input/Input.jsx
var Input = __webpack_require__(27222);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./src/components/cart/QuantitySelector.jsx
var QuantitySelector = __webpack_require__(85721);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./src/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(18216);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./src/components/Shared/DisplayDiscountPrice/index.jsx
var DisplayDiscountPrice = __webpack_require__(75179);
;// CONCATENATED MODULE: ./src/components/InstallDesignServices/v1/InstallDesignServices.view.jsx










const InstallDesignServicesView = (param)=>{
    let { handleCheckAvailability =()=>{} , authorData ={} , zipCodeError ={} , zipCodeInput ="" , handleChangeZipCode =()=>{} , i18n ={} , handleChange =()=>{} , handleAddToCart =()=>{} , quantity ={} , zipCodeCheck =()=>{} , availableServices =[] , productAnalyticsData ={} , productData =[] , handleClickChangeBtn =()=>{} , zipCodeChecked =false  } = param;
    const [width] = (0,useWindowResize/* default */.Z)();
    const { title ="" , checkAvailabilityText ="" , searchButtonLabel ="" , individualServiceNotAvailableText ="" , changeZipCodeLabel ="" , serviceAvailableText ="" , serviceNotAvailableText ="" , serviceAvailableDescription ="" , serviceNotAvailableDescription ="" , isZipCodeLookup =""  } = authorData;
    const { zipCode ="" , search ="" , addToCart =""  } = i18n;
    const rowCols = (0,utils/* getRowCols */.n)(width, lib/* isMobile */.tq, lib/* isTablet */.Em);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "install-design-services__container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " install-design-services__section",
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "install-design-services__title",
                        children: title
                    }),
                    isZipCodeLookup ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "install-design-services__zip-code-message",
                        children: (0,helper/* sanitizeInnerHtml */.KD0)(checkAvailabilityText)
                    }) : null,
                    isZipCodeLookup ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            !zipCodeChecked ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "install-design-services__zip-code-message",
                                children: (0,helper/* sanitizeInnerHtml */.KD0)(checkAvailabilityText)
                            }) : null,
                            zipCodeChecked && (availableServices === null || availableServices === void 0 ? void 0 : availableServices.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "install-design-services__zip-code-message",
                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(serviceAvailableText)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "install-design-services__success-error-message",
                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(serviceAvailableDescription)
                                    })
                                ]
                            }) : null,
                            zipCodeChecked && !(availableServices === null || availableServices === void 0 ? void 0 : availableServices.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "install-design-services__zip-code-message",
                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(serviceNotAvailableText)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "install-design-services__success-error-message",
                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(serviceNotAvailableDescription)
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "product-card-service__zipcode-availability",
                                        children: [
                                            zipCodeChecked ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "install__zipcode",
                                                        children: zipCodeInput
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        tabIndex: "0",
                                                        role: "link",
                                                        className: "install-service__eligible-service-edit",
                                                        onClick: handleClickChangeBtn,
                                                        children: [
                                                            " ",
                                                            changeZipCodeLabel
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                    id: "zipcode-install-design-service",
                                                    type: "text",
                                                    maxLength: 60,
                                                    placeholder: "".concat(zipCode),
                                                    label: "".concat(zipCode),
                                                    value: zipCodeInput,
                                                    customClass: "".concat((zipCodeError === null || zipCodeError === void 0 ? void 0 : zipCodeError.show) ? "product-card-service__zipcode-input-error" : ""),
                                                    onKeyDown: (e)=>{
                                                        return (e === null || e === void 0 ? void 0 : e.key) === "Enter" && handleCheckAvailability();
                                                    },
                                                    onChange: handleChangeZipCode,
                                                    onBlur: zipCodeCheck
                                                })
                                            }),
                                            (zipCodeInput === null || zipCodeInput === void 0 ? void 0 : zipCodeInput.length) && !zipCodeChecked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                role: "button",
                                                className: "black intall-service-search",
                                                label: searchButtonLabel !== null && searchButtonLabel !== void 0 ? searchButtonLabel : search,
                                                type: " ",
                                                disabled: (zipCodeInput === null || zipCodeInput === void 0 ? void 0 : zipCodeInput.length) < 5,
                                                onClick: handleCheckAvailability,
                                                useDefaultClass: true
                                            }) : null
                                        ]
                                    }),
                                    (zipCodeError === null || zipCodeError === void 0 ? void 0 : zipCodeError.show) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "error",
                                        children: zipCodeError === null || zipCodeError === void 0 ? void 0 : zipCodeError.message
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "install-services-lists",
                        children: (productData === null || productData === void 0 ? void 0 : productData.length) ? productData.map((item)=>{
                            const { name ="" , description ="" , price ="n/a" , currencySign , swatchUrl , presetConfigs , images , skuId , discountedPrice =0  } = item;
                            const imgUrl = (0,utils/* getPresetUrl */.v$)(width, rowCols, swatchUrl, images, presetConfigs, true);
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "install-services-lists__card ".concat(zipCodeChecked && (availableServices === null || availableServices === void 0 ? void 0 : availableServices.length) || isZipCodeLookup ? "show-add-cart-button" : ""),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "install-services-lists__image",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "search-icon",
                                            src: imgUrl,
                                            alt: name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "install-services-lists__information",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "install-services-lists__detail-section",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "install-services-lists__detail-section--name",
                                                        children: name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "install-services-lists__detail-section--description",
                                                        children: description
                                                    })
                                                ]
                                            }),
                                            (availableServices === null || availableServices === void 0 ? void 0 : availableServices.includes(skuId)) || isZipCodeLookup ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "install-services-lists__price-section",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "install-services-lists__price",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayDiscountPrice/* default */.Z, {
                                                        discountedPrice: discountedPrice,
                                                        price: price,
                                                        currencySign: currencySign
                                                    })
                                                })
                                            }) : null,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "clear"
                                            })
                                        ]
                                    }),
                                    zipCodeChecked && (availableServices === null || availableServices === void 0 ? void 0 : availableServices.includes(skuId)) || isZipCodeLookup ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "install-services-lists__price-and-cart",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "install-services-lists__cart",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "cartAction mx-0",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "quantity-selector-container",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                                                            doNotRequiredAnalyticsData: true,
                                                            productData: productAnalyticsData,
                                                            value: quantity[skuId],
                                                            onChange: (qty)=>handleChange(qty, skuId),
                                                            isPDPQuantitySelector: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "add-to-cart-container",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            role: "button",
                                                            label: addToCart,
                                                            onClick: ()=>handleAddToCart(item),
                                                            size: "large",
                                                            type: "primary",
                                                            flexible: true
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }) : zipCodeChecked && (availableServices === null || availableServices === void 0 ? void 0 : availableServices.length) && !(availableServices === null || availableServices === void 0 ? void 0 : availableServices.includes(skuId)) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "install-services-lists__price-and-cart",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "individual-service-not-available",
                                            children: individualServiceNotAvailableText
                                        })
                                    }) : null
                                ]
                            }, name);
                        }) : null
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var InstallDesignServices_view = ((0,lib/* withOrientationChange */.Qe)(InstallDesignServicesView));

// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var qs_lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(qs_lib);
// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
;// CONCATENATED MODULE: ./src/components/InstallDesignServices/api.js




const getListOfParamsToFetch = (persona)=>{
    const fl = [
        "id",
        "slug_s",
        "productName_s",
        "masterSKU_s",
        "Product_Category",
        "ProductBrandName_s",
        "productImages.url_ss",
        "SKUColorSwatchFilename_ss",
        "ProductDescriptionProductShort_s",
        "priceStartingAt.".concat(persona, "_d"),
        "discountedPriceStartingAt.".concat(persona, "_d"),
        "priceList.".concat(persona, ".saleOffer_s"),
        "Color.SKU.Details_ss",
        "ProductWebFeatures_ss",
        "ProductWebFeatures_s",
        "ProductIsExclusive_s",
        "RegionReleaseforShipment_dt",
        "title_s",
        "ProductNarrativeDescription_s",
        "priceList.".concat(persona, ".finalPrice_d"),
        "CustomerFacingBrand_s",
        "RegionBrandName_s"
    ];
    return fl.join(",");
};
const getProductDataFromSkuIds = async function(persona, services) {
    let lwAppName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    var ref;
    const fl = getListOfParamsToFetch(persona);
    const fq = services.map((item)=>'variantList.sku_ss:("'.concat(item.serviceSkuId, '")'));
    const config = await (0,constants_config/* getConfig */.i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    return api/* apim.get */.TH.get(constants.searchPlpEndPoint, {
        params: {
            fl,
            q: "*:*",
            fq: [
                fq.join(" "),
                'language_s:("'.concat(language, '")')
            ],
            collections: lwAppName,
            profilename: "profile_".concat(lwAppName, "_General")
        },
        paramsSerializer: (params)=>{
            return lib_default().stringify(params, {
                arrayFormat: "repeat",
                encode: false
            });
        }
    });
};


// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
;// CONCATENATED MODULE: ./src/i18n/useDesignServicei18n.js

const useDesignServicei18n = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        zipCode: t("kf.productCard.zipCode"),
        findaPro: t("kf.productCard.findaPro"),
        search: t("kf.productCard.search"),
        zipcodeEmptyError: t("kf.productCard.zipcodeEmptyError"),
        validZipcode: t("kf.productCard.validZipcode"),
        addToCart: t("kf.productCard.addToCart"),
        change: t("kf.productCard.change")
    };
    return i18n;
};
/* harmony default export */ var i18n_useDesignServicei18n = (useDesignServicei18n);

// EXTERNAL MODULE: ./src/components/productCard/v1/analytics.js
var analytics = __webpack_require__(41740);
;// CONCATENATED MODULE: ./src/components/InstallDesignServices/analytics.js

const getProductAnalyticsData = (props, discountedPrice, general)=>{
    const { productFeatures , discountPercent , name , productCategory , customerFacingSKU , badgeVal , skuId , price , images  } = props;
    const productAnalyticsData = {
        desc: productFeatures ? (0,helper/* sanitizeTextForAnalytics */.T68)(productFeatures.join(". ")) : "n/a",
        discountPrice: discountPercent > 0 ? discountedPrice : 0,
        discountPriceState: discountPercent > 0 ? "percentOff|" + discountPercent : "regular price",
        unitPrice: price,
        category: (0,helper/* sanitizeTextForAnalytics */.T68)(productCategory),
        color: "n/a",
        sku: skuId,
        name: (0,helper/* sanitizeTextForAnalytics */.T68)(name),
        image: images,
        customerFacingSKU: customerFacingSKU || ((general === null || general === void 0 ? void 0 : general.siteName) ? general.siteName[0] + "-" + skuId : ""),
        skuInitials: customerFacingSKU ? customerFacingSKU.split("-")[0] + "-" : (general === null || general === void 0 ? void 0 : general.siteName) ? general.siteName[0] + "-" : "",
        discountName: badgeVal,
        superSku: false,
        selectedColor: "n/a",
        productSaleable: true
    };
    return productAnalyticsData;
};
const getEventInfoObject = function(eventNameText, buttonName, general, checkZipCode) {
    let productName = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    var ref;
    const findaProLandingPagePath = (0,helper/* getShortenedUrlwithGeneral */.vu1)((ref = general === null || general === void 0 ? void 0 : general.findaProLandingPagePath) !== null && ref !== void 0 ? ref : "/", general);
    const ProductTitle = productName === null || productName === void 0 ? void 0 : productName.toLocaleLowerCase();
    const eventText = "installation services:install service:".concat(eventNameText);
    return {
        clickInternalLinks: "true",
        eventAction: eventText,
        eventName: eventText,
        eventType: "navigation",
        internalLinkName: buttonName !== null && buttonName !== void 0 ? buttonName : eventNameText,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkPosition: "find installation services",
        internalLinkType: "installation services:".concat(!checkZipCode ? "navigation" : checkZipCode),
        internalLinkURL: eventNameText === "find a pro" ? ((findaProLandingPagePath === null || findaProLandingPagePath === void 0 ? void 0 : findaProLandingPagePath.indexOf("http")) === -1 ? window.location.origin : "") + findaProLandingPagePath : "n/a",
        internalLinkZoneName: "installation services:".concat(ProductTitle)
    };
};
const getProductInfoForAnalytics = (product, quantity, general, cart)=>{
    var ref;
    const { skuId , discountPercent , price , discountedPrice  } = product;
    const { productCouponCode , productCoupondiscount , globalDiscountNames , globalDiscountValues  } = (0,helper/* getCurrentSkuCouponDiscounts */.mPk)({
        cart,
        sku: skuId
    });
    const productAnalyticsData = getProductAnalyticsData(product, discountedPrice, general);
    const { desc ="n/a" , unitPrice =0 , discountPriceState , category , color , customerFacingSKU , name , discountName  } = productAnalyticsData;
    const productPrice = discountPercent > 0 ? discountedPrice : price;
    let globalOffer = [
        discountName
    ];
    let globalDiscount = 0;
    if ((globalDiscountNames === null || globalDiscountNames === void 0 ? void 0 : globalDiscountNames.length) && globalDiscountValues) {
        globalOffer = [
            discountName,
            ...globalDiscountNames
        ];
        globalDiscount += globalDiscountValues;
    }
    const productInfo = {
        description: desc,
        frequency: "n/a",
        globalPromotionPrice: discountedPrice > 0 ? Number((price - 0).toFixed(2)) : 0,
        globalOffer: globalOffer.join("|") || "n/a",
        globalDiscount: globalDiscount ? Number(globalDiscount.toFixed(2)) : 0,
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        priceState: discountPriceState,
        productBasePrice: Number(unitPrice) || "n/a",
        productCategory: category || "n/a",
        productColor: color || "n/a",
        productCoupondiscount: productCoupondiscount || 0,
        productCouponCode: productCouponCode.join("|") || "n/a",
        productID: customerFacingSKU || "n/a",
        productName: name || desc || category || "n/a",
        productPartnerBuyNow: "n/a",
        productRoom: "service" || 0,
        productSalePrice: Number(productPrice),
        productSaleable: true,
        productStatus: "in stock",
        productSuperSku: false,
        productTileName: name || "n/a",
        quantity: quantity[skuId] || "n/a",
        defaultImageName: productAnalyticsData.image || "n/a",
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: "regular finished goods & service parts",
        productFindingMethod: "n/a",
        productCollectionsName: category || "n/a",
        productBrand: general === null || general === void 0 ? void 0 : (ref = general.siteName) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
        itemType: "service" || 0
    };
    return productInfo;
};

// EXTERNAL MODULE: ./src/store/features/cartSlice.js
var cartSlice = __webpack_require__(64925);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./src/components/InstallDesignServices/v1/index.module.scss
var index_module = __webpack_require__(56426);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/productCard/v1/productCardHelper.js
var productCardHelper = __webpack_require__(15011);
;// CONCATENATED MODULE: ./src/components/InstallDesignServices/v1/InstallDesignServices.jsx




















const InstallDesignServices = (props)=>{
    const dispatch = (0,es/* useDispatch */.I0)();
    const i18n = i18n_useDesignServicei18n();
    const { cart: activeCart = {}  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [productData, setProductData] = (0,react.useState)([]);
    const [zipCodeData, setZipCodeData] = (0,react.useState)({});
    const [quantity, setQuantity] = (0,react.useState)({});
    const [zipCodeError, setZipCodeError] = (0,react.useState)({
        show: false,
        message: ""
    });
    var ref;
    const [zipCodeInput, setZipCodeInput] = (0,react.useState)((ref = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("currentZipCode")) !== null && ref !== void 0 ? ref : "");
    const [availableServices, setAvailableServices] = (0,react.useState)([]);
    const [zipCodeChecked, setZipCodeChecked] = (0,react.useState)(false);
    const [persona, setPersona] = (0,react.useState)("GST");
    const [info, setInfo] = (0,react.useState)({});
    const { cartUrl ="" , currencySign ="" , general ={} , lwAppName =""  } = info;
    const { staticTexts ={} , data: authorData  } = props;
    const { services =[] , presetConfigs ="" , swatchUrl ="" , jsonFilePath =""  } = authorData;
    const { sfLabel ="" , lfLabel ="" , boxLabel ="" , yourCart ="" , itemAdded ="" , itemsAdded =""  } = staticTexts;
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((CONFIG)=>{
            const { general  } = CONFIG;
            if (!isEmpty_default()(CONFIG)) {
                const { cartLandingPagePath ="/" , siteName ="" , lwAppName =""  } = general;
                const cartUrl = (0,helper/* getShortenedUrlwithGeneral */.vu1)(cartLandingPagePath !== null && cartLandingPagePath !== void 0 ? cartLandingPagePath : "/", CONFIG);
                const currencySign = get_default()(CONFIG, "internationalization.currencySign", "");
                setInfo({
                    siteName,
                    cartUrl,
                    currencySign,
                    general,
                    lwAppName
                });
                setPersona((0,helper/* getUserPersona */.shu)());
            }
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(authorData) && lwAppName) {
            getZipCodeJsonFile();
            getProductDataFromSkuIds(persona, services, lwAppName).then((res)=>{
                if (res && (res === null || res === void 0 ? void 0 : res.data)) {
                    const productServiceData = get_default()(res === null || res === void 0 ? void 0 : res.data, "response.docs", []);
                    const serviceSkus = services.map((item)=>item.serviceSkuId);
                    productServiceData.sort((a, b)=>serviceSkus.indexOf(a.masterSKU_s) - serviceSkus.indexOf(b.masterSKU_s));
                    const productProps = productServiceData.map((product)=>getProductProps(product, presetConfigs, swatchUrl));
                    const quantity = {};
                    productProps.forEach((param)=>{
                        let { skuId  } = param;
                        quantity[skuId] = 1;
                    });
                    setQuantity(quantity);
                    setProductData(productProps);
                }
            });
        }
    }, [
        lwAppName
    ]);
    const getZipCodeJsonFile = async ()=>{
        if (jsonFilePath) {
            (0,api/* aemAxiosInstance */.Gb)({
                url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: jsonFilePath
                }
            }).then((response)=>{
                if (response) {
                    const { data: { zipcode =[]  } = {}  } = response;
                    setZipCodeData(zipcode);
                }
            }).catch((err)=>{
                console.error("Failed to get zipcode from AEM", err);
            });
        }
    };
    const getProductProps = function() {
        let productServiceData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, presetConfigs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", swatchUrl = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        const productCardProps = {
            presetConfigs: presetConfigs ? JSON.parse(presetConfigs) : "",
            swatchUrl: swatchUrl !== null && swatchUrl !== void 0 ? swatchUrl : "",
            images: image_missing/* default */.Z
        };
        if (!isEmpty_default()(productServiceData)) {
            var ref;
            // get product images
            let imgSrc = "";
            if (productServiceData["productImages.url_ss"]) {
                var ref1;
                imgSrc = (ref1 = productServiceData["productImages.url_ss"][0]) !== null && ref1 !== void 0 ? ref1 : "";
            }
            if (imgSrc === null || imgSrc === void 0 ? void 0 : imgSrc.length) {
                const imgParts = imgSrc === null || imgSrc === void 0 ? void 0 : imgSrc.split("/");
                const imgId = imgParts[imgParts.length - 1];
                productCardProps.images = imgId;
            }
            // get product colors
            if (productServiceData["Color.SKU.Details_ss"]) {
                var ref2;
                const colors = (ref2 = productServiceData["Color.SKU.Details_ss"]) !== null && ref2 !== void 0 ? ref2 : [];
                productCardProps.colors = colors.filter((item)=>{
                    const color = item === null || item === void 0 ? void 0 : item.split("|");
                    return color[4] === "false" || Date.parse(color[4]) > Date.now();
                });
            } else {
                productCardProps.colors = [
                    ""
                ];
            }
            // get product web features
            if (productServiceData["ProductWebFeatures_s"]) {
                var ref3;
                productCardProps.productFeatures = (ref3 = [
                    productServiceData["ProductWebFeatures_s"]
                ]) !== null && ref3 !== void 0 ? ref3 : [];
            } else {
                var ref4;
                productCardProps.productFeatures = (ref4 = productServiceData["ProductWebFeatures_ss"]) !== null && ref4 !== void 0 ? ref4 : [];
            }
            productCardProps.currencySign = currencySign;
            productCardProps.productCategory = get_default()(productServiceData, "Product_Category", "");
            productCardProps.name = get_default()(productServiceData, "productName_s", "");
            productCardProps.brandName = get_default()(productServiceData, "RegionBrandName_s", "");
            productCardProps.description = get_default()(productServiceData, "ProductNarrativeDescription_s", "");
            productCardProps.narrativeDescription = get_default()(productServiceData, "ProductNarrativeDescription_s", "");
            productCardProps.price = get_default()(productServiceData, "priceStartingAt.".concat(persona, "_d"), 0);
            productCardProps.discountedPrice = get_default()(productServiceData, "discountedPriceStartingAt.".concat(persona, "_d"), 0);
            productCardProps.discountPercent = parseInt(get_default()(productServiceData, "priceList.".concat(persona, ".saleOffer_s"), 0));
            productCardProps.slug = get_default()(productServiceData, "slug_s", "");
            productCardProps.customerBrand = get_default()(productServiceData, "CustomerFacingBrand_s", "");
            productCardProps.skuId = get_default()(productServiceData, "masterSKU_s", "");
            let tempColorDetails = get_default()(productServiceData, "Color.SKU.Details_ss", null);
            if (tempColorDetails) {
                if (typeof tempColorDetails !== "string" && tempColorDetails[0]) {
                    tempColorDetails = tempColorDetails[0];
                }
                productCardProps.customerFacingSKU = tempColorDetails.split("|")[5] || "";
            }
            productCardProps.badgeVal = get_default()(productServiceData, "priceList.".concat(persona, ".saleOffer_s"), "");
            productCardProps.globalDiscount = productCardProps.price - get_default()(productServiceData, "priceList.".concat(persona, ".finalPrice_d"), productCardProps.price);
            const productCategory = productCardProps === null || productCardProps === void 0 ? void 0 : (ref = productCardProps.productCategory) === null || ref === void 0 ? void 0 : ref.toLowerCase();
            productCardProps.priceType = "";
            if (productCategory === "field tiles" || productCategory === "slabs" || productCategory === "mosaics") {
                productCardProps.priceType = "/".concat(sfLabel);
            }
            if (productCategory === "trims & moldings") {
                productCardProps.priceType = "/".concat(lfLabel);
            }
            if (productCategory === "grout") {
                productCardProps.priceType = boxLabel;
            }
        }
        return productCardProps;
    };
    const checkUserZipCode = (userZipCodeVal)=>{
        let services = [];
        for(let i = 0; i < zipCodeData.length; i++){
            const key = Object.keys(zipCodeData[i])[0];
            let isMatched = false;
            for(let j = 0; j < zipCodeData[i][key].length; j++){
                const zipcode = Object.keys(zipCodeData[i][key][j])[0];
                if (zipcode === userZipCodeVal) {
                    services = zipCodeData[i][key][j][zipcode];
                    isMatched = true;
                    break;
                }
            }
            if (isMatched) break;
        }
        setAvailableServices(services);
        setZipCodeChecked(true);
        (services === null || services === void 0 ? void 0 : services.length) ? addZipcodeAnalytics("success", "", services) : addZipcodeAnalytics("failure", "service not available", services);
    };
    const handleCheckAvailability = async ()=>{
        let valid = true;
        const zipCodeErrObj = {
            show: false,
            message: ""
        };
        const { zipcodeEmptyError ="" , validZipcode =""  } = i18n;
        if (isEmpty_default()(zipCodeInput)) {
            zipCodeErrObj.show = true;
            zipCodeErrObj.message = zipcodeEmptyError;
            valid = false;
        } else if (!await (0,helper/* validateField */.OP$)("zipcode", zipCodeInput)) {
            zipCodeErrObj.show = true;
            zipCodeErrObj.message = validZipcode;
            valid = false;
        }
        setZipCodeError({
            zipCodeErrObj
        });
        valid ? checkUserZipCode(zipCodeInput) : setZipCodeChecked(false);
    };
    const addZipcodeAnalytics = function() {
        let status = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", services = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
        var ref;
        const productInfo = null;
        const productInfoArray = services.length ? productData.filter((product)=>services.includes(product.skuId)) : productData;
        const productNameArry = productInfoArray.map((product)=>product.name);
        const productNames = productNameArry.length ? productNameArry.join("|").toLowerCase() : "";
        const eventInfoObj = getEventInfoObject("check availability", "search", general, zipCodeInput, productNames);
        eventInfoObj.eventMsg = message || "n/a";
        eventInfoObj.eventStatus = status;
        (0,analytics/* callInstallServiceAddToCartAnalytics */.gA)({
            resInfo: {},
            eventInfoObj,
            productInfo,
            cartID: props === null || props === void 0 ? void 0 : (ref = props.cart) === null || ref === void 0 ? void 0 : ref.id
        });
    };
    const eventInfoObj = getEventInfoObject("change zip code", null, general, zipCodeInput, "toilet install service ");
    const handleClickChangeBtn = ()=>{
        setZipCodeChecked(false);
        (0,analytics/* callInstallServiceAddToCartAnalytics */.gA)({
            resInfo: {},
            eventInfoObj,
            cartID: activeCart === null || activeCart === void 0 ? void 0 : activeCart.id
        });
    };
    const handleChangeZipCode = async (e)=>{
        const { value  } = e.target;
        if (await (0,helper/* validateField */.OP$)("zipCodeNumeric", value) || value === "") {
            setZipCodeInput(value);
        }
        setZipCodeError({
            show: false,
            message: ""
        });
    };
    const zipCodeCheck = async ()=>{
        if (!await (0,helper/* validateField */.OP$)("zipcode", zipCodeInput)) {
            setZipCodeError({
                show: true,
                message: i18n === null || i18n === void 0 ? void 0 : i18n.validZipcode
            });
        } else {
            setZipCodeError({
                show: false,
                message: ""
            });
        }
    };
    const addServiceToCart = function() {
        let items = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], productName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", skuId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        let totalAdded = 0;
        items.forEach((item)=>totalAdded += item.quantity);
        const msg = totalAdded === 1 ? "".concat(totalAdded, " ").concat(itemAdded, " ") : "".concat(totalAdded, " ").concat(itemsAdded, " ");
        (0,productCardHelper/* productCardAddToCart */.x)([
            ...items
        ], true, "", (res)=>handleCallback(res, msg, productName, skuId), false);
    };
    const handleAddToCart = (item)=>{
        const { skuId ="" , customerBrand ="" , name =""  } = item;
        if (!isEmpty_default()(zipCodeInput)) {
            addServiceToCart([
                {
                    sku: skuId,
                    quantity: quantity[skuId],
                    userZipCode: zipCodeInput,
                    brand: customerBrand
                }
            ], name, skuId);
        }
    };
    const handleChange = async function() {
        let qty = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, skuId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        if (qty && qty !== 0) {
            const updateQuantity = {
                ...quantity
            };
            updateQuantity[skuId] = qty;
            setQuantity(updateQuantity);
        }
    };
    const getToasterMsg = (msg)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                msg,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: cartUrl,
                    children: yourCart
                }),
                "."
            ]
        });
    const handleCallback = function() {
        let res = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, msg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", productName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", skuId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
        const product = productData.find((productItem)=>{
            return (productItem === null || productItem === void 0 ? void 0 : productItem.skuId) === skuId;
        });
        const productInfo = getProductInfoForAnalytics(product, quantity, general, activeCart);
        const eventInfoObj = getEventInfoObject("add to cart", null, general, zipCodeInput, productName);
        const { status , message ="n/a"  } = res;
        eventInfoObj.eventStatus = status === 200 ? "success" : "failure";
        if (status !== 200) {
            eventInfoObj.eventMsg = message ? (0,helper/* sanitizeTextForAnalytics */.T68)(message) : "n/a";
        }
        (0,analytics/* callInstallServiceAddToCartAnalytics */.gA)({
            resInfo: res,
            eventInfoObj,
            productInfo,
            cartID: activeCart === null || activeCart === void 0 ? void 0 : activeCart.id
        });
        if (lib/* isMobile */.tq) dispatch((0,genericSlice/* showToast */.CF)({
            message: getToasterMsg(msg),
            isVisible: true
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()) === null || (index_module_default()) === void 0 ? void 0 : (index_module_default()).installServiceWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "install-design-services installdesignservices ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InstallDesignServices_view, {
                handleCheckAvailability: handleCheckAvailability,
                authorData: authorData,
                zipCodeError: zipCodeError,
                handleChangeZipCode: handleChangeZipCode,
                zipCodeInput: zipCodeInput,
                i18n: i18n,
                handleChange: handleChange,
                handleAddToCart: handleAddToCart,
                quantity: quantity,
                zipCodeCheck: zipCodeCheck,
                availableServices: availableServices,
                productData: productData,
                handleClickChangeBtn: handleClickChangeBtn,
                zipCodeChecked: zipCodeChecked
            })
        })
    });
};
/* harmony default export */ var v1_InstallDesignServices = ((0,lib/* withOrientationChange */.Qe)(InstallDesignServices));


/***/ }),

/***/ 48440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_KeySpecifier; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/hooks/useIsSsr.js
var useIsSsr = __webpack_require__(7154);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./src/components/core/Modal/Modal.jsx + 2 modules
var Modal = __webpack_require__(2583);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./src/components/core/ReCaptcha/ReCaptcha.jsx + 1 modules
var ReCaptcha = __webpack_require__(15740);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./src/components/RegisterOfflineProduct/v1/RegisterOfflineHelper.js
var RegisterOfflineHelper = __webpack_require__(85180);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./src/components/core/Checkbox/Checkbox.jsx
var Checkbox = __webpack_require__(55511);
// EXTERNAL MODULE: ./src/components/core/Input/Input.jsx
var Input = __webpack_require__(27222);
// EXTERNAL MODULE: ./src/components/core/SelectDropdown/SelectDropdown.jsx
var SelectDropdown = __webpack_require__(14629);
// EXTERNAL MODULE: ./src/components/core/RadioButton/RadioButton.jsx
var RadioButton = __webpack_require__(94593);
// EXTERNAL MODULE: ./src/components/RegisterOnlineProduct/v1/RegisterOnlineHelper.js
var RegisterOnlineHelper = __webpack_require__(407);
// EXTERNAL MODULE: ./src/utils/location.js
var utils_location = __webpack_require__(78800);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./src/components/checkout/checkoutHelperFunction.js
var checkoutHelperFunction = __webpack_require__(90164);
;// CONCATENATED MODULE: ./src/components/KeySpecifier/v1/KeySpecifierAnalytics.js
const getRecaptchaAnalytics = {
    pageTitle: "key-specifier-discount:group code",
    internalLinkPosition: "key-specifier-discount:group code form",
    internalLinkType: "key-specifier-discount",
    internalLinkTypeWithType: "key-specifier-discount"
};
const addSubmitAnalytics = function() {
    let status = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", groupCode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", policy1 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", policy2 = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", policy3 = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    const eventInfo = {
        ...getEventInfo("submit", null, true),
        eventStatus: status,
        eventMsg: message || "n/a",
        groupCode,
        termsAndConditions: policy1,
        getInspringIdeas: policy2,
        stayUptoDate: policy3
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const getEventInfo = function(type, link) {
    let needsJSON = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const eventInfo = {
        eventAction: "key-specifier-discount:group code:" + type,
        eventName: "key-specifier-discount:group code:" + type,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type,
        internalLinkPosition: "key-specifier-discount:group code form",
        internalLinkType: "key-specifier-discount:" + type,
        internalLinkZoneName: "key-specifier-discount:overlay",
        internalLinkURL: link ? (link.indexOf("http") === -1 && link.indexOf("mailto:") === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true"
    };
    if (needsJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};


// EXTERNAL MODULE: ./src/components/KeySpecifier/v1/index.module.scss
var index_module = __webpack_require__(42472);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/components/KeySpecifier/v1/KeySpecifierView.jsx
















const KeySpecifierView = (param)=>{
    let { showModal =false , i18n ={} , registerUser =()=>{} , loading =false , businessTypes =[] , states =[] , legalPages ="" , countries =[] , country ="" , emailBrand =""  } = param;
    const [firstName, setFirstName] = (0,react.useState)("");
    const [lastName, setLastName] = (0,react.useState)("");
    const [emailAddress, setEmailAddress] = (0,react.useState)("");
    const [businessName, setBusinessName] = (0,react.useState)("");
    const [jobTitle, setJobTitle] = (0,react.useState)("");
    const [businessPhoneNumber, setBusinessPhoneNumber] = (0,react.useState)("");
    const [streetAddress, setStreetAddress] = (0,react.useState)("");
    const [aptFloorSuite, setAptFloorSuite] = (0,react.useState)("");
    const [city, setCity] = (0,react.useState)("");
    const [zipCode, setZipCode] = (0,react.useState)("");
    const [groupCode, setGroupCode] = (0,react.useState)("");
    const [firstNameError, setFirstNameError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [groupCodeError, setGroupCodeError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [lastNameError, setLastNameError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [emailAddressError, setEmailAddressError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [businessNameError, setBusinessNameError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [businessPhoneNumberError, setBusinessPhoneNumberError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [streetAddressError, setStreetAddressError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [cityError, setCityError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [zipCodeError, setZipCodeError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [policy1Error, setPolicy1Error] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [policy1, setPolicy1] = (0,react.useState)(false);
    const [policy2, setPolicy2] = (0,react.useState)(false);
    const [policy3, setPolicy3] = (0,react.useState)(false);
    const [type, setType] = (0,react.useState)("");
    const [subType, setSubType] = (0,react.useState)("");
    const [state, setState] = (0,react.useState)("");
    const [isShowSubType, setIsShowSubType] = (0,react.useState)(false);
    const [suggestions, setSuggestions] = (0,react.useState)([]);
    const [active, setActive] = (0,react.useState)(true);
    const [isAnchorEventLoaded, setAnchorEventLoaded] = (0,react.useState)(false);
    const { name: i18nName , description , termsAndConditions , privacyPolicy , subjectAccessRequest , termsOfService , yourInformation , businessInformation , primaryBusinessType , submit , businessAddress , emailAddress: i18nEmailAddress , policy1Error: i18nPolicy1Error , groupCodeError: i18nGroupCodeError , firstNameError: i18nFirstNameError , lastNameError: i18nLastNameError , businessNameError: i18nBusinessNameError , streetAddressError: i18nStreetAddressError , businessPhoneNumberError: i18nBusinessPhoneNumberError , cityError: i18nCityError , zipCodeError: i18nZipCodeError , codeInvalidError , firstName: i18nFirstName , lastName: i18nLastName , businessName: i18nBusinessName , jobTitle: i18nJobTitle , aptFloorSuite: i18nAptFloorSuite , city: i18nCity , zipCode: i18nZipCode , groupCode: i18nGroupCode , emailAddressError: i18nEmailAddressError , businessPhoneNumber: i18nBusinessPhoneNumber , streetAddress: i18nStreetAddress , state: i18nState , keySpecifierGroupCode , installingProductatBusinessAbove , yes , no , termsAndConditions1 , getInspring , stay , need  } = i18n;
    const { privacyPolicy: privacyPolicyLegal , subjectAccessRequest: subjectAccessRequestLegal , termsOfService: termsOfServiceLegal  } = legalPages;
    (0,react.useEffect)(()=>{
        if (showModal) {
            if (groupCode) {
                onBlurInput("groupCode", groupCode);
            }
            if (firstName) {
                onBlurInput("firstName", firstName);
            }
            if (lastName) {
                onBlurInput("lastName", lastName);
            }
            if (emailAddress) {
                validateEmail();
            }
            if (businessName) {
                onBlurInput("businessName", businessName);
            }
            if (businessPhoneNumber) {
                onBlurInput("businessPhoneNumber", businessPhoneNumber);
            }
            if (zipCode) {
                onBlurInput("zipCode", zipCode);
            }
            if (streetAddress) {
                onBlurInput("streetAddress", streetAddress);
            }
            if (city) {
                onBlurInput("city", city);
            }
        }
    }, [
        showModal,
        lastName,
        firstName,
        emailAddress,
        businessName,
        businessPhoneNumber,
        groupCode,
        streetAddress,
        zipCode,
        city
    ]);
    (0,react.useEffect)(()=>{
        if (!showModal) {
            setFirstName("");
            setLastName("");
            setEmailAddress("");
            setBusinessName("");
            setJobTitle("");
            setType("");
            setSubType("");
            setBusinessPhoneNumber("");
            setStreetAddress("");
            setAptFloorSuite("");
            setCity("");
            setZipCode("");
            setState("");
            setGroupCode("");
            setPolicy1(false);
            setPolicy2(false);
            setPolicy3(false);
            clearError();
        } else if (!isAnchorEventLoaded) {
            setTimeout(()=>{
                findElementAndAddEvent("key-specifier__terms_policy1", "terms and conditions");
                findElementAndAddEvent("key-specifier__description1", "key specifier support");
            }, 0);
        }
    }, [
        showModal
    ]);
    const validateEmail = async ()=>{
        const errorMessage = [];
        const getElementIdList = [];
        let valid = true;
        if (await (0,helper/* validateField */.OP$)("email", emailAddress)) {
            onBlurInput("emailAddress", emailAddress);
        } else {
            getElementIdList.push("emailAddress");
            setEmailAddressError({
                show: true,
                message: i18nEmailAddressError
            });
            valid = false;
            errorMessage.push(i18nEmailAddressError);
        }
        if (!valid) {
            onFocustSet(errorMessage, getElementIdList);
        }
    };
    const onFocustSet = (errorMessage, getElementIdList)=>{
        var ref, ref1;
        addSubmitAnalytics("failure", errorMessage.join("|").toLowerCase(), groupCode, policy1, policy2, policy3);
        (ref = document.getElementById(getElementIdList[0])) === null || ref === void 0 ? void 0 : ref.focus();
        (ref1 = document.getElementById("".concat(getElementIdList[0], "-error"))) === null || ref1 === void 0 ? void 0 : ref1.focus();
    };
    const findElementAndAddEvent = (classes, type)=>{
        const descriptionElm = document.getElementsByClassName(classes);
        if (descriptionElm === null || descriptionElm === void 0 ? void 0 : descriptionElm.length) {
            const aElm = descriptionElm[0].getElementsByTagName("a");
            for (const element of aElm){
                const actualElm = element;
                if (!actualElm.hasAttribute("data-gbh-data-layer")) {
                    actualElm.classList.add("gbh-data-layer");
                    actualElm.setAttribute("data-gbh-data-layer", getEventInfo(type, actualElm.getAttribute("href")));
                    if (!isAnchorEventLoaded) {
                        setAnchorEventLoaded(true);
                    }
                }
            }
        }
    };
    (0,react.useEffect)(()=>{
        setSubType("");
        if (!isEmpty_default()(type)) {
            const showSubType = businessTypes.find((el)=>el.text === type).value;
            setIsShowSubType(Boolean(!isEmpty_default()(showSubType)));
        }
    }, [
        type
    ]);
    const clearError = ()=>{
        setGroupCodeError({
            show: false,
            message: ""
        });
        setFirstNameError({
            show: false,
            message: ""
        });
        setLastNameError({
            show: false,
            message: ""
        });
        setEmailAddressError({
            show: false,
            message: ""
        });
        setBusinessNameError({
            show: false,
            message: ""
        });
        setBusinessPhoneNumberError({
            show: false,
            message: ""
        });
        setStreetAddressError({
            show: false,
            message: ""
        });
        setCityError({
            show: false,
            message: ""
        });
        setZipCodeError({
            show: false,
            message: ""
        });
    };
    const handleAddressChange = (val)=>{
        setStreetAddress(val);
        getSuggestions(val);
    };
    const getSuggestions = (0,react.useCallback)(debounce_default()((addr)=>{
        (0,checkoutHelperFunction/* getAddressSuggestions */.We)(addr).then((suggData)=>setSuggestions(suggData));
    }, 300), []);
    const onSuggestionSelect = (val)=>{
        setSuggestions([]);
        const addr = (0,helper/* destructureAddress */.LY3)(val);
        setStreetAddress(addr === null || addr === void 0 ? void 0 : addr.address);
        setCity(addr === null || addr === void 0 ? void 0 : addr.city);
        setZipCode(addr === null || addr === void 0 ? void 0 : addr.zipcode);
        setState((0,RegisterOnlineHelper/* getStateName */.qs)(addr === null || addr === void 0 ? void 0 : addr.state, country, countries));
        setZipCodeError({
            show: false,
            message: ""
        });
        setCityError({
            show: false,
            message: ""
        });
        setStreetAddressError({
            show: false,
            message: ""
        });
    };
    const handleTermsPolicy = (e)=>{
        setPolicy1(e.target.checked);
        if (e.target.checked) {
            setPolicy1Error(false);
        }
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        clearError();
        const errorMessage = [];
        const getElementIdList = [];
        let valid = true;
        if (!policy1) {
            setPolicy1Error({
                show: true,
                message: i18nPolicy1Error
            });
            valid = false;
            errorMessage.push(i18nPolicy1Error);
        }
        if (!groupCode) {
            setGroupCodeError({
                show: true,
                message: i18nGroupCodeError
            });
            getElementIdList.push("groupCode");
            valid = false;
            errorMessage.push(i18nGroupCodeError);
        }
        if (!firstName || !await (0,helper/* validateField */.OP$)("name", firstName)) {
            getElementIdList.push("firstName");
            setFirstNameError({
                show: true,
                message: i18nFirstNameError
            });
            valid = false;
            errorMessage.push(i18nFirstNameError);
        }
        if (!lastName || !await (0,helper/* validateField */.OP$)("name", lastName)) {
            getElementIdList.push("lastName");
            setLastNameError({
                show: true,
                message: i18nLastNameError
            });
            valid = false;
            errorMessage.push(i18nLastNameError);
        }
        if (!emailAddress || !await (0,helper/* validateField */.OP$)("email", emailAddress)) {
            getElementIdList.push("emailAddress");
            setEmailAddressError({
                show: true,
                message: i18nEmailAddressError
            });
            valid = false;
            errorMessage.push(i18nEmailAddressError);
        }
        if (!businessName || !await (0,helper/* validateField */.OP$)("businessName", businessName)) {
            getElementIdList.push("businessName");
            setBusinessNameError({
                show: true,
                message: i18nBusinessNameError
            });
            valid = false;
            errorMessage.push(i18nBusinessNameError);
        }
        if (!businessPhoneNumber || !await (0,helper/* validatePhone */.a$Q)(businessPhoneNumber)) {
            getElementIdList.push("businessPhoneNumber");
            setBusinessPhoneNumberError({
                show: true,
                message: i18nBusinessPhoneNumberError
            });
            valid = false;
            errorMessage.push(i18nBusinessPhoneNumberError);
        }
        if (!await (0,helper/* validateField */.OP$)("address", streetAddress)) {
            getElementIdList.push("streetAddress");
            setStreetAddressError({
                show: true,
                message: i18nStreetAddressError
            });
            valid = false;
            errorMessage.push(i18nStreetAddressError);
        }
        if (!await (0,helper/* validateField */.OP$)("city", city)) {
            getElementIdList.push("city");
            setCityError({
                show: true,
                message: i18nCityError
            });
            valid = false;
            errorMessage.push(i18nCityError);
        }
        if (!zipCode || zipCode.length < 5 || !await (0,utils_location/* validateZip */.$8)(zipCode)) {
            getElementIdList.push("zipCode");
            setZipCodeError({
                show: true,
                message: i18nZipCodeError
            });
            valid = false;
            errorMessage.push(i18nZipCodeError);
        }
        if (!valid) {
            onFocustSet(errorMessage, getElementIdList);
        } else {
            const body = {
                groupCode: groupCode,
                emailBrand: emailBrand !== null && emailBrand !== void 0 ? emailBrand : "",
                business: {
                    name: firstName + " " + lastName,
                    email: emailAddress,
                    addressLine1: streetAddress,
                    addressLine2: aptFloorSuite,
                    city: city,
                    state: state,
                    postalCode: zipCode,
                    phone: businessPhoneNumber
                },
                businessName: businessName,
                enrollKohlerKBKeySpecifierProgram: true,
                subscribeKohlerKBConsumer: true,
                subscribeKohlerKBCMRLNews: true,
                kitchenBathRecentSource: true,
                jobTitle: jobTitle,
                productInstalledAtBusiness: active,
                occupation: type,
                occupationOther: subType,
                installAddressLine1: streetAddress,
                installAddressLine2: aptFloorSuite,
                installCity: city,
                installState: state,
                installPostalCode: zipCode
            };
            registerUser(body, ()=>setGroupCodeError({
                    show: true,
                    message: codeInvalidError
                }), addSubmitAnalytics("", "", groupCode, policy1, policy2, policy3));
        }
    };
    const checkDisabled = ()=>{
        if (isShowSubType) {
            if (firstName && lastName && emailAddress && businessName && type && subType && businessPhoneNumber && streetAddress && city && state && zipCode && groupCode) return false;
        } else if (firstName && lastName && emailAddress && businessName && type && businessPhoneNumber && streetAddress && city && state && zipCode && groupCode) {
            return false;
        }
        return true;
    };
    const handleChange = (e)=>{
        const name = e.target.getAttribute("name");
        let value;
        if (name === i18nEmailAddress) {
            value = e.target.value.replace(/\s/, "");
        } else if ((0,helper/* validateField */.OP$)("name", e.target.value) === false && (name === i18nFirstName || name === i18nLastName)) {
            const str = e.target.value.slice(0, -1);
            value = str.replace(/^\s/, "");
        } else {
            value = e.target.value.replace(/^\s/, "");
        }
        switch(name){
            case i18nFirstName:
                setFirstName(value);
                break;
            case i18nLastName:
                setLastName(value);
                break;
            case i18nEmailAddress:
                setEmailAddress(value);
                break;
            case i18nBusinessName:
                setBusinessName(value);
                break;
            case i18nJobTitle:
                setJobTitle(value);
                break;
            case i18nAptFloorSuite:
                setAptFloorSuite(value);
                break;
            case i18nCity:
                setCity(value);
                break;
            case i18nZipCode:
                setZipCode(value);
                break;
            case i18nGroupCode:
                setGroupCode(value.toUpperCase());
                break;
            default:
                break;
        }
    };
    const onBlurInput = async (name, value)=>{
        const setError = (errorName, errorValue)=>{
            switch(name){
                case "firstName":
                    setFirstNameError(errorValue);
                    break;
                case "lastName":
                    setLastNameError(errorValue);
                    break;
                case "emailAddress":
                    setEmailAddressError(errorValue);
                    break;
                case "businessName":
                    setBusinessNameError(errorValue);
                    break;
                case "businessPhoneNumber":
                    setBusinessPhoneNumberError(errorValue);
                    break;
                case "streetAddress":
                    setStreetAddressError(errorValue);
                    break;
                case "city":
                    setCityError(errorValue);
                    break;
                case "zipCode":
                    setZipCodeError(errorValue);
                    break;
                case "groupCode":
                    setGroupCodeError(errorValue);
                    break;
                default:
                    break;
            }
        };
        switch(name){
            case "firstName":
                return !value ? setError("firstName", {
                    show: true,
                    message: i18nFirstNameError
                }) : setError("firstName", {
                    show: false,
                    message: ""
                });
            case "lastName":
                return !value ? setError("lastName", {
                    show: true,
                    message: i18nLastNameError
                }) : setError("lastName", {
                    show: false,
                    message: ""
                });
            case "emailAddress":
                return !value || !await (0,helper/* validateField */.OP$)("email", value) ? setError("emailAddress", {
                    show: true,
                    message: i18nEmailAddressError
                }) : setError("emailAddress", {
                    show: false,
                    message: ""
                });
            case "businessName":
                return !value ? setError("businessName", {
                    show: true,
                    message: i18nBusinessNameError
                }) : setError("businessName", {
                    show: false,
                    message: ""
                });
            case "businessPhoneNumber":
                return !value || value.length < 14 ? setError("businessPhoneNumber", {
                    show: true,
                    message: i18nBusinessPhoneNumberError
                }) : setError("businessPhoneNumber", {
                    show: false,
                    message: ""
                });
            case "streetAddress":
                return !value ? setError("streetAddress", {
                    show: true,
                    message: i18nStreetAddressError
                }) : setError("streetAddress", {
                    show: false,
                    message: ""
                });
            case "city":
                return !value ? setError("city", {
                    show: true,
                    message: i18nCityError
                }) : setError("city", {
                    show: false,
                    message: ""
                });
            case "zipCode":
                return !value || value.length < 5 ? setError("zipCode", {
                    show: true,
                    message: i18nZipCodeError
                }) : setError("zipCode", {
                    show: false,
                    message: ""
                });
            case "groupCode":
                return !value ? setError("groupCode", {
                    show: true,
                    message: i18nGroupCodeError
                }) : setError("groupCode", {
                    show: false,
                    message: ""
                });
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "key-specifier ".concat((index_module_default()).keySpecifierStyleWrapper),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "key-specifier__header",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "key-specifier__title",
                    id: "key-specifier__title",
                    children: i18nName
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "key-specifier__description",
                id: "key-specifier__description",
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "key-specifier__sub",
                children: yourInformation
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "key-specifier__personal-info-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        id: "firstName",
                        type: "text",
                        value: firstName,
                        maxLength: 40,
                        placeholder: "".concat(i18nFirstName, "*"),
                        label: "".concat(i18nFirstName, "*"),
                        name: i18nFirstName,
                        onChange: handleChange,
                        showError: firstNameError === null || firstNameError === void 0 ? void 0 : firstNameError.show,
                        errorMessage: firstNameError === null || firstNameError === void 0 ? void 0 : firstNameError.message,
                        onBlur: ()=>onBlurInput("firstName", firstName)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        id: "lastName",
                        type: "text",
                        value: lastName,
                        maxLength: 40,
                        placeholder: "".concat(i18nLastName, "*"),
                        label: "".concat(i18nLastName, "*"),
                        name: i18nLastName,
                        onChange: handleChange,
                        showError: lastNameError.show,
                        errorMessage: lastNameError === null || lastNameError === void 0 ? void 0 : lastNameError.message,
                        onBlur: ()=>onBlurInput("lastName", lastName)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        id: "emailAddress",
                        type: "text",
                        value: emailAddress,
                        maxLength: 40,
                        placeholder: "".concat(i18nEmailAddress, "*"),
                        label: "".concat(i18nEmailAddress, "*"),
                        name: i18nEmailAddress,
                        onChange: handleChange,
                        showError: emailAddressError === null || emailAddressError === void 0 ? void 0 : emailAddressError.show,
                        errorMessage: emailAddressError === null || emailAddressError === void 0 ? void 0 : emailAddressError.message,
                        onBlur: ()=>onBlurInput("emailAddress", emailAddress)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "key-specifier__business-info-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "key-specifier__sub",
                        children: businessInformation
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        id: "businessName",
                        type: "text",
                        value: businessName,
                        maxLength: 40,
                        placeholder: "".concat(i18nBusinessName, "*"),
                        label: "".concat(i18nBusinessName, "*"),
                        name: i18nBusinessName,
                        onChange: handleChange,
                        showError: businessNameError === null || businessNameError === void 0 ? void 0 : businessNameError.show,
                        errorMessage: businessNameError === null || businessNameError === void 0 ? void 0 : businessNameError.message,
                        onBlur: ()=>onBlurInput("businessName", businessName)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        id: "jobTitle",
                        type: "text",
                        value: jobTitle,
                        maxLength: 40,
                        placeholder: "".concat(i18nJobTitle),
                        label: "".concat(i18nJobTitle),
                        name: i18nJobTitle,
                        onChange: handleChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "key-specifier__drop",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                            id: "primaryBusinessType",
                            data: businessTypes.map((el)=>el.text),
                            label: "".concat(primaryBusinessType, "*"),
                            value: type,
                            onChange: (val)=>setType(val)
                        })
                    }),
                    isShowSubType && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "key-specifier__drop",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                            id: "subType",
                            data: type ? businessTypes.find((el)=>el.text === type).value.split(",") : [],
                            label: type ? "Type of ".concat(type, "*") : "".concat(subType, "*"),
                            value: subType,
                            onChange: (val)=>setSubType(val)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        id: "businessPhoneNumber",
                        type: "text",
                        value: businessPhoneNumber,
                        maxLength: 40,
                        placeholder: "".concat(i18nBusinessPhoneNumber, "*"),
                        label: "".concat(i18nBusinessPhoneNumber, "*"),
                        name: i18nBusinessPhoneNumber,
                        onChange: (e)=>setBusinessPhoneNumber((0,RegisterOnlineHelper/* convertToPhoneNumber */["in"])(e.target.value)),
                        showError: businessPhoneNumberError === null || businessPhoneNumberError === void 0 ? void 0 : businessPhoneNumberError.show,
                        errorMessage: businessPhoneNumberError === null || businessPhoneNumberError === void 0 ? void 0 : businessPhoneNumberError.message,
                        onBlur: ()=>onBlurInput("businessPhoneNumber", businessPhoneNumber)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "key-specifier__business-addr-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "key-specifier__sub",
                        children: businessAddress
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        id: "streetAddress",
                        type: "text",
                        value: streetAddress,
                        maxLength: 40,
                        placeholder: "".concat(i18nStreetAddress, "*"),
                        label: "".concat(i18nStreetAddress, "*"),
                        name: i18nStreetAddress,
                        onChange: (e)=>handleAddressChange(e.target.value),
                        showError: streetAddressError === null || streetAddressError === void 0 ? void 0 : streetAddressError.show,
                        errorMessage: streetAddressError === null || streetAddressError === void 0 ? void 0 : streetAddressError.message,
                        suggestions: suggestions,
                        onSelect: (val)=>onSuggestionSelect(val),
                        onBlur: ()=>onBlurInput("streetAddress", streetAddress)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        id: "aptFloorSuite",
                        type: "text",
                        value: aptFloorSuite,
                        maxLength: 40,
                        placeholder: "".concat(i18nAptFloorSuite),
                        label: "".concat(i18nAptFloorSuite),
                        name: i18nAptFloorSuite,
                        onChange: handleChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        id: "city",
                        type: "text",
                        value: city,
                        maxLength: 40,
                        placeholder: "".concat(i18nCity, "*"),
                        label: "".concat(i18nCity, "*"),
                        name: i18nCity,
                        onChange: handleChange,
                        showError: cityError === null || cityError === void 0 ? void 0 : cityError.show,
                        errorMessage: cityError === null || cityError === void 0 ? void 0 : cityError.message,
                        onBlur: ()=>onBlurInput("city", city)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "key-specifier__state-zip",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "key-specifier__state",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                    id: "state",
                                    data: states.map((el)=>el.name),
                                    label: "".concat(i18nState, "*"),
                                    value: state,
                                    minLength: 20,
                                    onChange: (val)=>setState(val)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "key-specifier__zip",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    id: "zipCode",
                                    type: "text",
                                    value: zipCode,
                                    maxLength: 40,
                                    placeholder: "".concat(i18nZipCode, "*"),
                                    label: "".concat(i18nZipCode, "*"),
                                    name: i18nZipCode,
                                    onChange: handleChange,
                                    showError: zipCodeError === null || zipCodeError === void 0 ? void 0 : zipCodeError.show,
                                    errorMessage: zipCodeError === null || zipCodeError === void 0 ? void 0 : zipCodeError.message,
                                    onBlur: ()=>onBlurInput("zipCode", zipCode)
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "key-specifier__groupcode-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "key-specifier__sub",
                        children: keySpecifierGroupCode
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        id: "groupCode",
                        type: "text",
                        value: groupCode,
                        maxLength: 40,
                        placeholder: "".concat(i18nGroupCode, "*"),
                        label: "".concat(i18nGroupCode, "*"),
                        name: i18nGroupCode,
                        onChange: handleChange,
                        showError: groupCodeError === null || groupCodeError === void 0 ? void 0 : groupCodeError.show,
                        errorMessage: groupCodeError === null || groupCodeError === void 0 ? void 0 : groupCodeError.message,
                        onBlur: ()=>onBlurInput("groupCode", groupCode)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "key-specifier__description",
                children: installingProductatBusinessAbove
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "radio-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                        id: "installed-product",
                        name: "installed-product",
                        value: yes,
                        checked: active,
                        onClick: ()=>setActive(true)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                        id: "uninstalled-product",
                        name: "installed-product",
                        value: no,
                        checked: !active,
                        onClick: ()=>setActive(false)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "key-specifier__terms",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        checkBoxAria: termsAndConditions1,
                        checked: policy1,
                        onChange: (e)=>handleTermsPolicy(e)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "key-specifier__terms_policy key-specifier__terms_policy1",
                        children: (0,helper/* sanitizeInnerHtml */.KD0)(termsAndConditions)
                    })
                ]
            }),
            (policy1Error === null || policy1Error === void 0 ? void 0 : policy1Error.show) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "key-specifier__tnc",
                children: policy1Error === null || policy1Error === void 0 ? void 0 : policy1Error.message
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "key-specifier__terms",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        checked: policy2,
                        onChange: (e)=>setPolicy2(e.target.checked)
                    }),
                    getInspring
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "key-specifier__terms",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        checked: policy3,
                        onChange: (e)=>setPolicy3(e.target.checked)
                    }),
                    stay
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "key-specifier__description1",
                children: (0,helper/* sanitizeInnerHtml */.KD0)(need)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "key-specifier__button",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    type: "black",
                    role: "button",
                    loading: loading,
                    flexible: true,
                    label: submit,
                    onClick: handleSubmit,
                    disabled: checkDisabled()
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptcha/* default */.Z, {
                getAnalyticsData: getRecaptchaAnalytics
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "key-specifier__policies",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        tabIndex: "0",
                        href: privacyPolicyLegal,
                        className: "gbh-data-layer",
                        "data-gbh-data-layer": getEventInfo("privacy policy", privacyPolicyLegal),
                        children: privacyPolicy
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        tabIndex: "0",
                        href: subjectAccessRequestLegal,
                        className: "gbh-data-layer",
                        "data-gbh-data-layer": getEventInfo("subject access request", subjectAccessRequestLegal),
                        children: subjectAccessRequest
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        tabIndex: "0",
                        href: termsOfServiceLegal,
                        className: "gbh-data-layer",
                        "data-gbh-data-layer": getEventInfo("terms of service", termsOfServiceLegal),
                        children: termsOfService
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var v1_KeySpecifierView = (KeySpecifierView);

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
;// CONCATENATED MODULE: ./src/i18n/useKeySpecifieri18n.js


const useKeySpecifieri18n = (param)=>{
    let { authorData: { keySubhead , successTitle , successDescription , successCtaLabel , emailBrand , keyTerms , keyIdeas , keyUpToDate , keySupport , keyTitleOne , keyTitleTwo , keyTitleThree , keyTitleFour , radialButtons , keyHeadline , keySuccessMessage , keyCta  } = {}  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        description: keySubhead ? (0,helper/* sanitizeText */.oOy)(keySubhead) : t("kf.keyspecifier.label.description"),
        successTitle: successTitle ? (0,helper/* sanitizeText */.oOy)(successTitle) : t("kf.keyspecifier.label.successTitle"),
        successMessage: successDescription ? (0,helper/* sanitizeText */.oOy)(successDescription) : t("kf.keyspecifier.label.successMessage"),
        continueShopping: successCtaLabel ? (0,helper/* sanitizeText */.oOy)(successCtaLabel) : t("kf.keyspecifier.label.continueShopping"),
        termsAndConditions: keyTerms || t("kf.keyspecifier.label.termsAndConditions"),
        termsAndConditions1: t("kf.keyspecifier.label.termsAndConditions1"),
        getInspring: keyIdeas ? (0,helper/* sanitizeText */.oOy)(keyIdeas) : t("kf.keyspecifier.label.getIdeas"),
        stay: keyUpToDate ? (0,helper/* sanitizeText */.oOy)(keyUpToDate) : t("kf.keyspecifier.label.stay"),
        need: keySupport || t("kf.keyspecifier.label.need"),
        privacyPolicy: t("kf.keyspecifier.label.privacyPolicy"),
        subjectAccessRequest: t("kf.keyspecifier.label.subjectAccessRequest"),
        termsOfService: t("kf.keyspecifier.label.termsOfService"),
        codeInvalidError: t("kf.keyspecifier.label.codeInvalidError"),
        yourInformation: keyTitleOne || t("kf.keyspecifier.label.yourInformation"),
        businessInformation: keyTitleTwo || t("kf.keyspecifier.label.businessInformation"),
        businessAddress: keyTitleThree || t("kf.keyspecifier.label.businessAddress"),
        keySpecifierGroupCode: keyTitleFour || t("kf.keyspecifier.label.keySpecifierGroupCode"),
        firstName: t("kf.keyspecifier.label.firstName"),
        firstNameError: t("kf.keyspecifier.label.firstNameError"),
        lastName: t("kf.keyspecifier.label.lastName"),
        lastNameError: t("kf.keyspecifier.label.lastNameError"),
        emailAddress: t("kf.keyspecifier.label.emailAddress"),
        emailAddressError: t("kf.keyspecifier.label.emailAddressError"),
        businessName: t("kf.keyspecifier.label.businessName"),
        businessNameError: t("kf.keyspecifier.label.businessNameError"),
        jobTitle: t("kf.keyspecifier.label.jobTitle"),
        primaryBusinessType: t("kf.keyspecifier.label.primaryBusinessType"),
        primaryBusinessTypeError: t("kf.keyspecifier.label.primaryBusinessTypeError"),
        typeofDesigner: t("kf.keyspecifier.label.typeofDesigner"),
        typeofDesignerError: t("kf.keyspecifier.label.typeofDesignerError"),
        businessPhoneNumber: t("kf.keyspecifier.label.businessPhoneNumber"),
        businessPhoneNumberError: t("kf.keyspecifier.label.businessPhoneNumberError"),
        streetAddress: t("kf.keyspecifier.label.streetAddress"),
        streetAddressError: t("kf.keyspecifier.label.streetAddressError"),
        aptFloorSuite: t("kf.keyspecifier.label.aptFloorSuite"),
        city: t("kf.keyspecifier.label.city"),
        cityError: t("kf.keyspecifier.label.cityError"),
        state: t("kf.keyspecifier.label.state"),
        stateError: t("kf.keyspecifier.label.stateError"),
        zipCode: t("kf.keyspecifier.label.zipCode"),
        zipCodeError: t("kf.keyspecifier.label.zipCodeError"),
        groupCode: t("kf.keyspecifier.label.groupCode"),
        groupCodeError: t("kf.keyspecifier.label.groupCodeError"),
        installingProductatBusinessAbove: radialButtons || t("kf.keyspecifier.label.installingProductatBusinessAbove"),
        name: keyHeadline || t("kf.keyspecifier.label.name"),
        subType: t("kf.keyspecifier.label.subType"),
        policy1Error: t("kf.keyspecifier.label.policy1Error"),
        message: keySuccessMessage ? (0,helper/* sanitizeText */.oOy)(keySuccessMessage) : t("kf.keyspecifier.label.message"),
        sampleProps: t("kf.keyspecifier.label.sampleProps"),
        subTypeSet: t("kf.keyspecifier.label.subTypeSet"),
        primaryBusinessTypeSet: t("kf.keyspecifier.label.primaryBusinessTypeSet"),
        stateSet: t("kf.keyspecifier.label.stateSet"),
        yes: t("kf.keyspecifier.label.yes"),
        no: t("kf.keyspecifier.label.no"),
        submit: keyCta || t("kf.keyspecifier.label.submit"),
        needSupport: t("kf.keyspecifier.label.needSupport"),
        genError: t("kf.error.message.genericError")
    };
    return i18n;
};
/* harmony default export */ var i18n_useKeySpecifieri18n = (useKeySpecifieri18n);

// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
// EXTERNAL MODULE: ./src/components/FriendsAndFamily/v1/friendsAndFamilyHelper.js
var friendsAndFamilyHelper = __webpack_require__(91960);
;// CONCATENATED MODULE: ./src/components/KeySpecifier/v1/KeySpecifier.jsx


















const KeySpecifier = (props)=>{
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { data: authorData  } = props;
    const { emailBrand =""  } = authorData;
    const i18n = i18n_useKeySpecifieri18n({
        authorData
    });
    const { pageIsInteractive  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { successMessage , successTitle , genError , codeInvalidError , continueShopping  } = i18n;
    const { countryListPath , stateListPath , businessListPath , stateToCountryList: countries , countryList: countryLists  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [showSuccess, setShowSuccess] = (0,react.useState)(false);
    const [applyForm, setApplyForm] = (0,react.useState)(false);
    const [showAlertModal, setShowAlertModal] = (0,react.useState)(false);
    const [loading, setLoading] = (0,react.useState)(false);
    const [businessTypes, setBusinessTypes] = (0,react.useState)([]);
    const [stateList, setStateList] = (0,react.useState)([]);
    const [country, setCountry] = (0,react.useState)("");
    const [legalPageLinks, setLegalPageLinks] = (0,react.useState)("");
    const [nodeList, setNodeList] = (0,react.useState)([]);
    const [btnLoaded, setBtnLoaded] = (0,react.useState)(false);
    const [general, setGeneral] = (0,react.useState)({});
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        (0,friendsAndFamilyHelper/* redirectionToContentPage */.f)();
    }, []);
    (0,react.useEffect)(()=>{
        dispatch((0,genericSlice/* getGenericListPath */.Ln)());
        (0,config/* getConfig */.i)().then((config)=>{
            const legalPageLinks = get_default()(config, "legalPageData", {});
            const country = get_default()(config, "internationalization.country", "");
            const general = {
                country
            };
            setGeneral(general);
            setLegalPageLinks(legalPageLinks);
            setCountry(country);
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (!showAlertModal || !showSuccess) {
            setBtnLoaded(false);
        } else {
            setBtnLoaded(true);
        }
    }, [
        showAlertModal,
        showSuccess
    ]);
    (0,react.useEffect)(()=>{
        if (!isSsr && pageIsInteractive) {
            if (!btnLoaded) {
                setTimeout(function() {
                    getNodeList();
                }, 1000);
            }
        }
    }, [
        isSsr,
        pageIsInteractive,
        btnLoaded,
        nodeList
    ]);
    const getNodeList = ()=>{
        if (document.querySelectorAll(constants.KEY_SPECIFIER_QUERRY_SELECTOR_URL)) {
            setNodeList(document.querySelectorAll(constants.KEY_SPECIFIER_QUERRY_SELECTOR_URL));
            showMembershipPopupHandler();
        }
    };
    const showMembershipPopupHandler = ()=>{
        nodeList.forEach((el)=>{
            el.addEventListener("click", (e)=>{
                e.preventDefault();
                setShowAlertModal(true);
                setShowSuccess(false);
                setApplyForm(true);
            });
        });
    };
    (0,react.useEffect)(()=>{
        try {
            if (!isEmpty_default()(countryListPath) && !isEmpty_default()(stateListPath)) {
                (0,RegisterOfflineHelper/* getLocations */.JC)();
                getBusinessTypes();
            }
        } catch (error) {
            console.error(error);
        }
    }, [
        countryListPath,
        stateListPath,
        businessListPath
    ]);
    (0,react.useEffect)(()=>{
        if (countries === null || countries === void 0 ? void 0 : countries.length) {
            var ref, ref1;
            var ref2;
            const country = (ref2 = (ref = countryLists.find((country)=>{
                return country.value === (general === null || general === void 0 ? void 0 : general.country);
            })) === null || ref === void 0 ? void 0 : ref.text) !== null && ref2 !== void 0 ? ref2 : "";
            var ref3;
            const stateList = (ref3 = (ref1 = countries.find((country)=>country.code === "US")) === null || ref1 === void 0 ? void 0 : ref1.states) !== null && ref3 !== void 0 ? ref3 : [];
            setCountry(country);
            setStateList(stateList);
        }
    }, [
        countries
    ]);
    const showToaster = (msg)=>{
        dispatch((0,genericSlice/* showToast */.CF)({
            message: msg,
            isVisible: true
        }));
    };
    const handleClose = ()=>{
        setShowAlertModal(false);
        setShowSuccess(false);
    };
    const registerUser = (body, cb, analyticsCB)=>{
        setLoading(true);
        (0,ReCaptcha/* validateRecaptcha */.L)().then((res)=>{
            if (res.success) {
                api/* apim.post */.TH.post(constants.KEY_SPECIFIER_API_URL_ENDPOINT, body).then(()=>{
                    setLoading(false);
                    setShowAlertModal(false);
                    setShowSuccess(true);
                    setApplyForm(false);
                    analyticsCB === null || analyticsCB === void 0 ? void 0 : analyticsCB("success");
                }).catch((err)=>{
                    console.error(err);
                    setLoading(false);
                    cb();
                    analyticsCB === null || analyticsCB === void 0 ? void 0 : analyticsCB("failure", codeInvalidError === null || codeInvalidError === void 0 ? void 0 : codeInvalidError.toLowerCase());
                });
            } else {
                setLoading(false);
                showToaster(genError);
                analyticsCB("failure", genError === null || genError === void 0 ? void 0 : genError.toLowerCase());
            }
        }).catch((err)=>{
            console.error(err);
            analyticsCB === null || analyticsCB === void 0 ? void 0 : analyticsCB("failure", genError === null || genError === void 0 ? void 0 : genError.toLowerCase());
        });
    };
    const getBusinessTypes = async ()=>{
        const { payload: businessType  } = await dispatch((0,genericSlice/* getBusinessList */.Dz)());
        setBusinessTypes(businessType);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal["default"], {
        labelledBy: "key-specifier__title",
        describedBy: "key-specifier__description",
        showModal: showAlertModal || showSuccess,
        onModalClose: handleClose,
        children: [
            applyForm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_KeySpecifierView, {
                showModal: showAlertModal,
                i18n: i18n,
                registerUser: registerUser,
                loading: loading,
                businessTypes: businessTypes,
                states: stateList,
                legalPages: legalPageLinks,
                countries: countries,
                country: country,
                emailBrand: emailBrand
            }) : null,
            showSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "success-modelId",
                tabIndex: "0",
                className: "success-message-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "success-modal-header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: successTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "success-message-model",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: (0,helper/* sanitizeInnerHtml */.KD0)(successMessage)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "black",
                        role: "button",
                        label: continueShopping,
                        onClick: handleClose,
                        className: "gbh-data-layer"
                    })
                ]
            }) : null
        ]
    });
};
/* harmony default export */ var v1_KeySpecifier = (KeySpecifier);


/***/ }),

/***/ 99056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_KnowledgeArticle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./src/hooks/useIsSsr.js
var useIsSsr = __webpack_require__(7154);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./src/components/KnowledgeArticle/v1/KnowledgeArticleFiller.jsx
var KnowledgeArticleFiller = __webpack_require__(79491);
// EXTERNAL MODULE: ./components/Search/v1/InspirationTab/index.jsx
var InspirationTab = __webpack_require__(40577);
// EXTERNAL MODULE: ./src/components/core/PageTitle/index.module.scss
var index_module = __webpack_require__(18928);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/components/core/PageTitle/PageTitle.jsx



const PageTitle = (param)=>{
    let { title ="" , desc ="" , total =0  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).pageTitleWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container kf-react-plp-container kf-react-plp-container__container-border",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "kf-page-title",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "kf-page-title__titleBox",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "kf-page-title__title",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    "aria-label": total,
                                    className: "kf-page-title__total d-none d-lg-block",
                                    children: total
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "kf-page-title__descBox",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "kf-page-title__desc",
                                children: desc
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "kf-page-title__total d-lg-none",
                    children: total
                })
            ]
        })
    });
};
/* harmony default export */ var PageTitle_PageTitle = (PageTitle);

// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
;// CONCATENATED MODULE: ./src/i18n/useKnowledgeArticlei18n.js

const useKnowledgeArticlei18n = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        print: t("kf.plp.label.print"),
        share: t("kf.plp.label.share"),
        wishlist: t("kf.plp.label.wishlist"),
        showFilter: t("kf.plp.label.showFilter"),
        hideFilter: t("kf.plp.label.hideFilter"),
        filters: t("kf.plp.label.filters"),
        view: t("kf.plp.label.view"),
        all: t("kf.plp.label.all"),
        sort: t("kf.plp.label.sort"),
        applyFilters: "Apply Filters",
        loadMore: t("kf.plp.label.loadMore"),
        backToTop: t("kf.plp.label.backToTop"),
        showMore: t("kf.plp.label.showMore"),
        showLess: t("kf.plp.label.showLess"),
        clearAll: t("kf.plp.label.clearAll"),
        relevancy: t("kf.plp.label.relevancy"),
        date: t("kf.plp.label.date"),
        featured: t("kf.plp.label.featured"),
        filterSort: t("kf.plp.label.filterSort"),
        atoz: t("kf.plp.label.atoz"),
        ztoa: t("kf.plp.label.ztoa"),
        loading: t("kf.search.label.loading"),
        articles: t("kf.ka.label.articles"),
        viewResults: t("kf.plp.label.viewResults"),
        results: t("kf.plp.label.results"),
        items: t("kf.plp.label.items"),
        etc: t("kf.plp.label.etc"),
        sortByAria: (count)=>t("kf.plp.label.sortByAria", {
                sortByCount: count
            }),
        ariaLabel: {
            loadMore: t("kf.search.aria.label.loadMore"),
            loadMoreArticles: t("kf.search.aria.label.loadMoreArticles")
        },
        arialLabelPrint: (val)=>t("kf.plp.label.aria.print", {
                val: val
            }),
        ariaLabelShare: (val)=>t("kf.plp.label.aria.share", {
                val: "".concat(val, " page")
            }),
        filterTitle: (facetName, facetCount)=>t("kf.plp.ariaLabel.filterTitle", {
                facetName: facetName,
                facetCount: facetCount
            })
    };
    return i18n;
};
/* harmony default export */ var i18n_useKnowledgeArticlei18n = (useKnowledgeArticlei18n);

// EXTERNAL MODULE: ./src/store/features/productListSlice.js
var productListSlice = __webpack_require__(42286);
// EXTERNAL MODULE: ./components/AemGrid.jsx + 103 modules
var AemGrid = __webpack_require__(30390);
;// CONCATENATED MODULE: ./src/components/KnowledgeArticle/v1/KnowledgeArticle.jsx

















const KnowledgeArticle = (param)=>{
    let { data ={} , urlNames ="" , data404 ={}  } = param;
    const isSsr = (0,useIsSsr/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const [lwAppName, setLwAppName] = (0,react.useState)("");
    const [state, setState] = (0,react.useState)({
        id: ""
    });
    const [knowledgeArticlePath, setKnowledgeArticlePath] = (0,react.useState)("");
    const [show404, setShow404] = (0,react.useState)(false);
    const staticTexts = i18n_useKnowledgeArticlei18n();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { total =0  } = (0,es/* useSelector */.v9)(productListSlice/* selectProductListState */.rv).plp;
    const { title ="" , description =""  } = data;
    const handle404 = async function() {
        let queryParams = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const { payload: { data: { data: finalData = []  } = {}  } = {}  } = await dispatch((0,productListSlice/* getProducts */.Xp)({
            ...queryParams
        }));
        if (!finalData.length) {
            setShow404(true);
        }
    };
    const executeProductsAPI = function() {
        let urlNames = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", appName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        if (urlNames && appName) {
            const fl = [
                "id",
                "url_s",
                "title_s",
                "pageTitle_s",
                "eyeBrowText_s",
                "thumbNailImage_s",
                "searchDescription_s"
            ];
            const queryParams = {
                q: "*:*",
                start: 0,
                rows: 30,
                isFaq: true,
                displaytype: "",
                fl: fl.join(","),
                fq: 'urlName_s:("'.concat(urlNames, '")'),
                collections: appName.toLowerCase(),
                profileName: "profile_".concat(appName.toLowerCase(), "_PLP_Knowledge_Article")
            };
            handle404(queryParams);
        }
    };
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then((config)=>{
            const knowledgeArticlePath = get_default()(config, "general.knowledgeArticlePath", "");
            var ref;
            const currPage = (ref = knowledgeArticlePath.split("/").pop().replace(".html", "")) !== null && ref !== void 0 ? ref : "";
            const isArticleUrlPath = !(urlNames === null || urlNames === void 0 ? void 0 : urlNames.match(currPage));
            const { general: { lwAppName: appName = ""  } = {}  } = config !== null && config !== void 0 ? config : {};
            (0,helper/* getShortenedUrl */.Ppy)(knowledgeArticlePath).then((url)=>{
                setKnowledgeArticlePath(url);
            });
            setLwAppName(appName);
            if (data) {
                setState({
                    ...state,
                    id: isArticleUrlPath ? urlNames : ""
                });
            } else {
                console.error("Knowledge Articles: Get URL Property not found");
            }
            executeProductsAPI(urlNames, appName);
        });
        return ()=>{};
    }, [
        router,
        urlNames
    ]);
    return show404 ? !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid/* default */.Z, {
        data: data404
    }) : null : !isEmpty_default()(staticTexts) && !isEmpty_default()(lwAppName) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        tabIndex: "-1",
        label: "KnowledgeArticle",
        className: "knowledge-article product-listing ",
        children: [
            !urlNames ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle_PageTitle, {
                title: title,
                desc: (0,helper/* cleanText */.FV)(description),
                total: "".concat(total, " ").concat(staticTexts.articles)
            }) : null,
            isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(KnowledgeArticleFiller/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationTab/* default */.Z, {
                page: "article",
                type: "Help",
                staticTexts: staticTexts,
                translate: t,
                displayShare: true,
                displayPrint: true,
                articlesText: staticTexts.articles,
                totalSearchResults: total,
                productsPerPage: constants.PRODUCTS_PER_PAGE,
                profileName: "profile_".concat(lwAppName.toLowerCase(), "_PLP_Knowledge_Article"),
                pageId: state.id,
                knowledgeArticleUrl: knowledgeArticlePath,
                disableThumbnail: true,
                lwAppName: lwAppName,
                isReplace: true,
                isUpdateUrl: true,
                isSearchTab: false,
                isFaq: true,
                showTotal: false
            })
        ]
    }) : null;
};
/* harmony default export */ var v1_KnowledgeArticle = (KnowledgeArticle);


/***/ }),

/***/ 11419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_Literature; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
;// CONCATENATED MODULE: ./src/i18n/useLiteraturei18n.js

const useLiteraturei18n = (authorData)=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        print: t("kf.plp.label.print"),
        share: t("kf.plp.label.share"),
        wishlist: t("kf.plp.label.wishlist"),
        showFilter: t("kf.plp.label.showFilter"),
        hideFilter: t("kf.plp.label.hideFilter"),
        filters: t("kf.plp.label.filters"),
        view: t("kf.plp.label.view"),
        all: t("kf.plp.label.all"),
        sort: t("kf.plp.label.sort"),
        sortbyExpanded: t("kf.plp.label.sortbyExpanded"),
        sortbyClosed: t("kf.plp.label.sortbyClosed"),
        selected: t("kf.plp.arialabel.selected"),
        altSort: t("kf.plp.label.img.altSort"),
        applyFilters: "Apply Filters",
        loadMore: t("kf.plp.label.loadMore"),
        backToTop: t("kf.plp.label.backToTop"),
        backToResult: t("kf.plp.label.backToResult"),
        showMore: t("kf.plp.label.showMore"),
        showLess: t("kf.plp.label.showLess"),
        clearAll: t("kf.plp.label.clearAll"),
        relevancy: t("kf.plp.label.relevancy"),
        date: t("kf.plp.label.date"),
        atoz: t("kf.plp.label.atoz"),
        ztoa: t("kf.plp.label.ztoa"),
        loading: t("kf.search.label.loading"),
        resources: (authorData === null || authorData === void 0 ? void 0 : authorData.resultstext) || t("kf.literature.label.resources"),
        viewResults: t("kf.plp.label.viewResults"),
        results: t("kf.plp.label.results"),
        download: t("kf.literature.label.download"),
        viewLiterature: t("kf.literature.label.view"),
        favSuccessMsg: t("kf.favorites.success"),
        favErrorMsg: t("kf.favorites.error"),
        items: t("kf.plp.label.items"),
        etc: t("kf.plp.label.etc"),
        gridView: t("kf.plp.label.gridView"),
        columnView: t("kf.plp.label.columnView"),
        ariaLabel: {
            loadMore: t("kf.literature.aria.label.loadMore"),
            pdf: t("kf.literature.aria.label.pdf"),
            columnViewSelected: t("kf.productTab.aria.columnViewSelected"),
            columnViewNotSelected: t("kf.productTab.aria.columnViewNotSelected"),
            gridViewSelected: t("kf.productTab.aria.gridViewSelected"),
            gridViewNotSelected: t("kf.productTab.aria.gridViewNotSelected")
        },
        arialLabelPrint: (val)=>t("kf.plp.label.aria.print", {
                val: val
            }),
        arialLabelShare: (val)=>t("kf.plp.label.aria.share", {
                val: "".concat(val, " page")
            }),
        filterTitle: (facetName, facetCount)=>{
            return t("kf.plp.ariaLabel.filterTitle", {
                facetName: facetName,
                facetCount: facetCount
            });
        },
        newToOld: t("kf.literature.label.newToOld"),
        oldToNew: t("kf.literature.label.oldToNew"),
        removeItem: t("kf.favorites.removeItem"),
        removeItemError: t("kf.favorites.removeItemError"),
        sortByAria: (count)=>t("kf.plp.label.sortByAria", {
                sortByCount: count
            }),
        featured: t("kf.plp.label.featured"),
        filters: t("kf.plp.label.filters")
    };
    return i18n;
};
/* harmony default export */ var i18n_useLiteraturei18n = (useLiteraturei18n);

// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-lazy-load/dist/LazyLoad.js
var LazyLoad = __webpack_require__(25043);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/react-sticky-el/lib/index.js
var react_sticky_el_lib = __webpack_require__(75198);
var lib_default = /*#__PURE__*/__webpack_require__.n(react_sticky_el_lib);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(18216);
// EXTERNAL MODULE: ./src/hooks/usePrevious.js
var usePrevious = __webpack_require__(97349);
// EXTERNAL MODULE: ./src/components/ProductList/v2/Sort/index.jsx + 2 modules
var Sort = __webpack_require__(73812);
// EXTERNAL MODULE: ./src/components/ProductList/v2/Filter/index.jsx + 3 modules
var Filter = __webpack_require__(61304);
// EXTERNAL MODULE: ./components/Search/v1/ProductsTab/helper.js
var helper = __webpack_require__(34955);
;// CONCATENATED MODULE: ./src/components/Literature/v1/literatureAnalytics.js
const getShowHideEventInfo = (showFilter)=>{
    const type = !showFilter ? "hide" : "show";
    return JSON.stringify({
        eventAction: "literature:filters:".concat(type, " filter"),
        eventName: "literature:filters:".concat(type, " filter"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(type, " filters"),
        internalLinkPosition: "literature",
        internalLinkType: "literature:".concat(type),
        internalLinkZoneName: "literature:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const backToTopEventInfo = JSON.stringify({
    eventAction: "literature:main content area:back to top",
    eventName: "literature:main content area:back to top",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "back to top",
    internalLinkPosition: "literature landing",
    internalLinkType: "literature:navigation",
    internalLinkZoneName: "literature:main content area",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const loadMoreEventInfo = JSON.stringify({
    eventAction: "literature landing:article list:load more",
    eventName: "literature landing:article list:load more",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "load more",
    internalLinkPosition: "literature landing",
    internalLinkType: "literature landing:load more",
    internalLinkZoneName: "literature landing:article list",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const downloadEventInfo = (title)=>{
    return JSON.stringify({
        eventAction: "literature pdf download",
        eventName: "literature pdf download",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "download",
        internalLinkPosition: "literature",
        internalLinkType: "literature :".concat(title, " "),
        internalLinkZoneName: "literature:main content area",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./utils/helper.js
var utils_helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
// EXTERNAL MODULE: ./public/icons/download-dark-gray.svg
var download_dark_gray = __webpack_require__(91883);
// EXTERNAL MODULE: ./src/components/core/Image/DynamicImage.jsx
var DynamicImage = __webpack_require__(96702);
;// CONCATENATED MODULE: ./src/components/Literature/v1/Literature.view/LiteratureTile.jsx








const LiteratureTile = (props)=>{
    const { image ="" , imgId ="" , brandName ="" , title ="" , externalLink ="" , i18n ={}  } = props;
    const imgPlaceholder = image ? image : "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    const handleImgErr = (e)=>e.target.src = image_missing/* default */.Z;
    const getImg = (img)=>{
        let imgURL;
        const hostName = img.split(".").splice(0, 2).join(".");
        if (brandName.toLowerCase() !== "kohler" && img.includes(hostName)) {
            imgURL = img.split(".").splice(0, 3).join(".");
        }
        return imgURL;
    };
    const checkImg = (e)=>{
        e.persist();
        const ele = e.target;
        if (ele.src !== image_missing/* default */.Z && ele.src === imgPlaceholder) {
            axios_default().head(ele.dataset.src).then((res)=>{
                if (!res) handleImgErr(e);
            }).catch(()=>handleImgErr(e));
        }
    };
    const handleClick = (e)=>{
        if (props === null || props === void 0 ? void 0 : props.slabExtRedirectionUrl) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            e === null || e === void 0 ? void 0 : e.stopPropagation();
            location.href = decodeURIComponent((props === null || props === void 0 ? void 0 : props.slabExtRedirectionUrl) ? props === null || props === void 0 ? void 0 : props.slabExtRedirectionUrl : "");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "literature-tile",
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage["default"], {
                id: imgId,
                onLoad: checkImg,
                imgUrl: getImg(image) || image,
                alt: title,
                className: "literature-tile__image",
                uniqueId: imgId,
                onError: handleImgErr
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "literature-tile__title",
                children: (0,utils_helper/* sanitizeInnerHtml */.KD0)(title)
            }),
            externalLink && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                "aria-label": "".concat(i18n.download, " ").concat(title, " ").concat(i18n.ariaLabel.pdf),
                href: externalLink,
                className: "literature-tile__download-cta gbh-data-layer",
                target: "_blank",
                rel: "noopener noreferrer",
                "data-gbh-data-layer": downloadEventInfo(title),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: download_dark_gray/* default.src */.Z.src,
                        alt: i18n.download
                    }),
                    i18n.download
                ]
            })
        ]
    });
};
/* harmony default export */ var Literature_view_LiteratureTile = (LiteratureTile);

// EXTERNAL MODULE: ./src/components/ProductList/v2/ProductListView/ProductsPerPage/index.jsx
var ProductsPerPage = __webpack_require__(93575);
// EXTERNAL MODULE: ./src/store/features/productListSlice.js
var productListSlice = __webpack_require__(42286);
// EXTERNAL MODULE: ./src/store/features/authSlice.js
var authSlice = __webpack_require__(2693);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./public/icons/share.svg
var share = __webpack_require__(66773);
// EXTERNAL MODULE: ./public/icons/filter.svg
var filter = __webpack_require__(24495);
// EXTERNAL MODULE: ./public/icons/print.svg
var print = __webpack_require__(30402);
// EXTERNAL MODULE: ./public/icons/back-top-arrow.svg
var back_top_arrow = __webpack_require__(12522);
// EXTERNAL MODULE: ./public/icons/column-off.svg
var column_off = __webpack_require__(4419);
// EXTERNAL MODULE: ./public/icons/column-on.svg
var column_on = __webpack_require__(84923);
// EXTERNAL MODULE: ./public/icons/grid-off.svg
var grid_off = __webpack_require__(8909);
// EXTERNAL MODULE: ./public/icons/grid-on.svg
var grid_on = __webpack_require__(7520);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
;// CONCATENATED MODULE: ./components/Literature/v1/Literature.view/index.jsx































const LiteratureView = (props)=>{
    var ref;
    const { staticTexts ={} , displayShare =false , displayPrint =false , isLandscape =false , productsPerPage =[] , setTotal =()=>{}  } = props;
    const selectedSortItem = (0,utils_helper/* getSortItemBasedOnURL */.KE)(staticTexts, {
        name: staticTexts.atoz,
        query: "title_s+asc"
    });
    const dispatch = (0,es/* useDispatch */.I0)();
    const [generalInfo, setGeneralInfo] = (0,react.useState)({});
    const [width] = (0,useWindowResize/* default */.Z)();
    const [urlCheck, setUrlCheck] = (0,react.useState)(false);
    const [showFilter, setShowFilter] = (0,react.useState)(width >= 1024 ? true : false);
    const [rowCols, setRowCols] = (0,react.useState)(width < 1024 ? 1 : 3);
    const [navSticky, setNavSticky] = (0,react.useState)(false);
    const [filters] = (0,react.useState)([]);
    const [curRows, setCurRows] = (0,react.useState)(constants.DEFAULT_PRODUCT_COUNT_PLP);
    const [start, setStart] = (0,react.useState)(0);
    const [selectedSort, setSelectedSort] = (0,react.useState)(selectedSortItem);
    const [filterQueries, setFilterQueries] = (0,react.useState)([]);
    const [selectedFilterCount, setSelectedFilterCount] = (0,react.useState)(0);
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    var ref1;
    const [scrollToSku, setScrollToSku] = (0,react.useState)((ref1 = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.plpScrollSku) !== null && ref1 !== void 0 ? ref1 : "");
    const prevRows = (0,usePrevious/* default */.Z)(curRows);
    const [dataPopulated, setDataPopulated] = (0,react.useState)(false);
    const [dataLoading, setDataLoading] = (0,react.useState)(false);
    const [language, setLanguage] = (0,react.useState)("");
    const [lwName, setLwName] = (0,react.useState)("");
    const { data =[] , total =0 , facets ={} , facetLabels ={} , colors ={} , status  } = (0,es/* useSelector */.v9)(productListSlice/* selectProductListState */.rv).plp;
    const resultField = (0,react.useRef)(null);
    const { access_token: accessToken  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then(async (config)=>{
            const { general ={} , internationalization ={}  } = config !== null && config !== void 0 ? config : {};
            setGeneralInfo(general);
            var ref;
            setLanguage((ref = internationalization === null || internationalization === void 0 ? void 0 : internationalization.language) !== null && ref !== void 0 ? ref : "en");
            var ref1;
            setLwName((ref1 = general === null || general === void 0 ? void 0 : general.lwAppName) !== null && ref1 !== void 0 ? ref1 : "");
        });
    }, []);
    const filterClass = classnames_default()({
        "product-list__filter": true,
        "product-list__filter--hide": !showFilter,
        "product-list__filter--modal": showFilter
    });
    const filterButtonClass = classnames_default()({
        "product-list__filter-toggle-text": true,
        "product-list__filter-toggle-text--show": !showFilter
    });
    const tileClass = classnames_default()({
        "product-list__tile-col": true,
        "product-list__tile-col--full-width": !showFilter,
        "literature-list__tile-col": true
    });
    const productListTileClass = classnames_default()({
        container: true,
        "kf-react-container": true,
        "product-list__tiles": false,
        "product-list__tiles-literature": true
    });
    const sorts = [
        {
            name: staticTexts.atoz,
            query: "title_s+asc"
        },
        {
            name: staticTexts.ztoa,
            query: "title_s+desc"
        },
        {
            name: staticTexts.newToOld,
            query: "lastModifiedDate_s+desc"
        },
        {
            name: staticTexts.oldToNew,
            query: "lastModifiedDate_s+asc"
        }
    ];
    const isAsLiterature = (generalInfo === null || generalInfo === void 0 ? void 0 : (ref = generalInfo.lwAppName) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (constants.annSacksConstants === null || constants.annSacksConstants === void 0 ? void 0 : constants.annSacksConstants.asBrandName);
    if (isAsLiterature) {
        sorts === null || sorts === void 0 ? void 0 : sorts.unshift({
            name: staticTexts.featured,
            query: ""
        });
    }
    (0,react.useEffect)(()=>{
        if (isLandscape && width) {
            switch(true){
                case width > 1024:
                    setRowCols(3);
                    break;
                case width < 668:
                    setRowCols(2);
                    break;
                default:
                    setRowCols(3);
            }
        }
    }, [
        isLandscape,
        width
    ]);
    (0,react.useEffect)(()=>{
        const filterCount = filterQueries.reduce((acc, item)=>{
            return acc + item.value.length;
        }, 0);
        setSelectedFilterCount(filterCount);
    }, [
        filters
    ]);
    // To get facet labels and to check if pre-selected filters are multi select facets
    const getFacets = async (category)=>{
        var ref;
        return await api/* apim.get */.TH.get("/search/plp", {
            params: {
                fl: "id",
                fq: 'language_s:("'.concat(language, '")'),
                q: "*:*",
                rows: 0,
                profilename: (props === null || props === void 0 ? void 0 : props.lwProfileName) || "profile_".concat(generalInfo === null || generalInfo === void 0 ? void 0 : (ref = generalInfo.lwAppName) === null || ref === void 0 ? void 0 : ref.toLowerCase(), "_PLP_Literature"),
                collections: generalInfo === null || generalInfo === void 0 ? void 0 : generalInfo.lwAppName.toLowerCase()
            }
        });
    };
    const onLoadFn = async ()=>{
        if (lwName && language) {
            //to scrollup the product list
            window.scrollTo(0, 0);
            let currFilters = [];
            try {
                //Get filters from url params
                const urlFilters = (0,utils_helper/* getFacetsFromUrl */.bZU)();
                if (urlFilters.length > 0) {
                    var ref, ref1, ref2;
                    const resp = await getFacets("Literature");
                    var ref3;
                    const facetLabels = (0,utils_helper/* getAsUniqueFilter */.B_)((ref3 = resp === null || resp === void 0 ? void 0 : (ref = resp.data) === null || ref === void 0 ? void 0 : (ref1 = ref.fusion) === null || ref1 === void 0 ? void 0 : ref1.facet_labels) !== null && ref3 !== void 0 ? ref3 : {});
                    var ref4;
                    const facetFields = (0,utils_helper/* getAsUniqueFilter */.B_)((ref4 = resp === null || resp === void 0 ? void 0 : (ref2 = resp.data) === null || ref2 === void 0 ? void 0 : ref2.fusion["facet.field"]) !== null && ref4 !== void 0 ? ref4 : {});
                    urlFilters.forEach((f)=>{
                        let facetQuery = f.facet === "Price_Range" ? "Price_Range" : Object.keys(facetLabels).find((key)=>facetLabels[key] === f.facet.replaceAll("_", " "));
                        if (Object.values(facetFields).find((f)=>f === facetQuery)) {
                            facetQuery = "**".concat(facetQuery);
                        }
                        if (facetQuery) {
                            f.facet = facetQuery;
                        }
                    });
                }
                currFilters = [
                    ...currFilters,
                    ...urlFilters
                ];
                generateListingUrl(null, null, currFilters);
            } catch (error) {
                console.log(error);
            }
        }
        setUrlCheck(true);
    };
    (0,react.useEffect)(()=>{
        if (lwName) {
            onLoadFn();
        }
    }, [
        lwName,
        language
    ]);
    (0,react.useEffect)(()=>{
        setTotal(total);
    }, [
        total
    ]);
    (0,react.useEffect)(()=>{
        // To scrollup the product list on back
        if (dataPopulated) (0,helper/* scrollToProduct */.C1)();
    }, [
        dataPopulated
    ]);
    const onRows = (rows)=>{
        setStart(0);
        setCurRows(rows);
    };
    const executeScroll = ()=>{
        modules/* scroller.scrollTo */.OK.scrollTo("products-tab", {
            duration: 1500,
            delay: 0,
            smooth: "easeInOutQuart"
        });
    };
    const onLoadMore = ()=>{
        setStart(start + curRows);
    };
    const onSort = (selectedSort)=>{
        setStart(0);
        setSelectedSort(selectedSort);
        setIsOpen(false);
    };
    (0,react.useEffect)(()=>{
        if (accessToken && filterQueries != null) {
            // will trigger from onLoadMore
            if (start) {
                generateListingUrl(true, false);
            // Will trigger when user coming back from PDP page
            } else if (!start && scrollToSku) {
                setScrollToSku("");
                generateListingUrl(false, true);
            } else if (!start && curRows && !!prevRows && prevRows > curRows) {
                generateListingUrl(false, true);
            } else if (!start && curRows) {
                generateListingUrl(false, false);
            }
        }
    }, [
        accessToken,
        start,
        curRows,
        selectedSort,
        filterQueries,
        urlCheck
    ]);
    const generateListingUrl = function(update) {
        let enableScroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, queries = arguments.length > 2 ? arguments[2] : void 0;
        if (!dataLoading && !dataPopulated) {
            var ref, ref1;
            let callStart = 0;
            if (queries) {
                setFilterQueries(queries);
            } else {
                queries = filterQueries;
                callStart = start;
            }
            const fq = [
                ""
            ];
            queries.forEach((q)=>{
                var ref;
                const tag = '{!tag="'.concat(q === null || q === void 0 ? void 0 : q.facet, '"}');
                if (!(q === null || q === void 0 ? void 0 : (ref = q.facet) === null || ref === void 0 ? void 0 : ref.match(/^\*{2}/))) {
                    fq.push(encodeURIComponent("".concat(tag + q.facet, ':("').concat(q.value.join('" OR "'), '")')));
                    return;
                }
                fq.push("".concat(q.facet.replace(/^\*{2}/, ""), ':("').concat(encodeURIComponent(q.value.join('","')), '")'));
            });
            const query = {
                fq,
                rows: curRows,
                start: callStart
            };
            if (selectedSort.name !== staticTexts.featured) {
                if (selectedSort.name) {
                    query.sort = selectedSort.query;
                }
            }
            const fl = [
                "id",
                "url_s",
                "title_s",
                "thumbnailImageURL_s",
                "externalRedirectUrl_s",
                "slabExtRedirectionUrl_s"
            ];
            const isSlabs = ((ref1 = props === null || props === void 0 ? void 0 : (ref = props.lwProfileName) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.includes("slab")) ? true : false;
            if (isSlabs) {
                fl.push("slabExtRedirectionUrl_s");
            }
            const { lwAppName =""  } = generalInfo;
            if (lwAppName !== "") {
                const queryParams = {
                    q: "*:*",
                    fl: fl.join(","),
                    fq: query.fq,
                    sort: query.sort,
                    rows: query.rows || 30,
                    start: query.start || 0,
                    collections: lwAppName === null || lwAppName === void 0 ? void 0 : lwAppName.toLowerCase(),
                    update,
                    query: {},
                    isFaq: true,
                    profileName: (props === null || props === void 0 ? void 0 : props.lwProfileName) || "profile_".concat(lwAppName === null || lwAppName === void 0 ? void 0 : lwAppName.toLowerCase(), "_PLP_Literature")
                };
                if (enableScroll) setDataPopulated(false);
                setDataLoading(true);
                dispatch((0,productListSlice/* getProducts */.Xp)(queryParams)).then(()=>{
                    if (enableScroll) setDataPopulated(true);
                    setDataLoading(false);
                }).catch(()=>{
                    if (enableScroll) setDataPopulated(false);
                    setDataLoading(false);
                });
            }
        }
    };
    const isOnlyMobile = lib/* isMobile */.tq && !isLandscape && !lib/* isTablet */.Em;
    const isMobileLandscape = lib/* isMobile */.tq && isLandscape && !lib/* isTablet */.Em;
    const isMobileLandscapeTablet = lib/* isMobile */.tq && !isLandscape && lib/* isTablet */.Em && width < 1024;
    const handleFilter = (queries)=>{
        setFilterQueries(queries);
        (0,helper/* scrollToFirstProduct */.nj)();
    };
    const handleBackToTop = ()=>{
        var ref;
        resultField === null || resultField === void 0 ? void 0 : (ref = resultField.current) === null || ref === void 0 ? void 0 : ref.focus();
        window.scrollTo({
            top: 200,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        className: "products-tab",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                onFixedToggle: ()=>setNavSticky(!navSticky),
                className: "product-list__sticky-nav-wrap ".concat(navSticky && "product-list__sticky-nav-container"),
                stickyStyle: {
                    top: "0px",
                    zIndex: 9
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container-fluid product-list__sticky-nav ".concat(navSticky && "product-list__sticky-nav--shadow"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row mx-0 px-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container kf-react-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "product-listing__literature product-listing__controls",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                "aria-label": total,
                                                className: "product-listing__total",
                                                "aria-live": "polite",
                                                role: "status",
                                                tabIndex: 0,
                                                ref: resultField,
                                                children: status === "succeeded" ? "".concat(total, " ").concat(props.staticTexts.resources) : ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        role: "link",
                                                        "aria-label": !showFilter ? staticTexts.showFilter : staticTexts.hideFilter,
                                                        className: "product-list__filter-toggle gbh-data-layer",
                                                        "data-gbh-data-layer": getShowHideEventInfo(showFilter),
                                                        onClick: ()=>setShowFilter(!showFilter),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: filter/* default.src */.Z.src,
                                                                className: "product-list__filter-toggle-icon",
                                                                alt: "Toggle Filter"
                                                            }),
                                                            isOnlyMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    staticTexts.filters,
                                                                    " ",
                                                                    selectedFilterCount > 0 && " (".concat(selectedFilterCount, ")")
                                                                ]
                                                            }) : isMobileLandscape ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    staticTexts.filters,
                                                                    " ",
                                                                    selectedFilterCount > 0 && " (".concat(selectedFilterCount, ")")
                                                                ]
                                                            }) : isMobileLandscapeTablet ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    staticTexts.filters,
                                                                    " ",
                                                                    selectedFilterCount > 0 && " (".concat(selectedFilterCount, ")")
                                                                ]
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                className: filterButtonClass,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                        className: showFilter ? "show" : "hide",
                                                                        children: staticTexts.hideFilter
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                        className: !showFilter ? "show" : "hide",
                                                                        children: staticTexts.showFilter
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    lib/* isMobile */.tq ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        tabIndex: "0",
                                                        "aria-label": rowCols > 1 ? staticTexts.ariaLabel.gridViewSelected : staticTexts.ariaLabel.gridViewNotSelected,
                                                        className: "product-list__transparent-button",
                                                        onClick: ()=>setRowCols(rowCols === 1 ? 2 : 1),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            role: "presentation",
                                                            className: "product-list__grid-control-icon",
                                                            src: rowCols > 1 ? grid_on/* default.src */.Z.src : grid_off/* default.src */.Z.src,
                                                            alt: staticTexts.gridView
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Sort/* default */.Z, {
                                                        tabIndex: "0",
                                                        data: sorts,
                                                        selectedSort: selectedSort,
                                                        texts: staticTexts,
                                                        onChange: onSort,
                                                        page: "literature",
                                                        isOpen: isOpen,
                                                        setIsOpen: setIsOpen
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: productListTileClass,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
                                    className: filterClass,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-list__filter--sticky",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter["default"], {
                                            rowCols: rowCols,
                                            texts: staticTexts,
                                            sorts: sorts,
                                            selectedSort: selectedSort,
                                            onSortChange: onSort,
                                            currFilters: filterQueries,
                                            selectedFilterCount: filterQueries && filterQueries.reduce((acc, item)=>{
                                                return acc + item.value.length;
                                            }, 0),
                                            onFilter: handleFilter,
                                            close: setShowFilter,
                                            colors: colors,
                                            displayShare: displayShare,
                                            displayPrint: displayPrint,
                                            showFilter: showFilter,
                                            handleScroll: executeScroll,
                                            totalResults: total,
                                            showSort: width <= 991,
                                            page: "literature",
                                            facetData: facets,
                                            facets: filters,
                                            facetLabels: facetLabels,
                                            addToUrl: isAsLiterature ? isAsLiterature : false,
                                            hidePriceRange: true,
                                            wrapperClass: ".literature-list-wrapper",
                                            isAsLiterature: isAsLiterature
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: tileClass,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "literature-list ".concat(rowCols === 2 && "literature-list__two-col", " ").concat(rowCols === 1 && "literature-list__one-col"),
                                            children: data.map((element, i)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "literature-list-wrapper",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoad/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Literature_view_LiteratureTile, {
                                                            imgId: "s7img-".concat(element.id),
                                                            title: element.title_s,
                                                            image: element.thumbnailImageURL_s,
                                                            url: element.url_s,
                                                            i18n: staticTexts,
                                                            brandName: generalInfo === null || generalInfo === void 0 ? void 0 : generalInfo.siteName,
                                                            externalLink: element.externalRedirectUrl_s,
                                                            data: element,
                                                            displayShare: displayShare,
                                                            slabExtRedirectionUrl: (0,utils_helper/* getShortenedUrlwithGeneral */.vu1)(get_default()(element, "slabExtRedirectionUrl_s", ""), generalInfo)
                                                        }, element.id)
                                                    })
                                                }, i);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: total > curRows && total > data.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        "aria-label": staticTexts.ariaLabel.loadMore,
                                                        className: "product-list__load-more gbh-data-layer",
                                                        "data-gbh-data-layer": loadMoreEventInfo,
                                                        onClick: onLoadMore,
                                                        children: staticTexts.loadMore
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "row",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "product-list__back-to-top",
                                                            children: [
                                                                lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "product-list__print-and-share",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            role: "button",
                                                                            onClick: ()=>window.print(),
                                                                            children: [
                                                                                staticTexts.print,
                                                                                " ",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                    src: print/* default.src */.Z.src,
                                                                                    alt: staticTexts.print
                                                                                })
                                                                            ]
                                                                        }),
                                                                        displayShare && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            role: "button",
                                                                            children: [
                                                                                staticTexts.share,
                                                                                " ",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                    src: share/* default.src */.Z.src,
                                                                                    alt: staticTexts.share
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                !lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsPerPage/* default */.Z, {
                                                                    page: "literature",
                                                                    curRows: curRows,
                                                                    data: productsPerPage,
                                                                    totalResults: total,
                                                                    texts: props.staticTexts,
                                                                    onChange: onRows
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                    className: "product-list__go-back gbh-data-layer",
                                                                    role: "link",
                                                                    "aria-label": staticTexts.backToResult,
                                                                    "data-gbh-data-layer": backToTopEventInfo,
                                                                    onClick: handleBackToTop,
                                                                    children: [
                                                                        staticTexts.backToTop,
                                                                        " ",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            "aria-hidden": "true",
                                                                            src: back_top_arrow/* default.src */.Z.src,
                                                                            alt: staticTexts.backToTop
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Literature_view = (LiteratureView);

// EXTERNAL MODULE: ./src/components/Literature/v1/Literature.view/index.module.scss
var index_module = __webpack_require__(9942);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/components/Literature/v1/Literature/index.jsx






const Literature = (param)=>{
    let { data: authorData = {}  } = param;
    const [total, setTotal] = (0,react.useState)(0);
    const productsPerPage = constants.PRODUCTS_PER_PAGE;
    const staticTexts = i18n_useLiteraturei18n(authorData);
    const updateTotal = (total)=>setTotal(total);
    const displayShare = (authorData === null || authorData === void 0 ? void 0 : authorData.enableSocialShare) !== undefined ? authorData.enableSocialShare : true;
    const lwProfileName = (authorData === null || authorData === void 0 ? void 0 : authorData.lwProfileName) !== undefined ? authorData === null || authorData === void 0 ? void 0 : authorData.lwProfileName : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((index_module_default()).literatureWrapper),
        id: "literatureWrapperId",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "literature",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Literature_view, {
                staticTexts: staticTexts,
                displayShare: displayShare,
                displayPrint: true,
                productsPerPage: productsPerPage,
                setTotal: updateTotal,
                type: "Literature",
                lwProfileName: lwProfileName
            })
        })
    });
};
/* harmony default export */ var v1_Literature = (Literature);


/***/ }),

/***/ 85180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fi": function() { return /* binding */ addReviewRegistrationEventInfo; },
/* harmony export */   "JC": function() { return /* binding */ getLocations; },
/* harmony export */   "KL": function() { return /* binding */ getProductDetails; },
/* harmony export */   "R9": function() { return /* binding */ getReviewRegistrationEventInfo; },
/* harmony export */   "SE": function() { return /* binding */ productInfoHandleSubmit; },
/* harmony export */   "VS": function() { return /* binding */ addReviewRegistrationAnalytics; },
/* harmony export */   "YU": function() { return /* binding */ submitRegistrationGenericError; },
/* harmony export */   "Z6": function() { return /* binding */ addReviewRegistrationSubmitDataLayer; },
/* harmony export */   "e7": function() { return /* binding */ addRegistrationInformationAnalytics; },
/* harmony export */   "fv": function() { return /* binding */ getProductConfirmationEventInfo; },
/* harmony export */   "fz": function() { return /* binding */ editButtonAnalyticsEventInfo; },
/* harmony export */   "mh": function() { return /* binding */ getAddAnotherProductAnalytics; },
/* harmony export */   "oP": function() { return /* binding */ getOfflineReviewProductsAnalytics; },
/* harmony export */   "q$": function() { return /* binding */ modalNumberSupportLinkEventInfo; },
/* harmony export */   "qf": function() { return /* binding */ getRemoveOfflineProductsAnalytics; },
/* harmony export */   "sg": function() { return /* binding */ addProductInformationAnalytics; },
/* harmony export */   "xX": function() { return /* binding */ getBackToProductsAnalytics; }
/* harmony export */ });
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88751);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27514);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20366);



// Analytics *********************
const editButtonAnalyticsEventInfo = (type)=>{
    return JSON.stringify({
        eventAction: "my account:register offline kohler products:".concat(type, ":edit"),
        eventName: "my account:register offline kohler products:".concat(type, ":edit"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "edit",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register offline kohler products:".concat(type),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const getBackToProductsAnalytics = (isSuccess, myProductsPath)=>{
    const pageName = isSuccess ? "thank you for registering the products" : "top navigation";
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "my account:register offline kohler products:".concat(pageName, ":back to my products"),
        eventName: "my account:register offline kohler products:".concat(pageName, ":back to my products"),
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "back to my products",
        eventType: "navigation",
        internalLinkPosition: "register offline kohler products",
        internalLinkType: "my account:navigation",
        internalLinkURL: ((myProductsPath === null || myProductsPath === void 0 ? void 0 : myProductsPath.indexOf("http")) === -1 ? window.location.origin : "") + myProductsPath,
        internalLinkZoneName: "my account:register offline kohler products:".concat(pageName)
    });
};
const getProductConfirmationEventInfo = (linkUrl)=>{
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "my account:register offline kohler products:product registration summary:review products",
        eventName: "my account:register offline kohler products:product registration summary:review products",
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "review products",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkURL: (linkUrl.indexOf("http") === -1 ? window.location.origin : "") + linkUrl,
        internalLinkZoneName: "my account:register offline kohler products:product registration summary"
    });
};
const getOfflineReviewProductsAnalytics = (myProductsPath)=>{
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "my account:register offline kohler products:thank you for registering the products:review products",
        eventMsg: "n/a",
        eventName: "my account:register offline kohler products:thank you for registering the products:review products",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "review products",
        internalLinkPosition: "register offline kohler products",
        internalLinkType: "my account:navigation",
        internalLinkURL: ((myProductsPath === null || myProductsPath === void 0 ? void 0 : myProductsPath.indexOf("http")) === -1 ? window.location.origin : "") + myProductsPath,
        internalLinkZoneName: "my account:register offline kohler products:thank you for registering the products"
    });
};
// step product information **********
const addProductInformationAnalytics = (action, productData, status, errorsList)=>{
    if (status && status !== "success") {
        var ref;
        errorsList = ((ref = errorsList.join(":")) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "n/a";
    }
    const eventInfo = {
        eventAction: "my account:register offline kohler products:product information:next step",
        eventName: "my account:register offline kohler products:product information:next step",
        eventType: "navigation",
        eventMsg: errorsList || "n/a",
        eventStatus: status,
        internalLinkName: "next step",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register offline kohler products:product information",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const ProductInfo = [];
    productData === null || productData === void 0 ? void 0 : productData.map((data)=>{
        const obj = {
            customerImage: data.customerImage || "n/a",
            modelNumber: data.modelNumber.value || "n/a",
            placeOfPurchase: data.placeOfPurchase.value || "n/a",
            serialNumber: data.serialNumber.value || "n/a",
            uploadedImage: data.uploadedImage || "n/a"
        };
        ProductInfo.push(obj);
    });
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = action === "cmp:show" ? window.pageObj : getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: action,
        page,
        eventInfo,
        productInfo: ProductInfo
    });
// delete window.pageObj
};
// product form
const getRemoveOfflineProductsAnalytics = ()=>{
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "my account:register offline kohler products:product information:remove",
        eventName: "my account:register offline kohler products:product information:remove",
        eventType: "informative",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "remove",
        internalLinkPosition: "register offline kohler products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register offline kohler products:product information",
        internalLinkURL: "n/a"
    });
};
const modalNumberSupportLinkEventInfo = JSON.stringify({
    eventAction: "my account:register offline kohler products:product information:how to find your model number",
    eventName: "my account:register offline kohler products:product information:how to find your model number",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "how to find your model number",
    internalLinkPosition: "register products",
    internalLinkType: "my account:navigation",
    internalLinkZoneName: "my account:register offline kohler products:product information",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const getAddAnotherProductAnalytics = ()=>{
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "my account:register offline kohler products:product information:add another product to register",
        eventName: "my account:register offline kohler products:product information:add another product to register",
        eventType: "informative",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "add another product to register",
        internalLinkPosition: "register offline kohler products",
        internalLinkType: "my account:navigation",
        internalLinkURL: "n/a",
        internalLinkZoneName: "my account:register offline kohler products:product information"
    });
};
// step registrationInformation***
const addRegistrationInformationAnalytics = (productDetails, action, status, errorsList)=>{
    if (status && status !== "success") {
        var ref;
        errorsList = ((ref = errorsList.join("|")) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "n/a";
    }
    const eventInfo = {
        eventAction: "my account:register offline kohler products:personal information:next step",
        eventName: "my account:register offline kohler products:personal information:next step",
        eventType: "navigation",
        eventMsg: errorsList || "n/a",
        eventStatus: status,
        internalLinkName: "next step",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register offline kohler products:personal information",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const ProductInfo = [];
    productDetails === null || productDetails === void 0 ? void 0 : productDetails.map((data)=>{
        const obj = {
            customerImage: data.customerImage || "n/a",
            modelNumber: data.modelNumber.value || "n/a",
            placeOfPurchase: data.placeOfPurchase.value || "n/a",
            serialNumber: data.serialNumber.value || "n/a",
            uploadedImage: data.uploadedImage || "n/a"
        };
        ProductInfo.push(obj);
    });
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = action === "cmp:show" ? window.pageObj : getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: action,
        page,
        eventInfo,
        productInfo: ProductInfo
    });
// delete window.pageObj
};
// step reviewInformation
const getReviewRegistrationEventInfo = (type, linkUrl)=>{
    return JSON.stringify(addReviewRegistrationEventInfo(type, linkUrl));
};
const addReviewRegistrationEventInfo = function(type, linkUrl) {
    let clickInternalLinks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "true";
    const linkFor = type === null || type === void 0 ? void 0 : type.toLowerCase();
    return {
        eventAction: "my account:register offline kohler products:review and register:".concat(linkFor),
        eventName: "my account:register offline kohler products:review and register:".concat(linkFor),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: linkFor,
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register offline kohler products:review and register",
        internalLinkURL: linkUrl,
        clickInternalLinks
    };
};
const addReviewRegistrationAnalytics = (action, status, productData, message)=>{
    const eventInfo = {
        eventAction: "my account:register offline kohler products:review and register:submit registration",
        eventName: "my account:register offline kohler products:review and register:submit registration",
        eventType: "navigation",
        eventMsg: message || "n/a",
        eventStatus: status || "n/a",
        internalLinkName: "submit registration",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register offline kohler products:review and register",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const ProductInfo = [];
    productData === null || productData === void 0 ? void 0 : productData.map((data)=>{
        const obj = {
            customerImage: data.customerImage || "n/a",
            modelNumber: data.modelNumber.value || "n/a",
            placeOfPurchase: data.placeOfPurchase.value || "n/a",
            serialNumber: data.serialNumber.value || "n/a",
            uploadedImage: data.uploadedImage || "n/a"
        };
        ProductInfo.push(obj);
    });
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = action === "cmp:show" ? window.pageObj : getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: action,
        page,
        eventInfo,
        productInfo: ProductInfo
    });
// delete window.pageObj
};
const addReviewRegistrationSubmitDataLayer = (productData)=>{
    const eventInfo = {
        eventAction: "my account:register offline kohler products:product information:submit registration",
        eventName: "my account:register offline kohler products:review and register:submit registration",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "success",
        internalLinkName: "submit registration",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register offline kohler products:product information",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const productInfoData = productData === null || productData === void 0 ? void 0 : productData.map((data)=>{
        return {
            customerImage: data.customerImage || "n/a",
            modelNumber: data.modelNumber.value || "n/a",
            placeOfPurchase: data.placeOfPurchase.value || "n/a",
            serialNumber: data.serialNumber.value || "n/a",
            uploadedImage: data.uploadedImage || "n/a"
        };
    });
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page");
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo,
        productInfo: productInfoData
    });
};
// END--Analytics *********************
// step product information **********
const productInfoHandleSubmit = (data, staticText)=>{
    let valid = true;
    const newData = [];
    const errorMessage = [];
    data.map((formItem)=>{
        const obj = {};
        if (!formItem.modelNumber.value) {
            obj.modelNumber = {
                ...formItem.modelNumber,
                error: true,
                message: staticText.modelNumberError
            };
            valid = false;
            errorMessage.push(staticText.modelNumberError);
        } else if (!(0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .validateField */ .OP$)("modelNumber", formItem.modelNumber.value)) {
            obj.modelNumber = {
                ...formItem.modelNumber,
                error: true,
                message: staticText.modelNumberError
            };
            valid = false;
            errorMessage.push(staticText.modelNumberError);
        } else if (formItem.modelNumber.value.length < 3) {
            obj.modelNumber = {
                ...formItem.modelNumber,
                error: true,
                message: staticText.modelNumberError
            };
            valid = false;
            errorMessage.push(staticText.modelNumberError);
        }
        if (!formItem.placeOfPurchase.value) {
            obj.placeOfPurchase = {
                ...formItem.placeOfPurchase,
                error: true,
                message: staticText.placeOfPurchaseError
            };
            valid = false;
            errorMessage.push(staticText.placeOfPurchaseError);
        }
        newData.push({
            ...formItem,
            ...obj
        });
    });
    return {
        newData: newData,
        valid: valid,
        errorMessage: errorMessage
    };
};
const getLocations = async ()=>{
    await _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_0__/* .getGenericListPath */ .Ln)());
    const { payload: countryList  } = await _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_0__/* .getCountryList */ .Jp)());
    const { payload: stateList  } = await _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_0__/* .getstateList */ .lK)());
    await _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_0__/* .getplaceOfPurchaseList */ .GL)());
    if (countryList.length) _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_0__/* .mapStateToCountry */ .UD)({
        countryList,
        stateList
    }));
};
// register-offline-products
const getProductDetails = function() {
    let productDetail = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const productDetails = [];
    if (productDetail && productDetail.length > 0) {
        productDetail.forEach((item)=>{
            var ref, ref1, ref2, ref3, ref4;
            const productList = {};
            productList.modelNumber = ((ref = item.modelNumber) === null || ref === void 0 ? void 0 : ref.value.startsWith("K-")) ? (ref1 = item.modelNumber) === null || ref1 === void 0 ? void 0 : ref1.value.slice(2) : (ref2 = item.modelNumber) === null || ref2 === void 0 ? void 0 : ref2.value;
            productList.serialNumber = (ref3 = item.serialNumber) === null || ref3 === void 0 ? void 0 : ref3.value;
            productList.placeOfPurchaseType = (ref4 = item.placeOfPurchase) === null || ref4 === void 0 ? void 0 : ref4.value;
            productList.customerImage = item.customerImage;
            productDetails.push(productList);
        });
    }
    return productDetails;
};
const submitRegistrationGenericError = (productDetails, errorMsg)=>{
    const isShowEvent = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .isShowAnalyticsEventLoaded */ .xJ2)();
    if (!isShowEvent) {
        addReviewRegistrationAnalytics("cmp:click", "failure", productDetails, errorMsg);
    }
};



/***/ }),

/***/ 25778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_TechnicalSpecs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react-lazy-load/dist/LazyLoad.js
var LazyLoad = __webpack_require__(25043);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(18216);
// EXTERNAL MODULE: ./src/hooks/useIsSsr.js
var useIsSsr = __webpack_require__(7154);
// EXTERNAL MODULE: ./node_modules/react-sticky-el/lib/index.js
var react_sticky_el_lib = __webpack_require__(75198);
var lib_default = /*#__PURE__*/__webpack_require__.n(react_sticky_el_lib);
// EXTERNAL MODULE: ./src/components/ProductList/v2/Sort/index.jsx + 2 modules
var Sort = __webpack_require__(73812);
// EXTERNAL MODULE: ./public/icons/filter.svg
var filter = __webpack_require__(24495);
;// CONCATENATED MODULE: ./src/components/TechnicalSpecs/v1/analytics.js
const searchdropdowncloseAnalytics = '{"eventAction":"technical specs:hero:search technical specs close","eventName":"technical specs:hero:search technical specs close","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"close","internalLinkPosition":"tech specs","internalLinkType":"technical specs:search technical specs","internalLinkZoneName":"technical specs:hero","internalLinkURL":"n/a","clickInternalLinks":"true"}';
const showFIlterGetEventInfo = (showFilter)=>{
    const hideOrShow = showFilter ? "hide" : "show";
    return JSON.stringify({
        eventAction: "technical specs:filters:".concat(hideOrShow, " filters"),
        eventName: "technical specs:filters:".concat(hideOrShow, " filters"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(hideOrShow, " filters"),
        internalLinkPosition: "tech specs",
        internalLinkType: "technical specs:".concat(hideOrShow),
        internalLinkZoneName: "technical specs:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const addAnalyticsForSearch = function() {
    let searchedKeyword = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", totalResults = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, searchKeyword = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    const eventInfo = {
        eventAction: "technical specs:hero:search technical specs",
        eventName: "technical specs:hero:search technical specs",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: (searchKeyword === null || searchKeyword === void 0 ? void 0 : searchKeyword.toLowerCase()) || "",
        internalLinkPosition: "technical specs",
        internalLinkType: "technical specs:search",
        internalLinkZoneName: "technical specs:hero",
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        searchCount: sessionStorage.getItem("technicalspecSearch") ? Number(sessionStorage.getItem("technicalspecSearch")) + 1 : 1,
        searchResult: totalResults,
        searchTerm: searchedKeyword
    };
    sessionStorage.setItem("technicalspecSearch", eventInfo.searchCount);
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};

// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./src/components/core/Highlight/Highlight.jsx
var Highlight = __webpack_require__(293);
// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(653);
// EXTERNAL MODULE: ./public/icons/search.svg
var search = __webpack_require__(83790);
;// CONCATENATED MODULE: ./src/components/TechnicalSpecs/v2/SearchDropdown.jsx







const SearchDropdown = (props)=>{
    const { id ="" , data =[] , value ="" , placeholder ="" , analyticsData ="" , onType =()=>{} , onSelect =()=>{} , closeAnalyticsData ="" , clearSuggestions =()=>{}  } = props;
    const [isShowList, setShowList] = (0,react.useState)(false);
    const [selectedListItem, setListItem] = (0,react.useState)("");
    const searchDropdownRef = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        if (value.length > 0 && data.length > 0) {
            setShowList(true);
            setActivedescendant();
        } else setShowList(false);
    }, [
        data,
        value
    ]);
    (0,react.useEffect)(()=>{
        if (isShowList) setActivedescendant();
    }, [
        isShowList
    ]);
    var _id;
    const setActivedescendant = ()=>{
        var ref;
        return setListItem((_id = (ref = document.getElementById("".concat(id, "-list"))) === null || ref === void 0 ? void 0 : ref.childNodes[0].id) !== null && _id !== void 0 ? _id : "");
    };
    const handleChange = (e)=>{
        const { target: { value  }  } = e;
        onType(value);
    };
    const handleSelect = (item)=>{
        setShowList(false);
        onSelect(item);
    };
    // hide dropdown when user clicks outide the component
    (0,react.useEffect)(()=>{
        window.addEventListener("click", handleClickOutside);
        return ()=>window.removeEventListener("click", handleClickOutside);
    }, []);
    const handleClickOutside = (e)=>{
        const { target  } = e;
        if (searchDropdownRef.current.contains(target)) setShowList(false);
    };
    const handleKeyEnter = (event)=>{
        const { key ="" , target: { value  }  } = event;
        if (key === "Enter") {
            onSelect(value);
        }
    };
    const handleKeyDown = (e)=>{
        const { keyCode =""  } = e;
        if (isShowList) {
            const { KEYCODE: { ESC , UP , DOWN , SPACE , ENTER  }  } = constants["default"];
            const ele = [
                ...document.getElementById("".concat(id, "-list")).childNodes
            ];
            let index = 0;
            const selectedItem = ele.find((item, i)=>{
                if (item.id === selectedListItem) {
                    index = i;
                    return item;
                }
            });
            switch(keyCode){
                case ESC:
                    setShowList(false);
                    break;
                case UP:
                    e.preventDefault();
                    if (index > 0) ele.forEach((item, i)=>{
                        if (i === index - 1) {
                            item.classList.add("--hover");
                            (0,helper/* smoothScroll */.ldy)(item);
                            setListItem(item.id);
                        } else item.classList.remove("--hover");
                    });
                    break;
                case DOWN:
                    e.preventDefault();
                    if (index < ele.length - 1) ele.forEach((item, i)=>{
                        if (i === index + 1) {
                            item.classList.add("--hover");
                            (0,helper/* smoothScroll */.ldy)(item);
                            setListItem(item.id);
                        } else item.classList.remove("--hover");
                    });
                    break;
                case SPACE:
                    break;
                case ENTER:
                    selectedItem.click();
                    clearSuggestions();
                    break;
                default:
                    break;
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "search-dropdown",
        id: "kf-tech-specs-dropdown",
        ref: searchDropdownRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "search-dropdown__field",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            role: "presentation",
                            className: "search-dropdown__search-icon",
                            src: search/* default */.Z === null || search/* default */.Z === void 0 ? void 0 : search/* default.src */.Z.src,
                            alt: "search-icon"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: id,
                        type: "text",
                        value: value,
                        "data-gbh-data-layer": analyticsData || null,
                        placeholder: placeholder,
                        className: "search-dropdown__input " + (analyticsData ? "gbh-data-layer" : ""),
                        onChange: handleChange,
                        onKeyDown: handleKeyDown,
                        onKeyPress: handleKeyEnter,
                        "aria-haspopup": "listbox",
                        "aria-activedescendant": selectedListItem,
                        "aria-readonly": "true",
                        "aria-owns": "".concat(id, "-list"),
                        autoComplete: "off"
                    }),
                    value.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: ()=>onSelect(""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "search-dropdown__close-icon " + (closeAnalyticsData ? "gbh-data-layer" : ""),
                            "data-gbh-data-layer": closeAnalyticsData || null,
                            src: icons_close/* default */.Z === null || icons_close/* default */.Z === void 0 ? void 0 : icons_close/* default.src */.Z.src,
                            alt: "close-icon"
                        })
                    }) : null
                ]
            }),
            isShowList ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                id: "".concat(id, "-list"),
                className: "search-dropdown__dropdown",
                role: "listbox",
                children: data.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        role: "option",
                        id: "search-dropdown-list-".concat(i),
                        className: "search-dropdown__list-item ".concat(i === 0 ? "--hover" : ""),
                        onClick: ()=>handleSelect(item["productName_s"]),
                        "aria-selected": item === value,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "search-dropdown__list-text",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight/* default */.Z, {
                                text: item["productName_s"],
                                highlight: value
                            })
                        })
                    }, i))
            }) : null
        ]
    });
};
/* harmony default export */ var v2_SearchDropdown = (SearchDropdown);

;// CONCATENATED MODULE: ./src/components/TechnicalSpecs/v1/TechnicalSpecsNavHeader.jsx










const StickyNavHeader = (props)=>{
    const { staticTexts ={} , page ="" , sorts =[] , suggestions =[] , totalResults ="" , selectedSort ={} , onSort =()=>{} , showFilter =false , searchKeyword ="" , onSearch =()=>{} , onSuggest =()=>{} , setShowFilter =()=>{} , clearSuggestions =()=>{}  } = props;
    const { searchPlaceHolder ="" , results ="" , noResults ="" , showFilter: showFilterText = "" , hideFilter =""  } = staticTexts;
    const [width] = (0,useWindowResize/* default */.Z)();
    const [navSticky, setNavSticky] = (0,react.useState)(false);
    const filterModalWindow = (0,react.useRef)(null);
    const filterButtonClass = classnames_default()({
        "product-listing__filter-toggle-text": true,
        "product-listing__filter-toggle-text--show": !showFilter
    });
    (0,react.useEffect)(()=>{
        if (showFilter && (width < 992 || lib/* isMobile */.tq || lib/* isTablet */.Em)) {
            var ref;
            filterModalWindow === null || filterModalWindow === void 0 ? void 0 : (ref = filterModalWindow.current) === null || ref === void 0 ? void 0 : ref.focus();
        } else if (!showFilter && (width < 992 || lib/* isMobile */.tq || lib/* isTablet */.Em)) {
            var ref1;
            (ref1 = document.getElementById("showFilter")) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
    }, [
        showFilter
    ]);
    const renderSearchDropdown = function() /*#__PURE__*/ {
        let ccls = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        return (0,jsx_runtime.jsx)("div", {
            className: "technical-specs__search".concat(ccls && "-".concat(ccls)),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_SearchDropdown, {
                id: "tech-specs-search",
                closeAnalyticsData: searchdropdowncloseAnalytics,
                placeholder: "".concat(searchPlaceHolder),
                onSelect: onSearch,
                onType: onSuggest,
                value: searchKeyword,
                data: suggestions,
                clearSuggestions: clearSuggestions
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
        onFixedToggle: ()=>setNavSticky(!navSticky),
        className: "product-listing__sticky-nav-wrap",
        stickyStyle: {
            zIndex: 9
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container-fluid product-listing__sticky-nav ".concat(navSticky && "product-listing__sticky-nav--shadow"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-listing__row technical-specs__search-flex",
                children: [
                    navSticky && width < 813 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "technical-specs__search-wrap sticky-order-search",
                        children: renderSearchDropdown("ml")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container kf-react-plp-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-listing__row",
                            children: [
                                !navSticky && width < 625 && renderSearchDropdown("ml"),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "technical-specs__sticky-search-pd ".concat(navSticky && "--sticky-pd-nav", " product-listing__col product-listing__controls"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "product-listing__row technical-specs__search-wrap-parent",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "product-listing__total",
                                                    children: totalResults === "..." ? totalResults : totalResults ? totalResults + " " + results : noResults
                                                }),
                                                width > 625 && !navSticky ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "technical-specs__search-wrap sticky-order-search",
                                                    children: renderSearchDropdown()
                                                }) : null,
                                                width > 812 && navSticky && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "technical-specs__search-wrap sticky-order-search",
                                                    children: renderSearchDropdown()
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                            className: "sorting-section",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    id: "showFilter",
                                                    "aria-label": !showFilter ? showFilterText : hideFilter,
                                                    className: "product-listing__filter-toggle gbh-data-layer",
                                                    "data-gbh-data-layer": showFIlterGetEventInfo(showFilter),
                                                    onClick: ()=>setShowFilter(!showFilter),
                                                    children: [
                                                        width > 991 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                            className: filterButtonClass,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    className: showFilter ? "show" : "hide",
                                                                    children: hideFilter
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    className: !showFilter ? "show" : "hide",
                                                                    children: showFilterText
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: filter/* default */.Z === null || filter/* default */.Z === void 0 ? void 0 : filter/* default.src */.Z.src,
                                                            className: "product-listing__filter-toggle-icon",
                                                            alt: "Toggle Filter"
                                                        })
                                                    ]
                                                }),
                                                width > 812 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Sort/* default */.Z, {
                                                    tabIndex: "0",
                                                    page: page || "technicalspecs",
                                                    data: sorts,
                                                    texts: staticTexts,
                                                    selectedSort: selectedSort,
                                                    onChange: onSort,
                                                    isSearch: true
                                                }) : null
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var TechnicalSpecsNavHeader = (StickyNavHeader);

// EXTERNAL MODULE: ./src/components/Search/v1/TechnicalTile/index.jsx + 2 modules
var TechnicalTile = __webpack_require__(24719);
// EXTERNAL MODULE: ./src/components/ProductList/v2/Filter/index.jsx + 3 modules
var Filter = __webpack_require__(61304);
// EXTERNAL MODULE: ./src/components/ProductList/v2/Sort/index.module.scss
var index_module = __webpack_require__(58088);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/ProductList/v2/Filter/index.module.scss
var Filter_index_module = __webpack_require__(68167);
var Filter_index_module_default = /*#__PURE__*/__webpack_require__.n(Filter_index_module);
// EXTERNAL MODULE: ./src/components/ProductList/v2/ProductListView/index.module.scss
var ProductListView_index_module = __webpack_require__(55266);
var ProductListView_index_module_default = /*#__PURE__*/__webpack_require__.n(ProductListView_index_module);
// EXTERNAL MODULE: ./src/components/TechnicalSpecs/v1/index.module.scss
var v1_index_module = __webpack_require__(87410);
var v1_index_module_default = /*#__PURE__*/__webpack_require__.n(v1_index_module);
// EXTERNAL MODULE: ./src/components/ProductList/v2/ProductTile/index.module.scss
var ProductTile_index_module = __webpack_require__(20711);
var ProductTile_index_module_default = /*#__PURE__*/__webpack_require__.n(ProductTile_index_module);
// EXTERNAL MODULE: ./src/components/ProductList/v2/ProductListView/Pagination/index.jsx
var Pagination = __webpack_require__(57633);
// EXTERNAL MODULE: ./public/icons/arrow-up.svg
var arrow_up = __webpack_require__(97274);
;// CONCATENATED MODULE: ./src/components/TechnicalSpecs/TechnicalSpecLoader/index.js




const TechnicalSpecPLPLoader = (props)=>{
    const { showNavHeader =true , isProductTile =false  } = props;
    const renderProductListingTile = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "technical product-listing__tile-col",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-listing__row row-cols-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-listing__tile",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "LazyLoad is-visible kf-lazyload-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "TechnicalTile_technicalTileWrapper__h1BM8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "technical-tile technical-tile__grid-showfilter wow animate__fadeInUp",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "technical-tile__image position-relative",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "d-block technical-tile__image--product-image gbh-data-layer"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "technical-tile__collapsible technical-tile__collapsible-grid",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "technical-tile__specs-container",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "width-full",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "shimmer-loading__para shimmer width-170 mt60"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "shimmer-loading__para shimmer width-100"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "Accordion_accordionWrapper__vZrfq",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "collapsible-accordion",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "Collapsible-facet",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "Collapsible__trigger is-closed",
                                                                    "aria-expanded": "false",
                                                                    "aria-disabled": "false",
                                                                    "aria-controls": "collapsible-content-6674974705000",
                                                                    role: "button",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170 mt60"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-listing__tile",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "LazyLoad is-visible kf-lazyload-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "TechnicalTile_technicalTileWrapper__h1BM8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "technical-tile technical-tile__grid-showfilter wow animate__fadeInUp",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "technical-tile__image position-relative",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "d-block technical-tile__image--product-image gbh-data-layer"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "technical-tile__collapsible technical-tile__collapsible-grid",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "technical-tile__specs-container",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "width-full",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "shimmer-loading__para shimmer width-170 mt60"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "shimmer-loading__para shimmer width-100"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "Accordion_accordionWrapper__vZrfq",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "collapsible-accordion",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "Collapsible-facet",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "Collapsible__trigger is-closed",
                                                                    "aria-expanded": "false",
                                                                    "aria-disabled": "false",
                                                                    "aria-controls": "collapsible-content-6674974705000",
                                                                    role: "button",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170 mt60"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        });
    };
    return isProductTile ? renderProductListingTile() : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showNavHeader ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-listing__sticky-nav-wrap",
                style: {
                    minHeight: "130px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container-fluid product-listing__sticky-nav false",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-listing__row technical-specs__search-flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container kf-react-plp-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "product-listing__row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "technical-specs__sticky-search-pd false product-listing__col product-listing__controls",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "product-listing__row technical-specs__search-wrap-parent",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "product-listing__total shimmer-loading__para30 shimmer width-240"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "technical-specs__search-wrap sticky-order-search",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "technical-specs__search",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "search-dropdown",
                                                                id: "kf-tech-specs-dropdown",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "search-dropdown__field",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                role: "presentation",
                                                                                className: "search-dropdown__search-icon",
                                                                                src: search/* default */.Z === null || search/* default */.Z === void 0 ? void 0 : search/* default.src */.Z.src,
                                                                                alt: "search-icon"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                            id: "tech-specs-search",
                                                                            type: "text",
                                                                            placeholder: "Search Technical Specs",
                                                                            className: "search-dropdown__input "
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                                className: "sorting-section",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        id: "showFilter",
                                                        className: "product-listing__filter-toggle gbh-data-layer",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                className: "product-listing__filter-toggle-text",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                        className: "show",
                                                                        children: "Hide Filters"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                        className: "hide",
                                                                        children: "Show Filters"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: filter/* default */.Z === null || filter/* default */.Z === void 0 ? void 0 : filter/* default.src */.Z.src,
                                                                className: "product-listing__filter-toggle-icon",
                                                                alt: "Toggle Filter"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "sort",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                className: "sort__toggle",
                                                                children: [
                                                                    "Sort By : Featured",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: arrow_up/* default */.Z === null || arrow_up/* default */.Z === void 0 ? void 0 : arrow_up/* default.src */.Z.src,
                                                                        alt: "Sort",
                                                                        className: "sort__toggle-icon",
                                                                        "aria-hidden": "true"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                className: "sort__drop-down",
                                                                "aria-hidden": "true",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                        id: "select-options-0",
                                                                        role: "option",
                                                                        ndex: "-1",
                                                                        "aria-selected": "true",
                                                                        className: "sort__item gbh-data-layer active",
                                                                        children: "Featured"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                        id: "select-options-1",
                                                                        role: "option",
                                                                        ndex: "-1",
                                                                        "aria-selected": "false",
                                                                        className: "sort__item gbh-data-layer ",
                                                                        children: "A - Z"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                        id: "select-options-2",
                                                                        role: "option",
                                                                        ndex: "-1",
                                                                        "aria-selected": "false",
                                                                        className: "sort__item gbh-data-layer ",
                                                                        children: "Z - A"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container kf-react-plp-container product-listing__tiles",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-listing__row d-block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "filter-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-listing__filter product-listing__filter--modal",
                                "aria-modal": "true",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "product-listing__filter--sticky",
                                    "aria-hidden": "false",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-listing filter",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "filter__inner-container",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "product-listing__controls filter__mobile-header",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "product-listing__filter-toggle gbh-data-layer",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "Filter & Sort"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            ndex: "0",
                                                            role: "button",
                                                            src: "/_next/static/media/close-filter.155c83ba.svg",
                                                            className: "product-listing__close-icon gbh-data-layer",
                                                            alt: "Close Filter"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    role: "list",
                                                    className: "filter__filter-list",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "collapsible-outer",
                                                            role: "listitem",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "Collapsible-facet",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "Collapsible__trigger is-closed shimmer-loading__headpara shimmer mb20 width-full ",
                                                                        ndex: "0",
                                                                        "aria-expanded": "false",
                                                                        "aria-disabled": "false",
                                                                        "aria-controls": "collapsible-content-1690168099620",
                                                                        role: "button"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "Collapsible__contentOuter",
                                                                        role: "region",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "Collapsible__contentInner"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "collapsible-outer",
                                                            role: "listitem",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "Collapsible-facet",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "Collapsible__trigger is-closed shimmer-loading__headpara shimmer mb20 width-full",
                                                                        ndex: "0",
                                                                        "aria-expanded": "false",
                                                                        "aria-disabled": "false",
                                                                        "aria-controls": "collapsible-content-1690168099621",
                                                                        role: "button"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "Collapsible__contentOuter",
                                                                        role: "region",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "Collapsible__contentInner"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "collapsible-outer",
                                                            role: "listitem",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "Collapsible-facet",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "Collapsible__trigger is-closed shimmer-loading__headpara shimmer mb20 width-full",
                                                                        ndex: "0",
                                                                        "aria-expanded": "false",
                                                                        "aria-disabled": "false",
                                                                        "aria-controls": "collapsible-content-1690168099622",
                                                                        role: "button"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "Collapsible__contentOuter",
                                                                        role: "region",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "Collapsible__contentInner"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "collapsible-outer",
                                                            role: "listitem",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "Collapsible-facet",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "Collapsible__trigger is-closed shimmer-loading__headpara shimmer mb20 width-full",
                                                                        ndex: "0",
                                                                        "aria-expanded": "false",
                                                                        "aria-disabled": "false",
                                                                        "aria-controls": "collapsible-content-1690168099622",
                                                                        role: "button"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "Collapsible__contentOuter",
                                                                        role: "region",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "Collapsible__contentInner"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            renderProductListingTile()
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var TechnicalSpecLoader = (TechnicalSpecPLPLoader);

;// CONCATENATED MODULE: ./src/components/TechnicalSpecs/v1/TechnicalSpecsView.jsx



















const TechnicalSpecsView = (props)=>{
    const { data =[] , sorts =[] , curRows =0 , colors ={} , filters ={} , staticTexts ={} , facetLabels ={} , suggestions =[] , currFilters =[] , currencySign ="" , selectedSort ={} , totalResults ="" , displayPrint ="" , displayShare ="" , onRows =()=>{} , onSort =()=>{} , isLoading =false , searchKeyword ="" , onFilter =()=>{} , onSearch =()=>{} , productsPerPage =[] , onSuggest =()=>{} , onLoadMore =()=>{} , page ="technicalspecs" , selectedFilterCount =0 , clearSuggestions =()=>{}  } = props;
    const [width] = (0,useWindowResize/* default */.Z)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const [showFilter, setShowFilter] = (0,react.useState)(lib/* isMobile */.tq || width <= 992 ? false : true);
    const filterModalWindow = (0,react.useRef)(null);
    const plpRef = (0,react.useRef)(null);
    const { backToTop  } = constants.DEFAULT_SCROLL;
    const facets = {
        ...filters
    };
    delete facets["Products"];
    delete facets["Technical"];
    const tileClass = classnames_default()({
        technical: true,
        "product-listing__tile-col": true,
        "product-listing__tile-col--full-width": !showFilter
    });
    const filterClass = classnames_default()({
        "product-listing__filter": true,
        "product-listing__filter--hide": !showFilter,
        "product-listing__filter--modal": showFilter
    });
    (0,react.useEffect)(()=>{
        const mainElement = document.getElementById("main-content");
        mainElement.addEventListener("keydown", removeTabIndex);
        return ()=>{
            mainElement.removeEventListener("keydown", removeTabIndex);
        };
    });
    const removeTabIndex = ()=>document.getElementById("main-content").removeAttribute("tabindex");
    const handleKeyPress = (e)=>{
        if (width < 992) {
            const focusElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), button:not([disabled]) [role="button]:not([hidden=true])';
            const focusContent = filterModalWindow.current.querySelectorAll(focusElements);
            const firstElem = focusContent[0];
            const lastElem = focusContent[focusContent.length - 1].disabled ? focusContent[focusContent.length - 2] : focusContent[focusContent.length - 1];
            if (e.key === "Escape") {
                setShowFilter(false);
            }
            if (e.key === "Tab") {
                if (e.shiftKey && (document.activeElement === firstElem || document.activeElement === filterModalWindow.current)) {
                    e.preventDefault();
                    lastElem.focus();
                }
                if (!e.shiftKey && document.activeElement === lastElem) {
                    e.preventDefault();
                    firstElem.focus();
                }
            }
        }
    };
    const handleBackToTop = ()=>{
        const mainContent = document.getElementById("main-content");
        mainContent.tabIndex = 0;
        mainContent.focus();
        window.scrollTo({
            top: (0,helper/* getOffsetTop */.oJS)(mainContent) + backToTop,
            behavior: "smooth"
        });
    };
    const executeScroll = ()=>{
        var ref;
        plpRef === null || plpRef === void 0 ? void 0 : (ref = plpRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            behavior: "smooth"
        });
    };
    const handleSort = (sort)=>{
        onSort(sort);
        executeScroll();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((v1_index_module_default()).technicalSpecsWrapper, " ").concat((ProductListView_index_module_default()).productListWrapper, " ").concat((ProductTile_index_module_default()).productTileWrapper, " ").concat((index_module_default()).productListingSearchWrapper, " ").concat((Filter_index_module_default()).productListingFilterWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "product-list product-listing technical-specs",
            ref: plpRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "kf-react-plp-container product-list__header",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 title",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "technical-specs__list__title",
                                    dangerouslySetInnerHTML: {
                                        __html: staticTexts.technicalSpecs
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 description",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "product-list__description",
                                    children: staticTexts.pageDescription
                                })
                            })
                        ]
                    })
                }),
                isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TechnicalSpecLoader, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TechnicalSpecsNavHeader, {
                            staticTexts: staticTexts,
                            onSort: onSort,
                            totalResults: totalResults,
                            page: page,
                            sorts: sorts,
                            selectedSort: selectedSort,
                            onSearch: onSearch,
                            onSuggest: onSuggest,
                            searchKeyword: searchKeyword,
                            suggestions: suggestions,
                            clearSuggestions: clearSuggestions,
                            showFilter: showFilter,
                            setShowFilter: setShowFilter
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container kf-react-plp-container product-listing__tiles",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-listing__row d-block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "filter-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: filterClass,
                                            "aria-modal": true,
                                            ref: filterModalWindow,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-listing__filter--sticky",
                                                "aria-hidden": !showFilter,
                                                onKeyDown: handleKeyPress,
                                                children: facets && /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter["default"], {
                                                    page: "technicalspecs",
                                                    texts: staticTexts,
                                                    currencySign: currencySign,
                                                    facetData: facets,
                                                    facetLabels: facetLabels,
                                                    onFilter: onFilter,
                                                    close: setShowFilter,
                                                    colors: colors,
                                                    displayShare: true,
                                                    displayPrint: true,
                                                    discontinuedCheck: true,
                                                    showFilter: showFilter,
                                                    showSort: width <= 991,
                                                    sort: sorts,
                                                    selectedSort: selectedSort,
                                                    onSortChange: handleSort,
                                                    hidePriceRange: true,
                                                    currFilters: currFilters,
                                                    selectedFilterCount: selectedFilterCount,
                                                    totalResults: totalResults,
                                                    addToUrl: true,
                                                    type: "technical"
                                                })
                                            })
                                        }),
                                        isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TechnicalSpecLoader, {
                                            isProductTile: true
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: tileClass,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "product-listing__row row-cols-1",
                                                    children: data.length ? data.map((product, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "product-listing__tile",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoad/* default */.Z, {
                                                                    className: "kf-lazyload-wrapper",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TechnicalTile/* default */.Z, {
                                                                        data: product,
                                                                        fullWidth: !showFilter,
                                                                        staticTexts: staticTexts,
                                                                        highlightText: searchKeyword,
                                                                        page: "technicalspecs",
                                                                        currFilters: currFilters
                                                                    })
                                                                })
                                                            })
                                                        }, i)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "no-result__title",
                                                            role: "listitem",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: staticTexts.notFoundText
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                                    page: "technicalspecs",
                                                    removeLoadAnimation: true,
                                                    totalResults,
                                                    staticTexts,
                                                    onLoadMore,
                                                    curRows,
                                                    data,
                                                    displayPrint,
                                                    displayShare,
                                                    productsPerPage,
                                                    onRows,
                                                    handleBackToTop,
                                                    width
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var v1_TechnicalSpecsView = ((0,lib/* withOrientationChange */.Qe)(TechnicalSpecsView));

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
;// CONCATENATED MODULE: ./src/i18n/useTechnicalSpecsi18n.js

const useTechnicalSpecsi18n = (param)=>{
    let { componentProps ={} , loading =false , keyword =""  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        technicalSpecs: (componentProps === null || componentProps === void 0 ? void 0 : componentProps.techTitle) ? componentProps === null || componentProps === void 0 ? void 0 : componentProps.techTitle : t("kf.technical.label.technicalSpecs"),
        searchPlaceHolder: t("kf.technical.label.searchPlaceHolder"),
        pageDescription: (componentProps === null || componentProps === void 0 ? void 0 : componentProps.techDescription) ? componentProps === null || componentProps === void 0 ? void 0 : componentProps.techDescription : t("kf.technical.label.pageDescription"),
        print: t("kf.plp.label.print"),
        share: t("kf.plp.label.share"),
        wishlist: t("kf.plp.label.wishlist"),
        showFilter: t("kf.plp.label.showFilter"),
        hideFilter: t("kf.plp.label.hideFilter"),
        filters: t("kf.plp.label.filters"),
        filterSort: t("kf.plp.label.filterSort"),
        addToCompare: t("kf.plp.label.addToCompare"),
        colors: t("kf.plp.label.colors"),
        color: t("kf.plp.label.color"),
        view: t("kf.plp.label.view"),
        all: t("kf.plp.label.all"),
        sort: t("kf.plp.label.sort"),
        sortbyExpanded: t("kf.plp.label.sortbyExpanded"),
        sortbyClosed: t("kf.plp.label.sortbyClosed"),
        selected: t("kf.plp.arialabel.selected"),
        altSort: t("kf.plp.label.img.altSort"),
        sortByAria: (count)=>t("kf.plp.label.sortByAria", {
                sortByCount: count
            }),
        applyFilters: "Apply Filters",
        results: t("kf.plp.label.results"),
        noResults: t("kf.plp.label.noResults"),
        loadMore: t("kf.plp.label.loadMore"),
        backToTop: t("kf.plp.label.backToTop"),
        showMore: t("kf.plp.label.showMore"),
        showLess: t("kf.plp.label.showLess"),
        clearAll: t("kf.plp.label.clearAll"),
        category: t("kf.technical.label.category"),
        collection: t("kf.technical.label.collection"),
        certifications: t("kf.technical.label.certifications"),
        designFiles: t("kf.technical.label.designFiles"),
        technicalInfo: t("kf.pdp.label.specs"),
        installationSupport: t("kf.pdp.label.installationSupport"),
        addToFolder: t("kf.technical.label.addToFolder"),
        selectAll: t("kf.technical.label.selectAll"),
        download: t("kf.technical.label.download"),
        downloading: t("kf.technical.label.downloading"),
        hideDiscontinued: t("kf.plp.label.hideDiscontinued"),
        discontinuedText: t("kf.pdp.label.discontinuedTxt"),
        file: t("kf.technical.label.file"),
        files: t("kf.technical.label.files"),
        specsSheet: t("kf.technical.label.specsSheet"),
        envDeclaration: t("kf.technical.label.envDeclaration"),
        installationGuide: t("kf.technical.label.installationGuide"),
        userGuide: t("kf.technical.label.userGuide"),
        homeOwnerGuide: t("kf.technical.label.homeOwnerGuide"),
        viewResults: t("kf.plp.label.viewResults"),
        twoDplan: t("kf.technical.label.twoDplan"),
        twoDside: t("kf.technical.label.twoDside"),
        twoDfront: t("kf.technical.label.twoDfront"),
        threeDfile: t("kf.technical.label.threeDfile"),
        bimFile: t("kf.technical.label.bimFile"),
        cutoutTemplate: t("kf.technical.label.cutoutTemplate"),
        partsDiagram: t("kf.pdp.label.partsDiagram"),
        guides: t("kf.technical.label.guides"),
        ariaLabel: {
            filterChips: t("kf.plp.label.aria.filterChips")
        },
        notFoundText: loading || !keyword ? "..." : t("list.notfound", {
            keyword
        }),
        featured: t("kf.plp.label.featured"),
        atoz: t("kf.plp.label.atoz"),
        ztoa: t("kf.plp.label.ztoa"),
        // extra added statictexts
        discontinuedTxt: t("kf.pdp.label.discontinuedTxt"),
        filterTitle: (facetName, facetCount)=>t("kf.plp.ariaLabel.filterTitle", {
                facetName: facetName,
                facetCount: facetCount
            }),
        arialLabelPrint: (val)=>t("kf.plp.label.aria.print", {
                val: val
            }),
        ariaLabelShare: (val)=>t("kf.plp.label.aria.share", {
                val: "".concat(val, " page")
            })
    };
    return i18n;
};
/* harmony default export */ var i18n_useTechnicalSpecsi18n = (useTechnicalSpecsi18n);

// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./src/hooks/usePrevious.js
var usePrevious = __webpack_require__(97349);
;// CONCATENATED MODULE: ./src/components/TechnicalSpecs/technicalSpecHelper.js
const getSortList = (staticTexts)=>[
        {
            name: staticTexts.featured
        },
        {
            name: staticTexts.atoz,
            query: "productName_s+asc"
        },
        {
            name: staticTexts.ztoa,
            query: "productName_s+desc"
        }
    ];
const getFLData = (persona)=>[
        "id",
        "slug_s",
        "masterSKU_s",
        "productName_s",
        "Product_Category",
        "productImages.url_ss",
        "ProductSustainability_s",
        "ProductBrandName_s",
        "ProductADACompliant_s",
        "ProductBrandNameDisplay_s",
        "productRegionAllVariantDiscontinued_b",
        "RegionDiscontinuedDate_dt",
        "ProductDescriptionProductShort_s",
        "Color.".concat(persona, ".Details_ss"),
        "ProductResource.DXFPlanView.resourceFullWebURL_ss",
        "ProductResource.DWGPlanView.resourceFullWebURL_ss",
        "ProductResource.DXFFrontView.resourceFullWebURL_ss",
        "ProductResource.DWGFrontView.resourceFullWebURL_ss",
        "ProductResource.DXFSideView.resourceFullWebURL_ss",
        "ProductResource.DWGSideView.resourceFullWebURL_ss",
        "ProductResource.3DDXFSymbol.resourceFullWebURL_ss",
        "ProductResource.3DDWGSymbol.resourceFullWebURL_ss",
        "ProductResource.3DRevit.resourceFullWebURL_ss",
        "ProductResource.3D3DS.resourceFullWebURL_ss",
        "ProductResource.3DSketchup.resourceFullWebURL_ss",
        "ProductResource.CutOutDXF.resourceFullWebURL_ss",
        "ProductResource.3DOBJ.resourceFullWebURL_ss",
        "ProductResource.SpecPDFFileName.resourceFullWebURL_ss",
        "ProductResource.SpecPDFFileName.resourceTitle_ss",
        "ProductResource.EnvironProdDecl.resourceFullWebURL_ss",
        "ProductResource.EnvironProdDecl.resourceTitle_ss",
        "ProductResource.HomeownersGuide.resourceFullWebURL_ss",
        "ProductResource.HomeownersGuide.resourceTitle_ss",
        "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss",
        "ProductResource.InstallationWithoutSPPDF.resourceTitle_ss",
        "ProductResource.PartsPDFFileName.resourceFullWebURL_ss",
        "ProductProductNo_s"
    ];

// EXTERNAL MODULE: ./src/store/features/productListSlice.js
var productListSlice = __webpack_require__(42286);
;// CONCATENATED MODULE: ./src/components/TechnicalSpecs/v1/TechnicalSpecs.jsx
















const TechnicalSpecs = (props)=>{
    const dispatch = (0,es/* useDispatch */.I0)();
    const { data =[] , total , fusion ={} , facets =[] , facetLabels , status: loading , colors , suggestions , suggestionExactMatch  } = (0,es/* useSelector */.v9)(productListSlice/* selectProductListState */.rv).plp;
    const [searchedKeyword, setSearchedKeyword] = (0,react.useState)("");
    const [preFilterFlag, setPrefilterFlag] = (0,react.useState)(null);
    const { data: componentProps  } = props;
    const staticTexts = i18n_useTechnicalSpecsi18n({
        componentProps,
        loading,
        searchedKeyword
    });
    const { featured ="" , discontinuedTxt =""  } = staticTexts;
    const productsPerPage = constants.PRODUCTS_PER_PAGE;
    const [isSearch, setIsSearch] = (0,react.useState)(false);
    const [searchKeyword, setSearchKeyword] = (0,react.useState)("");
    const [rows, setRows] = (0,react.useState)();
    const [selectedSort, setSelectedSort] = (0,react.useState)({
        name: featured,
        query: ""
    });
    const [curFilterQueries, setCurFilterQueries] = (0,react.useState)([]);
    const [info, setInfo] = (0,react.useState)("");
    const sort = getSortList(staticTexts);
    const [start, setStart] = (0,react.useState)(0);
    const prevSort = (0,usePrevious/* default */.Z)(selectedSort);
    const prevFilter = (0,usePrevious/* default */.Z)(curFilterQueries);
    const prevPreSelect = (0,usePrevious/* default */.Z)(preFilterFlag);
    const prevRows = (0,usePrevious/* default */.Z)(rows);
    const prevSearchKeyword = (0,usePrevious/* default */.Z)(searchKeyword);
    const selectedFilterCount = curFilterQueries ? curFilterQueries.reduce((acc, item)=>{
        return acc + item.value.length;
    }, 0) : 0;
    const technicalArg = 'Technical:("Yes")';
    const hideDiscontinued = [
        {
            facet: "Hide_Discontinued",
            value: [
                "true"
            ],
            display: [
                discontinuedTxt
            ]
        }
    ];
    const emptyRow = 0;
    const { currencySign ="" , persona ="" , marketParamValues =[] , lwAppName =""  } = info;
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then(async (config)=>{
            var ref;
            var ref1;
            const brandName = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.siteName) !== null && ref1 !== void 0 ? ref1 : "";
            const locale = get_default()(config, "internationalization.locale", "");
            const currencySign = get_default()(config, "internationalization.currencySign", "");
            const currencyCode = get_default()(config, "internationalization.currencyCode", "");
            const marketParamValues = get_default()(config, "marketParamValues", "");
            const language = get_default()(config, "internationalization.language", "en");
            const { general: { lwAppName =""  } = {}  } = config !== null && config !== void 0 ? config : {};
            const persona = (0,helper/* getUserPersona */.shu)();
            const info = {
                marketParamValues,
                brandName,
                locale,
                currencySign,
                currencyCode,
                persona,
                language,
                lwAppName
            };
            const rowMob = lib/* isMobile */.tq ? constants.DEFAULT_TECHNICAL_SPECT_COUNT : parseInt(sessionStorage.getItem("rows")) || constants.DEFAULT_TECHNICAL_SPECT_COUNT;
            setInfo(info);
            setRows(rowMob);
        });
    }, []);
    (0,react.useEffect)(()=>{
        // will check for url filter
        if (info) handleFetchFacetFromUrl();
    }, [
        info
    ]);
    (0,react.useEffect)(()=>{
        if (preFilterFlag != null && info) {
            // will call filter in url exists
            if (preFilterFlag) {
                generateListingUrl("preSelectFIlter");
            } else if (!preFilterFlag && preFilterFlag != prevPreSelect) {
                // prevPreSelect null indicate no url filters
                prevPreSelect === null ? generateListingUrl() : updateUrlFilterQueries();
            } else if (start) {
                generateListingUrl(null, true);
            } else if (start == 0 && rows && !!prevRows && prevRows != rows) {
                generateListingUrl(null, false);
            } else if (prevSort && (prevSort === null || prevSort === void 0 ? void 0 : prevSort.query) != (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.query)) {
                generateListingUrl();
            } else if (prevFilter && prevFilter != curFilterQueries) {
                generateListingUrl();
            }
        }
    }, [
        preFilterFlag,
        info,
        selectedSort,
        curFilterQueries,
        start,
        rows
    ]);
    const updateUrlFilterQueries = ()=>{
        let currFilters = hideDiscontinued;
        const urlFilters = (0,helper/* getAllFilterQueries */.ud4)({
            attributeName: ""
        }, fusion, marketParamValues);
        currFilters = [
            ...currFilters,
            ...urlFilters
        ];
        setCurFilterQueries(currFilters);
    };
    (0,react.useEffect)(()=>{
        if (searchKeyword.length > 2 && prevSearchKeyword != searchKeyword || isSearch) handleSearchSuggestion(!isSearch ? "suggestion" : "");
    }, [
        searchKeyword,
        isSearch
    ]);
    const handleFetchFacetFromUrl = ()=>{
        let currFilters = hideDiscontinued;
        const urlFilters = (0,helper/* getFacetsFromUrl */.bZU)(marketParamValues);
        currFilters = [
            ...currFilters,
            ...urlFilters
        ];
        // not setting filterquery here, fusion required
        if (urlFilters.length > 0) setPrefilterFlag(true);
        else {
            // update only on no prefilter
            setCurFilterQueries(currFilters);
            setPrefilterFlag(false);
        }
    };
    const generateListingUrl = function() {
        let genarate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", update = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        const queries = curFilterQueries;
        const params = {
            profileName: "profile_".concat(lwAppName.toLowerCase()).concat(genarate === "suggestion" ? "_Typeahead" : "_Search"),
            collections: lwAppName.toLowerCase(),
            isFaq: true
        };
        // pre-filter param data
        if (genarate === "preSelectFIlter") {
            params.fl = "id";
            params.q = "*:*";
            params.rows = emptyRow;
        } else if (genarate === "suggestion") {
            params.q = searchKeyword;
            params.fq = technicalArg;
            params.rows = constants.TECHNICAL_SPECT_SEARCH_COUNT;
            params.fl = "productName_s";
            params.isSuggestion = searchKeyword;
        } else {
            // all other calls
            const fl = getFLData(persona);
            const fq = [
                technicalArg
            ];
            queries.forEach((q)=>{
                const tag = '{!tag="'.concat(q.facet, '"}');
                fq.push("".concat(encodeURIComponent(tag + q.facet), ':("').concat(encodeURIComponent(q.value.join('","')), '")'));
            });
            params.q = "*";
            params.fl = fl.join(",");
            params.rows = rows;
            params.fq = fq;
            params.start = start !== null && start !== void 0 ? start : emptyRow;
            params.selectedTitle = searchKeyword !== null && searchKeyword !== void 0 ? searchKeyword : "";
            params.update = update;
            if (searchKeyword.length > 2) {
                params.q = suggestionExactMatch !== null && suggestionExactMatch !== void 0 ? suggestionExactMatch : searchKeyword;
            }
            if (selectedSort.name !== (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.featured) && selectedSort.name) {
                params.sort = selectedSort.query;
            }
        }
        if (!params.fq) {
            params.fq = 'language_s:("'.concat(info.language, '")');
        } else {
            if (typeof params.fq === "string" && params.fq.length > 0) {
                params.fq = [
                    params.fq,
                    'language_s:("'.concat(info.language, '")')
                ];
            } else if (Array.isArray(params.fq)) {
                params.fq = [
                    ...params.fq,
                    'language_s:("'.concat(info.language, '")')
                ];
            }
        }
        dispatch((0,productListSlice/* getProducts */.Xp)({
            ...params
        })).unwrap().then(()=>{
            if (preFilterFlag) {
                setPrefilterFlag(false);
            }
            if (isSearch) {
                setIsSearch(false);
                addAnalyticsForSearch(searchedKeyword, total, searchKeyword);
            }
        }).catch((err)=>console.error(err));
    };
    const handleSearchSuggestion = debounce_default()((actionkey)=>{
        setSearchedKeyword(searchKeyword);
        generateListingUrl(actionkey);
    }, 500);
    const handleSort = (item)=>{
        setStart(0);
        setSelectedSort(item);
    };
    const handleRows = (rows)=>{
        setStart(0);
        setRows(rows);
        sessionStorage.setItem("rows", rows);
    };
    const handleSearch = (item)=>{
        setIsSearch(true);
        setSearchKeyword(item);
        handleClearSuggestion();
    };
    const handleClearSuggestion = ()=>{
        dispatch((0,productListSlice/* clearSuggestion */.dM)());
    };
    const handleLoadMore = ()=>setStart(parseInt(start) + parseInt(rows));
    return !isEmpty_default()(staticTexts) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_TechnicalSpecsView, {
        staticTexts: staticTexts,
        searchKeyword: searchKeyword,
        suggestions: suggestions,
        curRows: rows,
        data: data,
        filters: facets,
        onFilter: setCurFilterQueries,
        facetLabels: facetLabels,
        sorts: sort,
        selectedSort: selectedSort,
        onSearch: handleSearch,
        onSuggest: setSearchKeyword,
        clearSuggestions: handleClearSuggestion,
        onSort: handleSort,
        onRows: handleRows,
        onLoadMore: handleLoadMore,
        productsPerPage: productsPerPage,
        totalResults: total,
        currencySign: currencySign,
        colors: colors,
        currFilters: curFilterQueries,
        selectedFilterCount: selectedFilterCount
    }) : null;
};
/* harmony default export */ var v1_TechnicalSpecs = (TechnicalSpecs);


/***/ }),

/***/ 90164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "We": function() { return /* binding */ getAddressSuggestions; },
/* harmony export */   "qN": function() { return /* binding */ refreshCart; },
/* harmony export */   "tz": function() { return /* binding */ getShippingAddressFormated; },
/* harmony export */   "wQ": function() { return /* binding */ getEventInfo; },
/* harmony export */   "xj": function() { return /* binding */ checkInactivePromos; }
/* harmony export */ });
/* unused harmony export createOrder */
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19514);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20366);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64925);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88751);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87292);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27514);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25844);
/* harmony import */ var _constants___WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47956);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73350);
/* harmony import */ var _store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21925);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];










const getAddressSuggestions = async (addr)=>{
    if (!addr || addr.trim() === "") return [];
    try {
        const res = await _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .addresssSuggest */ .th)(addr));
        if (res && res.payload && res.payload.results) {
            var _suggestion;
            return res.payload.results.map((item)=>(_suggestion = item.suggestion) !== null && _suggestion !== void 0 ? _suggestion : "");
        }
        return [];
    } catch (err) {
        console.log("Failed to get suggestions from Experian", err);
        throw err;
    }
};
const refreshCart = async ()=>{
    var ref, ref1;
    const cart = (ref = _store__WEBPACK_IMPORTED_MODULE_1__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_1__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_1__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
    const { lineItems =[] , taxedPrice ={}  } = cart;
    if ((lineItems === null || lineItems === void 0 ? void 0 : lineItems.length) === 0) return;
    const shippingZip = localStorage.getItem("shippingZip");
    let payload = {};
    if (shippingZip && shippingZip.trim() !== "" && !taxedPrice) {
        payload = {
            actions: [
                {
                    action: "recalculate",
                    updateProductData: true
                },
                {
                    action: "calculateTax"
                }
            ]
        };
    } else {
        payload = {
            actions: [
                {
                    action: "recalculate",
                    updateProductData: true
                }
            ]
        };
    }
    await _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .addToCart */ .Xq)(payload)).unwrap().then((res)=>{
        if (res) {
            _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .setCart */ .RV)(res));
            const quantityLineItems = res === null || res === void 0 ? void 0 : res.lineItems;
            const payload = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)(quantityLineItems);
            _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .setCartCount */ .oJ)(payload));
        }
    });
};
const checkInactivePromos = async (cb, cb1)=>{
    var ref, ref1;
    const actions = [];
    let actionData;
    const cart = (ref = _store__WEBPACK_IMPORTED_MODULE_1__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_1__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_1__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
    const { discountCodes =[]  } = cart;
    discountCodes.filter((item)=>item.state !== "MatchesCart").map((item)=>{
        var ref;
        actions.push({
            action: "removeDiscountCode",
            discountCode: {
                typeId: "discount-code",
                id: (ref = item.discountCode) === null || ref === void 0 ? void 0 : ref.id
            }
        });
        actionData = [
            ...actions
        ];
    });
    if ((actionData === null || actionData === void 0 ? void 0 : actionData.length) > 0) {
        _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .discount */ .Al)({
            actions: actionData
        })).unwrap().then((res)=>{
            if (res && res.type === "Cart") {
                _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .addToCart */ .Xq)({
                    actions: [
                        {
                            action: "calculateTax"
                        }
                    ]
                })).unwrap().then((resp)=>{
                    if (resp && resp.type === "Cart") {
                        _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .setCart */ .RV)(res));
                        _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .setCartCount */ .oJ)(res.lineItems));
                        createOrder(cb, cb1);
                    }
                });
            }
        });
    } else {
        createOrder(cb, cb1);
    }
    return actionData;
};
const createOrder = async (cb, cb1)=>{
    var ref, ref1;
    const paymentId = (ref = _store__WEBPACK_IMPORTED_MODULE_1__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.paymentId;
    const { general: { siteName ="" , orderConfirmPath ="/" , homepageUrl ="/"  } = {}  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .i)();
    const orderConfirmUrl = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getShortenedUrl */ .Ppy)(orderConfirmPath);
    const homePagePath = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getShortenedUrl */ .Ppy)(homepageUrl);
    const { IGLOO: { getBlackbox  } = {}  } = window || {};
    const { blackbox , finished  } = (getBlackbox === null || getBlackbox === void 0 ? void 0 : getBlackbox()) || {};
    const payload = {
        paymentId: paymentId,
        orderSource: siteName
    };
    if (finished) {
        payload.deviceId = encodeURIComponent(blackbox !== null && blackbox !== void 0 ? blackbox : "");
    }
    _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .orderSubmit */ .aN)(payload)).unwrap().then((res)=>{
        const { parentOrder: { orderNumber ="" , customerEmail: email = ""  }  } = res;
        if (res) {
            const base64Str = Buffer.from(email).toString("base64");
            const redirectionLink = "".concat(orderConfirmUrl, "?orderNumber=").concat(orderNumber).concat("&q=".concat(base64Str));
            cb1 && cb1(redirectionLink);
            window.history.replaceState(null, null, homePagePath);
            window.location.href = redirectionLink;
        } else {
            cb && cb(false) // enable Place Order CTA on failure
            ;
        }
        _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentFailedAction */ .RM)(false));
    }).catch((error)=>{
        const { error: errorMsg , errorCode , paymentCompleted =false  } = error;
        if (paymentCompleted) {
            _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_3__/* .showToast */ .CF)({
                message: _constants___WEBPACK_IMPORTED_MODULE_7__.GENERIC_ERROR_MESSAGE,
                isVisible: true
            }));
        } else if (errorMsg === "Declined") {
            (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .deleteFromCart */ .EI)();
            window.location.href = _constants_routes__WEBPACK_IMPORTED_MODULE_6__/* .FRAUD_DECLINED_MESSAGE_ENDPOINT */ .Ht;
        } else {
            _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .getCart */ .dv)()).unwrap().then(async ()=>{
                _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentFailedAction */ .RM)(true));
                await refreshCart();
                const { generic: { aciPaymentErrorMessagesPath =""  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_1__/* .store.getState */ .h.getState();
                try {
                    const { data  } = await _constants_api__WEBPACK_IMPORTED_MODULE_8__/* .aemAxiosInstance.get */ .Gb.get(_constants___WEBPACK_IMPORTED_MODULE_7__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + aciPaymentErrorMessagesPath);
                    const { value: errorMsg  } = data.find((e)=>e.text === errorCode);
                    _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_3__/* .showToast */ .CF)({
                        message: errorMsg ? errorMsg : _constants___WEBPACK_IMPORTED_MODULE_7__.GENERIC_ERROR_MESSAGE,
                        isVisible: true
                    }));
                } catch (e) {
                    _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_3__/* .showToast */ .CF)({
                        message: _constants___WEBPACK_IMPORTED_MODULE_7__.GENERIC_ERROR_MESSAGE,
                        isVisible: true
                    }));
                }
            });
            cb && cb(false);
        }
    });
};
const getEventInfo = (type, link, needJson)=>{
    const eventInfo = {
        eventAction: "checkout:review:" + type,
        eventName: "checkout:review:" + type,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type,
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkZoneName: "checkout:review",
        internalLinkURL: link ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true"
    };
    if (needJson) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const getShippingAddressFormated = (data)=>{
    const { city ="" , country ="" , email ="" , firstName ="" , lastName ="" , phone ="" , postalCode ="" , state ="" , streetName ="" , streetNumber ="" , id =""  } = data;
    return {
        fname: {
            value: firstName,
            error: false,
            message: ""
        },
        lname: {
            value: lastName,
            error: false,
            message: ""
        },
        email: {
            value: email,
            error: false,
            message: ""
        },
        phone: {
            value: phone,
            error: false,
            message: ""
        },
        address1: {
            value: streetName,
            error: false,
            message: ""
        },
        address2: streetNumber,
        city: {
            value: city,
            error: false,
            message: ""
        },
        state: {
            value: state,
            error: false,
            message: ""
        },
        zipcode: {
            value: postalCode,
            error: false,
            message: ""
        },
        country: {
            value: country,
            error: false,
            message: ""
        },
        notes: "",
        label: {
            show: true,
            value: ""
        },
        id: id
    };
};


/***/ }),

/***/ 46760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47956);





const NextHead = (props)=>{
    var ref, ref1;
    const { title ="" , description ="" , templateName ="" , fullUrl ="" , psKey ="" , psCountry ="" , psLanguage ="" , pageUrl ="" , metaLanguage ="" , pdpData: { ProductBrandName_s: productName = "" , productName_s: partsName = "" , // ProductDescriptionProductShort_s: productDescription = "",
    "Color.SKU.Details_ss": skuDetails = [] , productIsInStock_b: available = true , masterVariantDataResponse: variants = [] , productName_s: productFullName = "" , metaDescription_s: productMetaDescription = ""  } = {} , pdpData ={} , initialImageFullUrl ="" , isPart =false , skuId ="" , siteName ="" , isBundleProduct =false , currencyCode ="USD" , persona ="GST"  } = props;
    var ref2;
    const selectedSkuDetails = (ref2 = skuDetails === null || skuDetails === void 0 ? void 0 : skuDetails.find((item)=>item.includes(skuId))) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    const selectSkuList = (ref3 = selectedSkuDetails === null || selectedSkuDetails === void 0 ? void 0 : selectedSkuDetails.split("|")) !== null && ref3 !== void 0 ? ref3 : [];
    var ref4;
    const selectedSku = (ref4 = selectSkuList[selectSkuList.length - 1]) !== null && ref4 !== void 0 ? ref4 : "";
    const [masterVariant, setMasterVariant] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [otherVariants, setOtherVariants] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    let showroomAddress = "";
    let breadCrumb = [];
    extractTeaserDescriptions(props);
    extractBreadCrumb(props);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (variants.length > 0) {
            const masterVariant = variants.filter((variant)=>variant.masterVariant_b);
            const otherVariant = variants.filter((variant)=>!variant.masterVariant_b);
            setMasterVariant(masterVariant);
            setOtherVariants(otherVariant);
        }
    }, [
        variants
    ]);
    // Recursive extractor for Find a showroom
    function extractTeaserDescriptions(data) {
        if (fullUrl.includes("/find-a-showroom/")) {
            if (Array.isArray(data)) {
                data.forEach((item)=>extractTeaserDescriptions(item));
            } else if (typeof data === "object" && data !== null) {
                if (data[":type"] === "annsacks/components/teaser_v2" && data.description) {
                    if (data.description.includes("tel:")) {
                        showroomAddress = data.description;
                        return;
                    }
                } else {
                    const itemsOrder = data[":itemsOrder"];
                    return itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.map((itemOrder, idx)=>{
                        const items = data[":items"][itemOrder];
                        if (showroomAddress === "") extractTeaserDescriptions(items);
                        else return;
                    });
                }
            }
        }
    }
    // Recursive extractor
    function extractBreadCrumb(data) {
        if (Array.isArray(data)) {
            data.forEach((item)=>extractBreadCrumb(item, results));
        } else if (typeof data === "object" && data !== null) {
            if (data[":type"] === "kf/components/breadcrumb/v1/breadcrumb" && Array.isArray(data["items"])) {
                breadCrumb = data["items"];
                return;
            } else {
                const itemsOrder = data[":itemsOrder"];
                return itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.map((itemOrder, idx)=>{
                    const items = data[":items"][itemOrder];
                    if (breadCrumb.length === 0) extractBreadCrumb(items);
                    else return;
                });
            }
        }
    }
    const getVariantImage = (variantImages, tmpSkuId)=>{
        let initialImgUrl = "";
        let initialImageFullUrl = "";
        let variantImageLabels = [];
        let variantImageURLs = [];
        if (variantImages === null || variantImages === void 0 ? void 0 : variantImages.length) {
            const selVarImageUrls = [];
            const selVarImageLabels = [];
            variantImages.forEach((img)=>{
                const imgDetail = img.split("|");
                if (tmpSkuId === imgDetail[0]) {
                    var ref;
                    selVarImageLabels.push((ref = imgDetail[4]) !== null && ref !== void 0 ? ref : "");
                    selVarImageUrls.push(imgDetail[imgDetail.length - 1] ? imgDetail[imgDetail.length - 1] : _constants__WEBPACK_IMPORTED_MODULE_4__.EMPTY_PIXEL);
                } else if (!variants.find((v)=>v === imgDetail[0])) {
                    var ref1;
                    variantImageLabels.push((ref1 = imgDetail[4]) !== null && ref1 !== void 0 ? ref1 : "");
                    variantImageURLs.push(imgDetail[imgDetail.length - 1] ? imgDetail[imgDetail.length - 1] : _constants__WEBPACK_IMPORTED_MODULE_4__.EMPTY_PIXEL);
                }
            });
            variantImageLabels = [
                ...selVarImageLabels,
                ...variantImageLabels
            ];
            variantImageURLs = [
                ...selVarImageUrls,
                ...variantImageURLs
            ];
            if (variantImageURLs.length < 1) {
                variantImageLabels.push(tmpSkuId);
                variantImageURLs.push(_constants__WEBPACK_IMPORTED_MODULE_4__.EMPTY_PIXEL);
            }
        } else {
            variantImageLabels.push(tmpSkuId);
            variantImageURLs.push(_constants__WEBPACK_IMPORTED_MODULE_4__.EMPTY_PIXEL);
        }
        const assetIdArray = variantImageURLs ? variantImageURLs[0].split("PAWEB/") : [
            ""
        ];
        initialImgUrl = assetIdArray.length > 1 ? assetIdArray[1] : "";
        var ref;
        initialImageFullUrl = (ref = variantImageURLs.find((image)=>image.includes(initialImgUrl))) !== null && ref !== void 0 ? ref : "";
        return initialImageFullUrl;
    };
    const getVariantsSchema = ()=>{
        let variantsSchema = [];
        if (otherVariants.length > 0) {
            variantsSchema = variants.map((variant)=>{
                var ref;
                const skuId = (ref = variant === null || variant === void 0 ? void 0 : variant.sku_s) !== null && ref !== void 0 ? ref : "";
                var ref1;
                const selectedSkuDetails = (ref1 = skuDetails === null || skuDetails === void 0 ? void 0 : skuDetails.find((item)=>item.includes(skuId))) !== null && ref1 !== void 0 ? ref1 : "";
                var ref2;
                const selectSkuList = (ref2 = selectedSkuDetails === null || selectedSkuDetails === void 0 ? void 0 : selectedSkuDetails.split("|")) !== null && ref2 !== void 0 ? ref2 : [];
                var ref3;
                const selectedSku = (ref3 = selectSkuList[selectSkuList.length - 1]) !== null && ref3 !== void 0 ? ref3 : "";
                var ref4, ref5, ref6, ref7, ref8, ref9;
                return {
                    "@type": "Product",
                    sku: selectedSku,
                    gtin: (ref4 = variant === null || variant === void 0 ? void 0 : variant.SKUUPCCode_s) !== null && ref4 !== void 0 ? ref4 : "",
                    image: getVariantImage(variant["productImages.labelWithUrl_ss"], variant.sku_s),
                    name: (ref5 = variant === null || variant === void 0 ? void 0 : variant.productName_s) !== null && ref5 !== void 0 ? ref5 : "",
                    description: (ref6 = variant === null || variant === void 0 ? void 0 : variant.metaDescription_s) !== null && ref6 !== void 0 ? ref6 : "",
                    color: (ref7 = variant === null || variant === void 0 ? void 0 : variant.ColorFinish_s) !== null && ref7 !== void 0 ? ref7 : "",
                    offers: {
                        "@type": "Offer",
                        url: "".concat(fullUrl, "?skuId=").concat((ref8 = variant === null || variant === void 0 ? void 0 : variant.sku_s) !== null && ref8 !== void 0 ? ref8 : ""),
                        priceCurrency: currencyCode || "USD",
                        price: (ref9 = variant === null || variant === void 0 ? void 0 : variant["priceList.".concat(persona, ".finalPrice_d")]) !== null && ref9 !== void 0 ? ref9 : 0,
                        itemCondition: "https://schema.org/NewCondition",
                        availability: variant.productIsInStock_b ? "https://schema.org/InStock" : "https://schema.org/OutOfStock"
                    }
                };
            });
        }
        return variantsSchema;
    };
    var ref5, ref6, ref7;
    const productSchema = otherVariants.length > 0 ? [
        {
            "@context": "https://schema.org",
            "@type": "ProductGroup",
            "@id": fullUrl,
            url: fullUrl,
            additionalType: isPart ? "Service Part" : "",
            name: isPart ? partsName : isBundleProduct ? partsName : productFullName,
            image: initialImageFullUrl,
            description: isBundleProduct ? partsName : productMetaDescription,
            sku: isBundleProduct ? skuId : selectedSku || skuId,
            gtin: (ref5 = masterVariant === null || masterVariant === void 0 ? void 0 : (ref = masterVariant[0]) === null || ref === void 0 ? void 0 : ref.SKUUPCCode_s) !== null && ref5 !== void 0 ? ref5 : "",
            brand: {
                "@type": "Brand",
                name: siteName
            },
            productGroupID: isBundleProduct ? skuId : selectedSku,
            variesBy: [
                "https://schema.org/color"
            ],
            hasVariant: getVariantsSchema()
        }
    ] : {
        "@context": "https://schema.org",
        "@type": "Product",
        "@id": fullUrl,
        url: fullUrl,
        additionalType: isPart ? "Service Part" : "",
        name: isPart ? partsName : isBundleProduct ? partsName : productFullName,
        image: initialImageFullUrl,
        description: isBundleProduct ? partsName : productMetaDescription,
        sku: isBundleProduct ? skuId : selectedSku || skuId,
        gtin: (ref6 = masterVariant === null || masterVariant === void 0 ? void 0 : (ref1 = masterVariant[0]) === null || ref1 === void 0 ? void 0 : ref1.SKUUPCCode_s) !== null && ref6 !== void 0 ? ref6 : "",
        priceCurrency: currencyCode || "USD",
        brand: {
            "@type": "Brand",
            name: siteName
        },
        offers: {
            "@type": "Offer",
            price: (ref7 = pdpData === null || pdpData === void 0 ? void 0 : pdpData["priceList.".concat(persona || "GST", ".finalPrice_d")]) !== null && ref7 !== void 0 ? ref7 : 0,
            priceCurrency: currencyCode || "USD",
            availability: available ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
            itemCondition: "http://schema.org/NewCondition"
        },
        hasVariant: getVariantsSchema()
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: "Kohler US Plumbing Bathroom Kitchen"
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: description
                    })
                ]
            }),
            pageUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: pageUrl
            }) : null,
            templateName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: templateName
            }) : null,
            metaLanguage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: metaLanguage === null || metaLanguage === void 0 ? void 0 : metaLanguage.toLocaleLowerCase()
            }) : null,
            fullUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: fullUrl
            }) : null,
            psKey ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "ps-key",
                content: psKey
            }) : null,
            psCountry ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "ps-country",
                content: psCountry
            }) : null,
            psLanguage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "ps-language",
                content: psLanguage
            }) : null,
            productName || partsName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3___default().sanitize(JSON.stringify(productSchema))
                }
            }, "structured-data") : null,
            showroomAddress.includes("tel:") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/showroom+json",
                dangerouslySetInnerHTML: {
                    __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3___default().sanitize(JSON.stringify({
                        description: showroomAddress,
                        name: title
                    }))
                }
            }, "structured-data-showroom") : null,
            (breadCrumb === null || breadCrumb === void 0 ? void 0 : breadCrumb.length) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/breadcrumb+json",
                dangerouslySetInnerHTML: {
                    __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3___default().sanitize(JSON.stringify(breadCrumb))
                }
            }, "structured-data-breadcrumb") : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NextHead);


/***/ }),

/***/ 93720:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"membershipStyleWrapper":"v1_membershipStyleWrapper__gbvj7"};

/***/ }),

/***/ 5693:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"findStoreLandingWrapper":"FindStoreLanding_View_findStoreLandingWrapper__evwSr"};

/***/ }),

/***/ 77781:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"friendsAndFamilyStyleWrapper":"FriendsAndFamilyView_friendsAndFamilyStyleWrapper__UVbF_"};

/***/ }),

/***/ 56426:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"installServiceWrapper":"v1_installServiceWrapper__ELrqA"};

/***/ }),

/***/ 42472:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"keySpecifierStyleWrapper":"v1_keySpecifierStyleWrapper__0B0TO"};

/***/ }),

/***/ 9942:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"literatureWrapper":"Literature_view_literatureWrapper__7Z8yv"};

/***/ }),

/***/ 87410:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"technicalSpecsWrapper":"v1_technicalSpecsWrapper__qwHAk"};

/***/ }),

/***/ 18928:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageTitleWrapper":"PageTitle_pageTitleWrapper__wiDOk"};

/***/ })

}]);